<template>
  <div class="details-view">
    <cargo-left-right-resize
      v-show="Boolean(action)"
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'||(isEditing&&activeTabName==='tabCharges'&&basicInfoVisible)"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          v-show="action==='look'"
          :grid-options="gridOptions"
          :row-data="rowData"
          :show-side-bar="false"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          min-height="100%"
          class="section"
          grid-style="min-width: 220px;width:100%;height:100%;"
          @gridReady="onGridReady"
        />
        <cargo-ag-grid
          v-if="isEditing&&activeTabName==='tabCharges'&&basicInfoVisible"
          :grid-options="basicInfo.gridOptions"
          :row-data="basicInfo.rowData"
          :show-side-bar="false"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          min-height="100%"
          class="section"
          grid-style="min-width: 220px;width:100%;height:100%;"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider ref="cargoButtonGroupSlider">
                <div v-show="action==='look'" :class="'btn-group-look' + (canOperateJob ? '' : ' cannot-operate-job')">
                  <el-button v-if="!isXhqAdd" no="back" type="primary" class="can-operate" @click="goBack">{{ openMultiple ? $t('SeaExport.Close') : $t('common.btn.back') }}</el-button>
                  <el-button no="edit" :disabled="!(job && Number(job.jobState) === 0 && !JobUtils.isBlockJob(job))" type="success" @click="triggerEditEvent">{{ $t('common.btn.edit') }}</el-button>
                  <el-button v-show="$checkPermission(['button_SEBooking_addSEBooking'])" no="new" :disabled="hqDisabledOperate" type="primary" class="can-operate" @click="triggerAddEvent()">{{ $t('common.btn.new') }}</el-button>
                  <el-button
                    v-show="$checkPermission(['button_SEBooking_addLCL'])"
                    no="AddHbl"
                    :disabled="hqDisabledOperate"
                    type="primary"
                    class="can-operate"
                    @click="triggerAddEvent(true)"
                  >{{ $t('SeaExport.AddHbl') }}</el-button>

                  <el-button
                    v-show="$checkPermission(['button_SEBooking_addSEBooking'])"
                    no="Copy"
                    type="primary"
                    @click="toCopy"
                  >{{ $t('SeaExport.Copy') }}</el-button>

                  <el-button
                    v-show="$checkPermission(['button_SEBooking_addSEBooking']) && showImportOrder"
                    no="copyFromJob"
                    type="primary"
                    @click="importOrder"
                  >{{ $t('SeaExport.ImportOrder') }}</el-button>

                  <el-button
                    v-show="$checkPermission(['button_JobBooking_ReturnReview']) && showReturnReview"
                    no="returnReview"
                    type="primary"
                    @click="returnReview"
                  >{{ $t('CargoMsg.Cargo_ReturnPreApprovalRemoteBooking') }}</el-button>

                  <el-button
                    v-if="job.shutOut?btnInfo.privilege.button_SEBooking_cancelShutout:btnInfo.privilege.button_SEBooking_Shutout"
                    no="shutOutLabel"
                    type="primary"
                    :disabled="!(job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.SHUT_OUT) || isCooperate"
                    @click="toShutOut"
                  >{{ btnInfo.label.shutOutLabel }}</el-button>

                  <template>
                    <!-- 客户门点打印 -->
                    <el-dropdown
                      v-if="activeTabName === 'tabTruckingForSe'"
                      no="truckingPrint"
                      split-button
                      type="success"
                      style="margin-left: 5px;"
                      @click="onPrint('')"
                      @command="onPrint"
                    >
                      {{ $t('SeaExport.print') }}
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="PrintByFleet">{{ $t('SeaExport.PrintByFleet') }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!-- 其他打印 -->
                    <el-button v-else no="print" :disabled="enablePrint" type="success" @click="onPrint('')">{{ $t('SeaExport.print') }}</el-button>
                  </template>

                  <el-button
                    v-show="btnInfo.visible.printFclProfit"
                    no="PrintFclProfit"
                    type="primary"
                    @click="printFCLPROFIT"
                  >{{ $t('SeaExport.PrintFclProfit') }}</el-button>

                  <el-button
                    v-show="btnInfo.visible.printLclProfit"
                    no="PrintLclProfit"
                    type="primary"
                    @click="printLCLPROFIT"
                  >{{ $t('SeaExport.PrintLclProfit') }}</el-button>

                  <el-button
                    v-show="!btnInfo.visible.printReturn && job.jobState === SystemConstants.OPERATING && btnInfo.privilege.button_JobBooking_PreSubmit && job.manageAuditStatus !== 1"
                    no="PreSubmission"
                    type="primary"
                    :disabled="isCooperate"
                    @click="doSubmitPrint_PreSubmit"
                  >{{ $t('SeaExport.PreSubmission') }}</el-button>
                  <!--提交-->
                  <el-button
                    v-show="!btnInfo.visible.printReturn && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.COMMITED || job.jobState === SystemConstants.PRE_COMMIT) && btnInfo.privilege.button_JobBooking_Submit && parseInt(job.manageAuditStatus) !== 1"
                    no="Submission"
                    type="primary"
                    :disabled="isCooperate"
                    @click="doSubmitPrint_Submit"
                  >{{ $t('SeaExport.Submission') }}</el-button>
                  <!--主管提交-->
                  <el-button
                    v-show="!btnInfo.visible.printReturn && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.COMMITED || job.jobState === SystemConstants.PRE_COMMIT) && btnInfo.privilege.button_JobBooking_ManagerSubmit"
                    no="ManagerSubmission"
                    type="primary"
                    class="can-operate"
                    :disabled="isCooperate"
                    @click="doSubmitPrint_ManagerSubmit"
                  >{{ $t('SeaExport.ManagerSubmission') }}</el-button>
                  <!--港前、尾程 审核-->
                  <el-button
                    v-if="isHc && job.prePortPlanner > 0 && job.prePortApproveStatus === SystemConstants.PRICE_STATE_REVIEW.code && ($store.getters.isAdmin || $store.getters.userId === job.prePortPlanner)"
                    no="showPrePortAuditBtn"
                    type="primary"
                    @click="p=>{priceAuditCommand=$t('CargoMsg.Cargo_preportAudit');priceAuditHandle()}"
                  >{{ $t('CargoMsg.Cargo_preportAudit') }}</el-button>
                  <el-button
                    v-if="isHc && job.prePortPlanner > 0 && job.lastMileApproveStatus === SystemConstants.PRICE_STATE_REVIEW.code && ($store.getters.isAdmin || $store.getters.userId === job.lastMilePlanner)"
                    no="showLastMileAuditBtn"
                    type="primary"
                    @click="p=>{priceAuditCommand=$t('CargoMsg.Cargo_TailEndAudit');priceAuditHandle()}"
                  >{{ $t('CargoMsg.Cargo_TailEndAudit') }}</el-button>
                  <!--审核-->
                  <el-button
                    v-show="!btnInfo.visible.printReturn && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && btnInfo.privilege.button_JobBooking_ManagerAuditSubmit && parseInt(job.manageAuditStatus) === 1"
                    no="Audit"
                    type="primary"
                    :disabled="isCooperate"
                    @click="doSubmitAudit_ManagerSubmit"
                  >{{ $t('SeaExport.Audit') }}</el-button>
                  <!--退回操作-->
                  <el-button
                    v-show="job.jobState === SystemConstants.PRE_COMMIT && $checkPermission(['button_JobBooking_ReturnToOperater'])"
                    no="ReturnAction"
                    type="primary"
                    :disabled="isCooperate"
                    @click="backReturn"
                  >{{ $t('SeaExport.ReturnAction') }}</el-button>
                  <!--撤回-->
                  <el-button
                    v-show="btnInfo.visible.cancelReturn"
                    no="PrintReturn"
                    type="primary"
                    class="can-operate"
                    :disabled="isCooperate || controlledLocked"
                    @click="backReturn"
                  >{{ $t('SeaExport.PrintReturn') }}</el-button>
                  <!--协作-->
                  <el-button v-show="useOrderCenterMode && !masterFlag && (!orderCenterBranch || (orderCenterBranch && useOrderCenterBranch)) && !isRegionalCommission" no="bntCooperation" type="primary" @click="cooperationHandler">{{ $t('CargoMsg.Cargo_Cooperation') }}</el-button>
                  <!--退回-->
                  <el-button v-show="useOrderCenterMode && !masterFlag && !orderCenterBranch" no="bntCooperationReturn" type="primary" @click="cooperationReturnHandler">{{ $t('CargoMsg.Cargo_CooperationReturn') }}</el-button>
                  <!--委托/关联业务信息-->
                  <el-button
                    no="btnEntrustment"
                    type="primary"
                    :class="btnInfo.label.btnEntrustment === $t('SeaExport.AssociationBusinessInformation') ? 'can-operate' : ''"
                    :disabled="!((btnInfo.privilege.consignationEnable && $store.getters.isGroupCompany) || btnInfo.privilege.consignationCrossEnable)"
                    @click="entrustmentClickHandlerPre"
                  >{{ btnInfo.label.btnEntrustment }}</el-button>

                  <!--出口转进口-->
                  <el-button
                    v-show="isShowExportToImport && isShowExportToImportCommon && !isRegionalCommission"
                    no="btnEntrustmentSI"
                    type="primary"
                    :class="btnInfo.label.btnEntrustmentSI === $t('SeaExport.AssociationBusinessInformationSI') ? 'can-operate' : ''"
                    :disabled="!((btnInfo.privilege.consignationEnableSI && $store.getters.isGroupCompany))"
                    @click="entrustmentSIClickHandler"
                  >{{ btnInfo.label.btnEntrustmentSI }}</el-button>

                  <!-- 同步信息-出口同步到进口【租户内 跨租户公用】 -->
                  <el-button
                    v-show="job.relatedJob && ((btnInfo.label.btnEntrustmentSI === $t('SeaExport.AssociationBusinessInformationSI') && job.relatedJobLob && job.relatedJobLob === 'SI') || isCrossTenantSEToSIStatus)"
                    no="16"
                    :disabled="job.jobState !== SystemConstants.STATE_OPERATING.code"
                    type="primary"
                    @click="syncRelatedJob"
                  >{{ $t('SeaExport.SynchronizationInformation') }}</el-button>

                  <!--提交改单费用-->
                  <el-button
                    v-show="job.jobState === SystemConstants.VERIFIED && job.changeState === SystemConstants.VERIFIED && $checkPermission(['button_JobBooking_ChangeCommit']) && Number(config.get('IsCommittedAllowAddCost')) === 1"
                    no="ChangeCommit"
                    type="primary"
                    @click="changeCommit_clickHandler"
                  >{{ $t('SeaExport.ChangeCommit') }}</el-button>

                  <el-button
                    v-show="btnInfo.visible.sendBackBookingButton && $checkPermission(['button_SEBooking_sendBackBooking'])"
                    no="SendBookingData"
                    type="primary"
                    @click="sendBookingData"
                  >{{ $t('SeaExport.SendBookingData') }}</el-button>
                  <!-- 指令操作按钮 -->
                  <el-dropdown
                    v-if="instructioinBtns.length > 0"
                    split-button
                    type="primary"
                    style="margin-left: 5px"
                    @command="onInstructioinCommand"
                  >
                    {{ $t('queryJob.BusinessOperationInstruction') }}
                    <el-dropdown-menu slot="dropdown">
                      <template v-for="(item, index) in instructioinBtns">
                        <el-dropdown-item
                          :key="index"
                          :disabled="!item.allowOperate"
                          :command="item.tenantInstructionUuid"
                        >
                          {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                        </el-dropdown-item>
                      </template>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-badge :is-dot="crossTenantDialog.readState" class="item">
                    <el-dropdown
                      split-button
                      type="primary"
                      class="can-operate"
                      style="margin-left: 5px"
                      @click="logHandle()"
                      @command="p=>{logCommand=p;logHandle()}"
                    >{{ $t('CargoMsg.Cargo_LogRecord') }}
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="$t('SeaExport.DataPushChangeLog')">{{ $t('SeaExport.DataPushChangeLog') }}</el-dropdown-item>
                        <el-dropdown-item :command="$t('CargoMsg.Cargo_BusinessStatusChangeLog')">{{ $t('CargoMsg.Cargo_BusinessStatusChangeLog') }}</el-dropdown-item>
                        <el-dropdown-item :command="$t('SeaExport.EdiStatusChangeLog')">{{ $t('SeaExport.EdiStatusChangeLog') }}</el-dropdown-item>
                        <el-dropdown-item :command="$t('SeaExport.BookingReceiptLog')">{{ $t('SeaExport.BookingReceiptLog') }}</el-dropdown-item>
                        <el-dropdown-item v-show="toExoSystemOC || toExoSystemEAS" :command="$t('CargoMsg.Cargo_PushResultLog')">{{ $t('CargoMsg.Cargo_PushResultLog') }}</el-dropdown-item>
                        <el-badge :is-dot="crossTenantDialog.readState" class="item">
                          <el-dropdown-item :disabled="!job.relatedJob" :command="$t('SeaExport.ChangeHistory')">{{ $t('SeaExport.ChangeHistory') }}</el-dropdown-item>
                        </el-badge>
                        <el-dropdown-item :command="$t('SeaExport.OperationLog')">{{ $t('SeaExport.OperationLog') }}</el-dropdown-item>
                        <el-dropdown-item v-show="jingyuWarehouse" :command="$t('SeaExport.JyWarehouseApiLog')">{{ $t('SeaExport.JyWarehouseApiLog') }}</el-dropdown-item>
                        <el-dropdown-item v-show="toExoSystemJYD" :command="$t('SystemMaintenance.MsdApiLog')">{{ $t('SystemMaintenance.MsdApiLog') }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-badge>
                  <!-- 申请解锁（费用解锁线上审批） -->
                  <el-button
                    v-show="$checkPermission(['button_ledger'])"
                    no="unlockApply"
                    type="primary"
                    style="margin-left: 5px"
                    @click="toUnlockApply"
                  >{{ $t('SeaExport.UnlockApplyBtn') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <!-- todo v-show="!$checkPermission(['role_ElectricBusiness']) && !$store.getters.isAdmin"-->
                  <el-button no="save" type="success" :disabled="!canSave||isLoadingData" @click="triggerSaveEvent">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="cancel" type="success" :disabled="!canSave" @click="cancelEdit(openMultiple?againLookAtMultiple:()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="isNew" class="new btn-group-new" style="border-left:none;padding-left:0">
                  <el-button no="save2" type="success" :disabled="!canSave||isLoadingData" @click="triggerSaveEvent">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="cancel2" type="success" :disabled="!canSave" @click="cancelEdit(openMultiple?goBackAtMultiple:goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues2" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'||action==='edit'" style="display: flex;white-space:nowrap;">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="bottom-start" :offset="sopTooltipOffset" :visible-arrow="false">
                  <div class="right-tip" @mousemove="resetSopTooltip" @dblclick="onBtnListDoubleClicked()">
                    <span no="SopState" class="red" style="font-size:14px;">
                      {{ commonInfo.jobState }}
                      <!-- 「正操作」「预提交」「已提交」「已审核」业务状态存在费用时 进行退关操作后，需要显示为「XXX（有费用退关）」-->
                      <font v-if="(job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut && !commonInfo.jobChangeState" class="red" style="font-size:14px;">({{ $t('Message.HasChargeToShutOut') }})</font>
                      <font v-if="(job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut && commonInfo.jobChangeState" class="red" style="font-size:14px;">({{ $t('Message.HasChargeToShutOut') }}/{{ commonInfo.jobChangeState }})</font>
                      <font v-if="!((job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut) && commonInfo.jobChangeState" class="red" style="font-size:14px;">({{ commonInfo.jobChangeState }})</font>
                      <span v-if="job.payableChargeLockedStatus === 1" class="red" style="margin: 0px 0px 0px 0px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
                    </span>
                    <template>
                      <span v-if="action==='edit'&&activeTabName==='tabCharges'" style="color:unset;" v-html="commonInfo.chargeJobTitle" />
                      <span v-else style="color:unset;" v-html="commonInfo.jobTitle" />
                    </template>
                    <span class="red">{{ commonInfo.jobLock }}</span>
                    <span v-if="commonInfo.provisionLock && commonInfo.provisionLock.etdLocked" style="font-size:14px;color:red;margin-left:10px;">计提已校准</span>
                  </div>
                </el-tooltip>
                <el-tooltip v-if="job.zyCreditWarning" effect="dark" :content="job.zyCreditWarning" placement="bottom-start" :visible-arrow="false">
                  <div class="right-tip">
                    <span style="font-size:12px;color:orange;width:220px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ job.zyCreditWarning }}</span>
                  </div>
                </el-tooltip>
              </div>
              <span v-show="isNew&&activeTabName==='tabCharges'" v-html="commonInfo.chargeJobTitle" />
            </div>
          </div>
          <div ref="tabsContainer" :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')" style="position: relative">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!masterFlag && (privilege.seBooking.bookingTab || isVerify)"
                :key="1"
                :lazy="true"
                name="tabBookingFCL"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-FCLUICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="tabBookingFCL"
                  :is-fba="isFba"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :processing-promise-list="processingPromiseList"
                  :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @showYdBookingResult="showYdBookingResultHandler"
                  @updateJob="updateJob"
                  @showMscSupplement="p => showMscSupplementHandler(p)"
                />
                <tab-booking-fcl
                  v-else
                  ref="tabBookingFCL"
                  :is-fba="isFba"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :processing-promise-list="processingPromiseList"
                  :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
                  :provision-lock="commonInfo.provisionLock"
                  :template-name="templateName"
                  @showYdBookingResult="showYdBookingResultHandler"
                  @updateJob="updateJob"
                  @showMscSupplement="p => showMscSupplementHandler(p)"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && (privilege.seBooking.bookingTab || isVerify) && !isBuyerConsoleFcl"
                :key="2"
                :lazy="true"
                name="tabBookingMaster"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-master-UICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeChange="containerLoadTypeChange"
                  @verticalScroll="onVerticalScroll"
                />
                <tab-booking-master
                  v-else
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeChange="containerLoadTypeChange"
                  @verticalScroll="onVerticalScroll"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && (privilege.seBooking.bookingTab || isVerify) && isBuyerConsoleFcl"
                :key="30"
                :lazy="true"
                name="tabBuyerConsoleFclBookingMaster"
                :label="$t('SeaExport.Basic')"
              >
                <tab-buyer-console-fcl-booking-master-UICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="tabBuyerConsoleFclBookingMaster"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeChange="containerLoadTypeChange"
                  @updateJob="updateJob"
                  @verticalScroll="onVerticalScroll"
                />
                <tab-buyer-console-fcl-booking-master
                  v-else
                  ref="tabBuyerConsoleFclBookingMaster"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeChange="containerLoadTypeChange"
                  @updateJob="updateJob"
                  @verticalScroll="onVerticalScroll"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && (privilege.seBooking.vesselEqTab || privilege.salesQueryModule.vesselEqTab || isVerify)"
                :key="3"
                :lazy="true"
                name="tabVesselEq"
                :label="$t('SeaExport.Booking')"
              >
                <!-- 订舱tab -->
                <tab-vessel-eq-UICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="tabVesselEq"
                  :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditBooking"
                  view-source="bookingWorkspace"
                  :do-saving="doSaving"
                  @ediChangeHandler="saveEventFlag=true"
                  @showYdBookingResult="showYdBookingResultHandler"
                  @reload="reload"
                />
                <tab-vessel-eq
                  v-else
                  ref="tabVesselEq"
                  :slave-customs-declaration-enable="slaveCustomsDeclarationEnable"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditBooking"
                  view-source="bookingWorkspace"
                  :do-saving="doSaving"
                  @ediChangeHandler="saveEventFlag=true"
                  @showYdBookingResult="showYdBookingResultHandler"
                  @reload="reload"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="showMscSupplement"
                key="tabMscBooking"
                :lazy="true"
                name="tabMscBooking"
                :label="$t('CargoMsg.Cargo_MscBookingInfo')"
              >
                <tab-msc-booking-info ref="tabMscBooking" :context="context" :action="action" :param-data="changeDataSFT" />
              </el-tab-pane>
              <!-- 数据追踪 -->
              <el-tab-pane
                v-if="tabInfo.visible.dataTrackingDisplay"
                key="tabDataTracking"
                :lazy="true"
                name="tabDataTracking"
                :label="$t('SeaExport.DataTracking')"
              >
                <tab-data-tracking ref="tabDataTracking" :context="context" :job.sync="job" :action="action" @toPacking="toPacking" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearance"
                :lazy="true"
                name="tabUsCustomsClearance"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance ref="tabUsCustomsClearance" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentSISynchronized" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearanceMaster"
                :lazy="true"
                name="tabUsCustomsClearanceMaster"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance-master ref="tabUsCustomsClearanceMaster" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentSISynchronized" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && (privilege.seBooking.prePlanBooking || isVerify)"
                :key="4"
                :lazy="true"
                name="tabPrePlanBooking"
                :label="$t('SeaExport.prePlanBooking')"
              >
                <tab-pre-plan-booking-jc v-if="commonInfo.showCombinedManifest" ref="tabPrePlanBooking" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" @reload="reload" @prePlanBookingToVgm="prePlanBookingToVgm" @jobChangeState="onJobChangeState" />
                <tab-pre-plan-booking v-else ref="tabPrePlanBooking" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" @reload="reload" @prePlanBookingToVgm="prePlanBookingToVgm" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && (privilege.seBooking.prePlanBooking || isVerify)"
                :key="5"
                :lazy="true"
                name="tabPrePlanBookingLcl"
                :label="$t('SeaExport.prePlanBooking')"
              >
                <tab-pre-plan-booking-jc
                  v-if="commonInfo.showCombinedManifest"
                  ref="tabPrePlanBookingLcl"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  @reload="reload"
                  @prePlanBookingToVgm="prePlanBookingToVgm"
                  @jobChangeState="onJobChangeState"
                />
                <tab-pre-plan-booking-jc
                  v-else
                  ref="tabPrePlanBookingLcl"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  @reload="reload"
                  @prePlanBookingToVgm="prePlanBookingToVgm"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && (masterFlag || paramsOfTab.signMBL) && privilege.seBooking.mbl"
                :key="6"
                :lazy="true"
                name="tabMBL"
                label="MB/L"
              >
                <!-- MB/Ltab -->
                <tab-mbl-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabMBL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="SeBooking" @resetTab="resetTab" @changeDataSFT="changeDataSFTFunc" />
                <tab-mbl v-else ref="tabMBL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="SeBooking" @resetTab="resetTab" @changeDataSFT="changeDataSFTFunc" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.seBooking.mbl2 && (paramsOfTab.typeMBL !== 0 && paramsOfTab.typeMBL !== 1)"
                :key="7"
                :lazy="true"
                name="tabMBL2"
                :label="'MB/L'+(paramsOfTab.typeMBL===2?$t('CargoMsg.Cargo_SplitBL'):'')+(paramsOfTab.typeMBL===3?$t('SeaExport.MergeAndSingle'):'')"
              >
                <tab-mbl2-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabMBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
                <tab-mbl2 v-else ref="tabMBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.signHBL && !paramsOfTab.mblOnly && (!masterFlag || isBuyerConsoleFcl) && privilege.seBooking.hbl"
                :key="8"
                :lazy="true"
                name="tabHBL"
                label="HB/L"
              >
                <tab-hbl-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabHBL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="SeBooking" @resetTab="resetTab" @syncData="syncData" @sinceSingle="sinceSingle" />
                <tab-hbl v-else ref="tabHBL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="SeBooking" @resetTab="resetTab" @syncData="syncData" @sinceSingle="sinceSingle" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !paramsOfTab.mblOnly && !isNew && privilege.seBooking.hbl2 && (paramsOfTab.typeHBL !== 0 && paramsOfTab.typeHBL !== 1)"
                :key="9"
                :lazy="true"
                name="tabHBL2"
                :label="'HB/L'+(paramsOfTab.typeHBL===2?$t('CargoMsg.Cargo_SplitBL'):'')+(paramsOfTab.typeHBL===3?$t('SeaExport.MergeAndSingle'):'')"
              >
                <tab-hbl2-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabHBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
                <tab-hbl2 v-else ref="tabHBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && paramsOfTab.ams && privilege.seBooking.ams"
                :key="10"
                :lazy="true"
                name="tabAMS"
                :label="$t('SeaExport.Anti_terrorismShipping')"
              >
                <!-- 反恐舱单tab -->
                <tab-ams ref="tabAMS" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.virtualHBL && privilege.seBooking.tabSubBill"
                :key="11"
                :lazy="true"
                name="tabSubBill"
                :label="$t('SeaExport.FormalHbl')"
              >
                <tab-sub-bill-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabSubBill" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
                <tab-sub-bill v-else ref="tabSubBill" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && privilege.seBooking.containersLayer"
                :key="12"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <!-- 装箱信息tab -->
                <tab-container ref="tabContainer" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :enable-ui-custom="$store.state.uiCustom.enable && !isFba" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && masterFlag && !isNew && privilege.seBooking.lclManagerLayer && !isBuyerConsoleFcl"
                :key="13"
                :lazy="true"
                name="tabLclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <!-- 装箱信息tab name需要与下面一致-->
                <tab-lcl-container-multi-so-no-mode
                  v-if="masterCustomsDeclarationEnable"
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :location="location"
                  :enable-ui-custom="$store.state.uiCustom.enable && !isFba"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
                <!-- 装箱信息tab -->
                <tab-lcl-container
                  v-else
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :location="location"
                  :enable-ui-custom="$store.state.uiCustom.enable && !isFba"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && masterFlag && !isNew && privilege.seBooking.lclManagerLayer && isBuyerConsoleFcl"
                :key="29"
                :lazy="true"
                name="tabBuyerConsoleFclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <!-- 装箱信息tab -->
                <tab-buyer-console-fcl-container ref="tabBuyerConsoleFclContainer" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :enable-ui-custom="$store.state.uiCustom.enable && !isFba" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.vgm"
                :key="14"
                :lazy="true"
                name="tabVGM"
                label="VGM"
              >
                <!-- VGMtab -->
                <tab-vgm ref="tabVGM" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.backUpWarehouse && privilege.seBooking.backUpWarehouseTab"
                :key="29"
                :lazy="true"
                name="tabBackUpWarehouse"
                :label="$t('SeaExport.BackUpWarehouse')"
              >
                <!-- 前置仓tab -->
                <tab-back-up-warehouse ref="tabBackUpWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.warehousing && privilege.seBooking.warehouseTab"
                :key="15"
                :lazy="true"
                name="tabWarehouse"
                :label="$t('SeaExport.WarehouseLoading')"
              >
                <!-- 仓库内装tab -->
                <tab-warehouse ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && paramsOfTab.warehousing && $checkPermission(['tab_FBABookingNew_fbaSeaWarehouseTab'])" :key="29" :label="$t('SeaExport.DomesticWarehouse')" :lazy="true" name="fbaWarehousingDetail">
                <!-- 国内仓 -->
                <fba-warehousing-detail ref="fbaWarehousingDetail" lob="FBA" :action="action" source="fbaSea" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBABookingNew_fbaSeaoverSeaWarehouseTab'])" :key="30" :label="$t('SeaExport.ForeignWarehouse')" :lazy="true" name="fbaOutWarehouse">
                <!-- 国外仓 -->
                <fba-out-warehouse ref="fbaOutWarehouse" :action="action" :context="context" source="fbaSea" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.landTransportation && privilege.seBooking.seTruckingPage"
                :key="16"
                :lazy="true"
                name="tabTruckingForSe"
                :label="$t('SeaExport.Trucking')"
              >
                <tab-trucking-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabTruckingForSe" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
                <tab-trucking-for-se v-else ref="tabTruckingForSe" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
              </el-tab-pane>
              <!-- 目的港派车tab -->
              <el-tab-pane
                v-if="paramsOfTab.dischargingPortDoor && privilege.seBooking.seDischargingTrukingPage"
                key="tabDischargingTrucking"
                :lazy="true"
                name="tabDischargingTrucking"
                :label="$t('SeaExport.DispatchVehiclesAtDestination')"
              >
                <tab-discharging-trucking-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabDischargingTrucking" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentSISynchronized" :cooperate-edit="cooperateEditOther" />
                <tab-discharging-trucking v-else ref="tabDischargingTrucking" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentSISynchronized" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!-- 目的港清关数据tab -->
              <el-tab-pane
                v-if="paramsOfTab.destPortCustomsClearance && privilege.seBooking.seDischargingTrukingPage"
                key="tabDestinationCustomsData"
                :lazy="true"
                name="tabDestinationCustomsData"
                :label="$t('SeaExport.PortOfDestinationCustomsClearance')"
              >
                <tab-destination-customs-data ref="tabDestinationCustomsData" :context="context" :action="action" :consign-readonly="action === 'look'" :customs-section-readonly="true" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!isFba ? showTabWarehouseIn : (showTabWarehouseIn && masterFlag)"
                :key="17"
                :lazy="true"
                name="tabWarehouseIn"
                :label="$t('SeaExport.CargoInfo')"
              >
                <tab-warehouse-in ref="tabWarehouseIn" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @refreshTabs="refresh" />
              </el-tab-pane>
              <!--!this.tabInfo.visible.oujianCustomsInfo-->
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.customs && privilege.seBooking.seCustomsInfo"
                :key="18"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclaration')"
              >
                <!-- 报关tab -->
                <tab-customs-info-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabCustomsInfo" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
                <tab-customs-info v-else ref="tabCustomsInfo" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
              </el-tab-pane>
              <!--<el-tab-pane-->
              <!--v-if="!(isLclMaster && isNew) && paramsOfTab.customs && privilege.seBooking.seCustomsInfo && this.tabInfo.visible.oujianCustomsInfo"-->
              <!--:key="29"-->
              <!--:lazy="true"-->
              <!--name="tabCustomsInfoOuj"-->
              <!--:label="$t('SeaExport.OuJianDeclaration')"-->
              <!--&gt;-->
              <!--<tab-customs-info-ouj ref="tabCustomsInfoOuj" :context="context" :action="action" />-->
              <!--</el-tab-pane>-->
              <!-- 保险 -->
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.insure"
                :lazy="true"
                name="tabInsure"
                :label="$t('SeaExport.InsureInfo')"
              >
                <tab-insure ref="tabInsure" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.charge.chargeView && !isFba"
                :key="19"
                :lazy="true"
                name="tabTradeDetail"
                :label="$t('SeaExport.TradeDetail')"
              >
                <!-- 货物明细tab -->
                <tab-trade-detail v-if="!commonInfo.poItemsTabViewModel" ref="tabTradeDetail" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :is-uppercase-by-config="isUppercaseByConfig" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
                <!-- 货物明细时贝希使用 -->
                <tab-po-items-upgrade v-if="commonInfo.poItemsTabViewModel" ref="tabTradeDetail" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBABookingNew_fbaSeaGoodsDetailTab'])" :key="31" :label="$t('SeaExport.TradeDetail')" :lazy="true" name="fbaGoodsDetail">
                <!-- fba货物明细 -->
                <tab-warehousing-detail ref="fbaGoodsDetail" :context="context" :action="action" source="fbaSea" :cooperate-edit="cooperateEditOther" :is-uppercase-by-config="isUppercaseByConfig" @reload="reload" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.itmService"
                :key="20"
                :lazy="true"
                name="tabTradeCommission"
                :label="$t('SeaExport.TradeCommission')"
              >
                <!-- 贸易tab -->
                <tab-trade-commission ref="tabTradeCommission" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <template v-if="!(isLclMaster && isNew) && privilege.charge.chargeView">
                <el-tab-pane
                  v-if="!chargePageSet.hideTabCharge"
                  :key="21"
                  :lazy="true"
                  name="tabCharges"
                  :label="$t('SeaExport.Charge')"
                >
                  <!-- 费用tab -->
                  <tab-charges ref="tabCharges" :context="context" :action="action" :is-cross-tenant-se-to-si="isCrossTenantSEToSIStatus" :location="location" view-source="SeBooking" :enable-ui-custom="true" :provision-lock="commonInfo.provisionLock" @ChargeLockStatusChange="chargeLockStatusChange" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="chargePageSet.arAloneShow && privilege.charge.chargeReceivable"
                  key="chargeArTab"
                  :lazy="true"
                  name="tabChargesAr"
                  :label="$t('queryJob.FeeReceivable')"
                >
                  <tab-charges
                    ref="tabChargesAr"
                    :context="context"
                    :action="action"
                    :is-cross-tenant-se-to-si="isCrossTenantSEToSIStatus"
                    :location="location"
                    view-source="SeBooking"
                    tab-name="tabChargesAr"
                    type="ar"
                    :enable-ui-custom="true"
                    :provision-lock="commonInfo.provisionLock"
                    @ChargeLockStatusChange="chargeLockStatusChange"
                  />
                </el-tab-pane>
                <el-tab-pane
                  v-if="chargePageSet.apAloneShow && privilege.charge.chargePayable"
                  key="chargeApTab"
                  :lazy="true"
                  name="tabChargesAp"
                  :label="$t('queryJob.CostsPayable')"
                >
                  <tab-charges
                    ref="tabChargesAp"
                    :context="context"
                    :action="action"
                    :is-cross-tenant-se-to-si="isCrossTenantSEToSIStatus"
                    :location="location"
                    view-source="SeBooking"
                    tab-name="tabChargesAp"
                    type="ap"
                    :enable-ui-custom="true"
                    :provision-lock="commonInfo.provisionLock"
                    @ChargeLockStatusChange="chargeLockStatusChange"
                  />
                </el-tab-pane>
              </template>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="22"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <!-- 国内账单tab -->
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" :location="location" :enable-ui-custom="$store.state.uiCustom.enable && !isFba" :page-type="UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.billTab.billTabView"
                :key="23"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <!-- 国外账单tab -->
                <tab-oversea-bill
                  ref="tabOverseaBill"
                  :context="context"
                  :action="action"
                  :location="location"
                  view-source="SeaBooking"
                  :enable-ui-custom="$store.state.uiCustom.enable && !isFba"
                  :page-type="UICustomConstants.SEA_BOOKING_OVERSEA_BILL"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.charge.advanceCharge"
                :key="24"
                :lazy="true"
                name="tabAdvanceCharge"
                :label="$t('SeaExport.AdvanceChargeInfo')"
              >
                <!-- 代收垫付tab -->
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.seBooking.fileTab"
                :key="25"
                :lazy="true"
                name="tabFile"
                :label="$t('SeaExport.DocumentCirculation')"
              >
                <!-- 单证流转tab -->
                <tab-file ref="tabFile" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && paramsOfTab.cargoType && paramsOfTab.cargoType !== 'GC' && privilege.seBooking.specialGoodsTab"
                :key="26"
                :lazy="true"
                name="tabSpecialGoods"
                :label="$t('SpecialGoods.label')"
              >
                <tab-special-goods-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabSpecialGoods" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
                <tab-special-goods v-else ref="tabSpecialGoods" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.seBooking.portalState && !isNew"
                :key="27"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :is-cross-tenant-se-to-si="isLoadRelatedSop" :cooperate-edit="cooperateEditOther" :controlled-locked="controlledLocked" :sop-template-config="sopTemplateConfig" @refresh="$emit('refreshList', job.jobNo)" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.fileHistory.fileHistoryView"
                :key="28"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history
                  ref="tabFileHistory"
                  :context="context"
                  :btn-info="btnInfo"
                  :is-cross-tenant-se-to-si="isCrossTenantSEToSIStatus"
                  :cooperate-edit="cooperateEditOther"
                  :controlled-locked="controlledLocked"
                  :preview-file-method="p => previewFileMethod(p)"
                  :can-operate-job="canOperateJob"
                  view-source="SeBooking"
                  :show-instruction="true"
                  @writebackJob="writebackJob"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <!-- @updateDocCfmState="updateDocCfmState" -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- @closeCallback="reload"-->
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="hasChargeShutoutHandler()">{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="noHasChargeShutoutHandler()"
        >{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="680px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div :class="{'set-style': item.includes('箱号：'), 'set-mgTop': item.includes('箱号：') && index }">{{ item.includes('箱号：containerNoNull') ? '' : item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 业务状态变更记录弹窗 -->
    <business-status-log-dialog
      :visible.sync="businessStatusDialog.visible"
      :job-uuid="job.uuid || ''"
    />
    <!-- EDI状态变更记录弹窗 -->
    <edi-status-log-dialog v-if="ediStatusLogDialog.visible" :visible.sync="ediStatusLogDialog.visible" :job-uuid="job.uuid || ''" />
    <!-- 订舱回执操作日志弹窗 -->
    <booking-space-log-dialog
      v-if="bookingSpaceLogDialog.visible"
      :visible.sync="bookingSpaceLogDialog.visible"
      :job-uuid="job.uuid || ''"
    />
    <!-- 数据推送结果记录 -->
    <push-result-log-dialog v-if="pushResultLogDialog.visible" :visible.sync="pushResultLogDialog.visible" :job-uuid="job.uuid || ''" />
    <!-- SOP操作状态弹窗 -->
    <sop-state-dialog :hide-window="isEditing" :visible.sync="sopStateDialog.visible" :is-need-refresh.sync:="sopStateDialog.isNeedRefresh" :default-is-expand="sopStateDialog.defaultIsExpand" :job="job" :is-need-expand.sync="sopStateDialog.isNeedExpand" @handleClose="sopStateDialogClose" />
    <!-- 发送分公司/tenant内部委托 -->
    <template v-if="sendBranchWindow.visible">
      <el-dialog
        v-if="sendBranchSelectObject === 2"
        v-el-drag-dialog
        :visible.sync="sendBranchWindow.visible"
        :title="$t('SeaExport.ConsignationSI')"
        width="550px"
        :close-on-click-modal="false"
      >
        <el-form label-width="96px" label-position="right">
          <el-form-item label-width="0">
            <span style="color: #000000;font-size: 14px;">{{ $t('CargoMsg.Cargo_EntrustedReceiveInfo') }}</span>
          </el-form-item>
          <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('SeaExport.CustomerService') : $t('SeaExport.Operation')">
            <cargo-user-select
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
              style="width: 200px"
              @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
            />
          </el-form-item>
          <!--自定义业务类型（同租户 且 出口转进口 场景）-->
          <el-form-item v-if="enableEntrustmentSI" :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :method-params="{type:'SI', grade: 0, active: true}"
              :tag-name="isZh?'name':'englishName'"
              style="width: 200px"
              @parentCallBack="p=>{sendBranchWindow.customJobType=p.value}"
            />
          </el-form-item>
        </el-form>
        <el-form label-width="40px" :inline="true" label-position="right">
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ $store.getters.currentOffice.chineseName }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ sendBranchWindow.title }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consignee" disabled style="width: 200px">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeTarget" style="width: 200px" @change="onConsigneeTargetChange">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
              <el-option :label="$t('SeaExport.ConsignationCompany')" value="customer" />
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consigneeDetail" disabled style="width: 200px">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeDetailTarget" style="width: 200px" @change="onConsigneeDetailTargetChange">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
              <el-option :label="$t('SeaExport.ShipperDetail')" value="shipperDetail" />
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-top: 20px;margin-left:40px">{{ $t('queryJob.NoteConsigneeCustomerExportImport') }}</div>
        <div slot="footer" style="display: flex;justify-content: space-between;">
          <el-checkbox v-model="sendBranchWindow.checkConsigneeDefault" style="color: #000000" @change="onCheckConsigneeDefaultChange">{{ $t('queryJob.SetAsDefaultExportInfo') }}</el-checkbox>
          <div>
            <el-button type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
            <el-button @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        v-else
        v-el-drag-dialog
        :visible.sync="sendBranchWindow.visible"
        :title="sendBranchWindow.title"
        width="360px"
        :close-on-click-modal="false"
      >
        <el-form label-width="96px" label-position="right">
          <el-form-item
            v-for="(item, index) in sendBranchWindow.items"
            :key="index"
            :label="item.selectObject === 0 ? $t('SeaExport.CustomerService') : (item.selectObject === 1 ? $t('SeaExport.Operation') : $t('SeaExport.Planner'))"
          >
            <cargo-user-select
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : (item.selectObject === 1 ? 'op' : 'sealine')}"
              @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
            />
          </el-form-item>
          <!--自定义业务类型（同租户 且 出口转进口 场景）（判断enableEntrustmentSI区分出【出口转进口】即可，无需区分【同租户】，因为只有【同租户】才会使用该弹窗）-->
          <el-form-item v-if="enableEntrustmentSI" :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :method-params="{type:'SI', grade: 0, active: true}"
              :tag-name="isZh?'name':'englishName'"
              @parentCallBack="p=>{sendBranchWindow.customJobType=p.value}"
            />
          </el-form-item>
          <el-form-item v-if="showdCheckSalesMapping" :label="$t('queryJob.SalesMapping')">
            <el-checkbox v-model="sendBranchWindow.checkSalesMapping" no="checkSalesMapping">{{ $t('queryJob.SalesCargoSalesMap') }}</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
    </template>
    <!--关联业务信息-->
    <trust-from-window
      v-if="trustFromWindow.visible"
      ref="trustFromWindow"
      :visible.sync="trustFromWindow.visible"
      :trust-job="trustFromWindow.trustJob"
      :job="trustFromWindow.job"
      :context="context"
      :can-operate-job="canOperateJob"
      @refresh="applyCloseAndRefresh"
    />
    <cross-tenant-change-history-dialog v-if="crossTenantDialog.visible" :data="crossTenantDialog.data" :has-un-read="crossTenantDialog.readState" :visible.sync="crossTenantDialog.visible" :job-uuid="job.uuid" :lob="job.lob" />
    <!-- 推送日志记录弹窗 -->
    <push-log-dialog v-if="pushLogDialog.visible" :visible.sync="pushLogDialog.visible" :job-uuid="job.uuid || ''" />

    <!-- 验证规则-保存业务节点弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      lob="SE"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!--关联进口业务信息-->
    <related-si-from-window
      v-if="relatedSiFromWindow.visible"
      ref="relatedSiFromWindow"
      :visible.sync="relatedSiFromWindow.visible"
      :related-job="relatedSiFromWindow.relatedJob"
      :context="context"
      :can-operate-job="canOperateJob"
    />
    <!--选择协作分公司-->
    <cooperation-branch-list
      v-if="cooperationBranchListDialog.visible"
      :visible.sync="cooperationBranchListDialog.visible"
      :job-uuid="cooperationBranchListDialog.jobUuid"
      :job="cooperationBranchListDialog.job"
      :order-center-branch="cooperationBranchListDialog.orderCenterBranch"
      @refresh="(cooperatebranch)=>{updateJobCooperate(cooperatebranch);refreshChargeTabCooperatebranch(cooperatebranch)}"
      @cancel="()=>cooperationBranchListDialog.visible=false"
      @refreshJob="reload"
    />
    <!-- 业务申请审批流 -->
    <job-apply-dialog
      v-if="jobApplyDialog.visible"
      :visible.sync="jobApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_SubmitJobChargeForApproval')"
      type="apply"
      :doc-id="job.uuid"
      :document-config-id="documentConfigId"
      @close="jobApplyDialog.visible=false"
      @closeAndRefresh="applyCloseAndRefresh"
    />
    <!--  导入订单数据弹框  -->
    <import-order-dialog
      v-show="importOrderDialog.visible"
      ref="importOrderDialog"
      :visible.sync="importOrderDialog.visible"
      :lob="importOrderDialog.job.lob || 'SE'"
      :job="importOrderDialog.job"
      @confirmCallBack="data=>{ importOrderConfirmCallBack(data) }"
    />
    <!-- 预览文件弹窗 -->
    <cargo-dialog
      v-if="previewFileData.visible"
      no="preview"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :can-maximize="true"
      :can-minimize="true"
      custom-class="preview-dialog"
      @close="closePreviewDialog"
      @modalMin="onPreviewFileDailogMin"
    >
      <div v-if="previewFileData.pdfSrc" class="pdf-img">
        <el-scrollbar>
          <pdf v-for="i in previewFileData.numPages" :key="i" :src="previewFileData.pdfSrc" :page="i" />
        </el-scrollbar>
      </div>
      <viewer v-else-if="previewFileData.photoList.length > 0" :images="previewFileData.photoList" class="preview-img">
        <img v-for="(item, index) in previewFileData.photoList" :key="index" :src="item">
      </viewer>
      <iframe v-else-if="previewFileData.officeFileUrl" :src="previewFileData.officeFileUrl" class="office-preview" />
    </cargo-dialog>
    <el-button
      v-if="previewFileData.showViewBtn"
      no="FileView"
      type="primary"
      style="position: absolute;right: 60px;bottom: 100px;"
      @click="toViewFile"
    >{{ $t('Message.FileView') }}</el-button>
    <!-- 变更日志记录 弹窗 -->
    <data-update-log-dialog :hide-window="isEditing" :visible.sync="dataUpdateLogDialog.visible" :is-need-refresh.sync:="dataUpdateLogDialog.isNeedRefresh" :default-is-expand="dataUpdateLogDialog.defaultIsExpand" :job="job" :is-need-expand.sync="dataUpdateLogDialog.isNeedExpand" @handleClose="dataUpdateLogDialogClose" />
    <jy-warehouse-api-log-dialog :visible.sync="jyWarehouseApiLogDialog.visible" :job-uuid="job.uuid" />
    <msd-api-log-dialog :visible.sync="msdApiLogDialog.visible" :job-uuid="job.uuid" />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="SE"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="detail"
      @confirm="reload"
    />
    <!-- 壹沓回执结果 -->
    <yd-booking-result-dialog
      v-if="ydBookingResultDialog.visible"
      ref="ydBookingResultDialog"
      :visible.sync="ydBookingResultDialog.visible"
      :job-uuid="ydBookingResultDialog.jobUuid"
      :job="ydBookingResultDialog.job"
      :yd-booking-result="ydBookingResultDialog.bookingResult"
      @close="closeYdBookingDialog"
      @refreshJob="reload"
    />
    <!-- 费用解锁申请弹窗 -->
    <unlock-apply-dialog v-if="unlockApplyDialog.visible" :visible.sync="unlockApplyDialog.visible" :selected-jobs="[job]" @success="onUnlockApplySuccess" />
    <!-- 自定义表单窗口 -->
    <custom-form-window ref="customFormWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import { BookingWorkspaceContext } from './bookingWorkspaceContext'
import { BookingWorkspacePM } from './bookingWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import ediStatusLogDialog from '@/components/Cargo/Job/ediStatusLogDialog'
import bookingSpaceLogDialog from '@/components/Cargo/Job/bookingSpaceLogDialog'
import trustFromWindow from './tabs/trustFromWindow'
import tabBookingFcl from './tabs/tabBookingFCL'
import tabBookingFCLUICustom from './tabs/tabBookingFCLUICustom'
import tabBookingMaster from './tabs/tabBookingMaster'
import tabBookingMasterUICustom from './tabs/tabBookingMasterUICustom'
import tabVesselEq from './tabs/tabVesselEq'
import tabVesselEqUICustom from './tabs/tabVesselEqUICustom'
import tabPrePlanBooking from './tabs/tabPrePlanBooking'
import tabPrePlanBookingLcl from './tabs/tabPrePlanBookingLcl'
import tabMbl from './tabs/tabMBL'
import tabMblUICustom from './tabs/tabMBLUICustom'
import tabMbl2 from './tabs/tabMBL2'
import tabMbl2UICustom from './tabs/tabMBL2UICustom'
import tabHbl from './tabs/tabHBL'
import tabHblUICustom from './tabs/tabHBLUICustom'
import tabHbl2 from './tabs/tabHBL2'
import tabHbl2UICustom from './tabs/tabHBL2UICustom'
import tabAms from './tabs/tabAMS'
import tabSubBill from './tabs/tabSubBill'
import tabSubBillUICustom from './tabs/tabSubBillUICustom'
import tabContainer from './tabs/tabContainer'
import tabLclContainer from './tabs/tabLclContainer'
import tabLclContainerMultiSoNoMode from './tabs/tabLclContainerMultiSoNoMode'
import tabVgm from './tabs/tabVGM'
import tabWarehouse from './tabs/tabWarehouse'
import tabTruckingForSe from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import tabTruckingUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTruckingUICustom'
import tabDischargingTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTrucking'
import tabDischargingTruckingUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTruckingUICustom'
import tabDestinationCustomsData from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabDestinationCustomsData'
import tabWarehouseIn from './tabs/tabWarehouseIn'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabCustomsInfoUICustom from '@/components/Cargo/Job/booking/tabs/tabCustomsInfoUICustom'
import tabCustomsInfoOuj from '@/components/Cargo/Job/booking/tabs/ouJian/tabCustomsInfoOuj'
import tabTradeDetail from './tabs/tabTradeDetail'
import tabTradeCommission from './tabs/tabTradeCommission'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabFile from '@/components/Cargo/Job/booking/tabs/tabFile'
import tabSpecialGoods from './tabs/tabSpecialGoods'
import tabSpecialGoodsUICustom from './tabs/tabSpecialGoodsUICustom'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { getUserDefaultDepartment } from '@/api/user'
import { getOfficeByUuid } from '@/api/office'
import { saveSeaBookingSpace, createCrossTenantImportByExportJob, importOrderJob } from '@/api/seaExport/seaExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { Company } from '@/class/model/mdm/Company'
import { Office } from '@/class/model/sys/Office'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { PrintUtils } from '@/utils/PrintUtils'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import {
  ensureExecuteSuccess,
  deepCopy,
  sleep,
  cleanCircleObject,
  catchErrorTip,
  MarkManage
} from '@/utils/commonUtil'
import StrUtils from '@/utils/StrUtils'
import { getDocumentType } from '@/api/documentType'
import { checkJobProvisionFlag, normalizeProvisionLock } from '@/api/provision/provisionData'
import { canBatchShutout, shutOut, getChargeIsInvoice, commit, saveJobInfo, calculateProfit, printProfit, saveCopyJob, createImportByExportJob,
  prePrintProfit, feedbackBookingData, getRelatedJob, checkingConsignationJob, saveCloneJob, crossTenantJob, isContractExpiredForbidCreateJob, getRelatedSiJob,
  manualTriggerAndUpate, syncRelatedJob, executeRuleEngine
} from '@/api/seaExport/seaExportJob'
import { queryCompany, mainTainCurrentTenantCompanies, getCompanyByTenantIdAndBranchIdAndScac } from '@/api/company'
import { updateChangeState } from '@/api/clearing/financeManage'
import { queryLatestState, isRejectedBySendJobNo, isCrossed } from '@/api/booking/crossTenantHistory'
import { isHavePorts } from '@/api/seaport'
import { isHavePacking } from '@/api/basicData/packing'
import { queryTemplateByNameAndType } from '@/api/sysManage/baseConfig/template'
import { sortByMultiField } from '@/utils'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import TabDataTracking from '@/views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking'
import lodash from 'lodash'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import TabPrePlanBookingJc from '@/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/tabPrePlanBookingJc'
import tabBuyerConsoleFclContainer from './tabs/tabBuyerConsoleFclContainer'
import tabBuyerConsoleFclBookingMaster from './tabs/tabBuyerConsoleFclBookingMaster'
import tabBuyerConsoleFclBookingMasterUICustom from './tabs/tabBuyerConsoleFclBookingMasterUICustom'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getSubscribePortPush } from '@/api/sysManage/subscribePortPushRule'
import { backReturn, normalCommitJob, queryApiRespLog, queryCrossTenantSyncHistory } from '@/api/booking/job'
import { getUserInfo } from '@/utils/auth'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { sendHecMessageByJob, backHecMessageByJob } from '@/api/clearing/charge'
import { sendJobCBMS } from '@/api/booking/job'
import TabPoItemsUpgrade from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabPoItemsUpgrade'
import pushResultLogDialog from '@/components/Cargo/Job/pushResultLogDialog'
import CrossTenantChangeHistoryDialog from '@/components/Cargo/Job/crossTenantDialogChangeHistory'
import PushLogDialog from '@/views/cargo/v0/Clearing/components/booking/PushLogDialog'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import tabBackUpWarehouse from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBackUpWarehouse'
import relatedSiFromWindow from './tabs/relatedSiFromWindow'
import tabUsCustomsClearance from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearance'
import tabUsCustomsClearanceMaster from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMaster'
import { PrePlanBookingUtil } from '@/class/cargo/model/utils/PrePlanBookingUtil'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import FbaOutWarehouse from '@/views/cargo/v0/FBA/OverseaWarehousing/fbaOutWarehouse'
import { triggerReleaseRuleEngineAfterSave } from '@/utils/releaseRuleEngine'
import FbaWarehousingDetail from '@/views/cargo/v0/FBA/Warehousing/fbaWarehousingDetail'
import tabWarehousingDetail from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehousingDetail'
import cooperationBranchList from '@/components/Cargo/Job/cooperationBranchList'
import { updateState } from '@/api/booking/jobCooperate'
import { DocumentManage, stringToNumArray } from '@/utils/commonUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { syncManifestInfoToVgm } from '@/api/seaExport/vgm'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import JobApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import pdf from 'vue-pdf'
import DataUpdateLogDialog from '@/components/Cargo/Job/dataUpdateLogDialog'
import TabInsure from '@/components/Cargo/Job/booking/tabs/tabInsure'
import {
  LOG_SE_SEA_BOOKING,
  SE
} from '@/class/cargo/model/parameters/SystemConstants'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CFM_BILL_STATE_NEW, CFM_BILL_STATE_UPDATE } from '@/class/cargo/model/parameters/XhqBillCfmState'
import { toXhqUpdateLclBillInfo, xhqUpdateBillInfo } from '@/api/seaExport/seaCargoDoc'
import { fbaGetRelatedJob, fbaSaveCloneJob } from '@/api/Fba/fbaJob'
import JyWarehouseApiLogDialog from '@/components/Cargo/Job/jyWarehouseApiLogDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import BookingWorkspaceMixin from '@/mixin/BookingWorkspaceMixin'
import ImportOrderDialog from '@/components/Cargo/Job/importOrderDialog'
import { getConfigForCurrentTenant } from '@/api/sysManage/baseConfig/vasChannelConfig'
import { BB_CARGO_TYPE, BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import TabMscBookingInfo from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMscBookingInfo.vue'
import { matchView } from '@/store/modules/tagsView'
import ydBookingResultDialog from '@/views/cargo/v0/SeaExport/components/edi/ydBookingResultDialog'
import { queryYDBookingResultsAndJob } from '@/api/seaExport/edi'
import MsdApiLogDialog from '@/components/Cargo/Job/msdApiLogDialog.vue'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import {
  mergeCopyUntouchedTabData,
  normalizeSchemeContent,
  resolveLegacyVesselEqSelected,
  SEA_BOOKING_COPY_OPTIONS_CACHE_PREFIX,
  cleanupCopiedContainerUuids
} from './seaBookingCopyConfig'
import { getJobInstructions } from '@/api/sysManage/uiCustom'
import CustomFormWindow from '@/components/Cargo/Job/customFormWindow'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { autoAllocateCargo } from '@/api/seaExport/warehouseIn'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import UnlockApplyDialog from '@/views/cargo/v0/SeaExport/components/booking/unlockApplyDialog'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'

export default {
  name: 'SeBookingWorkspace',
  components: {
    jobReturnReviewDialog,
    MsdApiLogDialog,
    TabMscBookingInfo,
    FbaWarehousingDetail,
    FbaOutWarehouse,
    CrossTenantChangeHistoryDialog,
    PushLogDialog,
    TabPoItemsUpgrade,
    TabPrePlanBookingJc,
    CargoButtonGroupSlider,
    TabDataTracking,
    cargoAdvanceSelect, cargoUserSelect, cargoLeftRightResize, cargoTemplateSelectorDialog, businessStatusLogDialog, ediStatusLogDialog, bookingSpaceLogDialog, trustFromWindow,
    tabBookingFcl, tabBookingFCLUICustom, tabBookingMaster, tabBookingMasterUICustom, tabVesselEq, tabVesselEqUICustom, tabPrePlanBooking, tabPrePlanBookingLcl, tabMbl, tabMblUICustom, tabMbl2, tabMbl2UICustom, tabHbl, tabHblUICustom, tabHbl2, tabHbl2UICustom, tabAms,
    tabSubBill, tabSubBillUICustom, tabContainer, tabLclContainer, tabLclContainerMultiSoNoMode, tabVgm, tabWarehouse, tabTruckingForSe, tabTruckingUICustom, tabDischargingTrucking, tabDischargingTruckingUICustom, tabDestinationCustomsData, tabWarehouseIn, tabCustomsInfo, tabCustomsInfoUICustom, tabCustomsInfoOuj, tabTradeDetail,
    tabTradeCommission, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabFile, tabSpecialGoods, tabSpecialGoodsUICustom, tabSopState, tabFileHistory,
    CheckingWindow, EstimateValidationDialog, BatchCheckingWindow, sopStateDialog, tabBuyerConsoleFclContainer, tabBuyerConsoleFclBookingMaster, tabBuyerConsoleFclBookingMasterUICustom, pushResultLogDialog, checkingSaveJobWindow, tabBackUpWarehouse, relatedSiFromWindow,
    tabUsCustomsClearance, tabUsCustomsClearanceMaster, tabWarehousingDetail, cooperationBranchList, CargoIm, JobApplyDialog, CargoDialog, pdf, DataUpdateLogDialog, TabInsure, ImportOrderDialog,
    JyWarehouseApiLogDialog, ydBookingResultDialog, CustomFormWindow, UnlockApplyDialog
  },
  mixins: [BookingWorkspaceMixin],
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    openMultiple: {
      type: Boolean,
      default: false
    },
    isFba: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: ''
    }
  },
  data() {
    const currentUserInfo = getUserInfo()
    const leftGridColumnType = window.localStorage.getItem(`SE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`) || 'jobNo'
    return {
      isHc: false,
      priceAuditCommand: this.$t('CargoMsg.Cargo_preportAudit'),
      imCacheKey: '',
      lockHBLReleaseStateBeforeReleaseVerify: '',
      customerSelfRelease: '',
      isZh: this.$store.getters.language === 'zh',
      leftGridColumnType,
      visible: false,
      URL,
      selectTypeNames: TYPE_NAMES,
      context: new BookingWorkspaceContext(this.parentContext),
      pm: new BookingWorkspacePM(this),
      SystemConstants,
      ContainerLoadType,
      UICustomConstants,
      copyJobNum: 0,
      privilege: {
        seBooking: {
          bookingTab: this.$checkPermission(['tab_SEBooking_BookingTab']),
          vesselEqTab: this.$checkPermission(['tab_SEBooking_VesselEqTab']),
          prePlanBooking: this.$checkPermission(['tab_SEBooking_PrePlanBooking']),
          mbl: this.$checkPermission(['tab_SEBooking_MBL']),
          mbl2: this.$checkPermission(['tab_SEBooking_MBL2']),
          hbl: this.$checkPermission(['tab_SEBooking_HBL']),
          hbl2: this.$checkPermission(['tab_SEBooking_HBL2']),
          ams: this.$checkPermission(['tab_SEBooking_AMS']),
          tabSubBill: this.$checkPermission(['tab_SEBooking_TabSubBill']),
          containersLayer: this.$checkPermission(['tab_SEBooking_ContainersLayer']),
          lclManagerLayer: this.$checkPermission(['tab_SEBooking_LclManagerLayer']),
          warehouseTab: this.$checkPermission(['tab_SEBooking_WarehouseTab']),
          seTruckingPage: this.$checkPermission(['tab_SEBooking_SETruckingPage']),
          seDischargingTrukingPage: this.$checkPermission(['tab_SEBooking_SEDischargingTrukingPage']),
          seCustomsInfo: this.$checkPermission(['tab_SEBooking_SECustomsInfo']),
          fileTab: this.$checkPermission(['tab_SEBooking_FileTab']),
          specialGoodsTab: this.$checkPermission(['tab_SEBooking_SpecialGoodsTab']),
          portalState: this.$checkPermission(['tab_SEBooking_portalState']),
          backUpWarehouseTab: this.$checkPermission(['tab_SEBooking_BackUpWarehouseTab'])
        },
        salesQueryModule: {
          vesselEqTab: this.$checkPermission(['tab_SalesQueryModule_VesselEqTab'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          chargeReceivable: this.$checkPermission(['tab_Charge_chargeReceivable']),
          chargePayable: this.$checkPermission(['tab_Charge_chargePayable']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      isCrossTenantSEToSIStatus: false,
      isLoadRelatedSop: false,
      btnInfo: {
        label: {
          shutOutLabel: this.$t('SeaExport.ShutOut'),
          btnEntrustment: this.$t('SeaExport.Consignation'), // 内部委托按钮
          btnEntrustmentSI: this.$t('SeaExport.ConsignationSI') // 出口转进口按钮
        },
        btnEntrustmentSISynchronized: false, // 出口转进口（已同步过）
        visible: {
          sendBackBookingButton: false, // 发送订舱数据
          printFclProfit: false, // 整箱利润打印
          printLclProfit: false, // 拼箱利润打印
          cancelReturn: false, // 退回操作
          printReturn: false // 撤回
        },
        privilege: {
          btnEntrustment: null, // 委托按钮是否禁用
          btnShutout: false, // 退关按钮是否可用
          consignationEnable: false, // 内部委托按钮是否可用
          consignationEnableSI: false, // 出口转进口按钮是否可用
          consignationCrossEnable: false, // 跨分公司委托是否可用
          crossMoreSign: false,
          button_SEBooking_cancelShutout: this.$checkPermission(['button_SEBooking_cancelShutout']),
          button_SEBooking_Shutout: this.$checkPermission(['button_SEBooking_Shutout']),
          button_JobBooking_Submit: this.$checkPermission(['button_JobBooking_Submit']),
          button_JobBooking_PreSubmit: this.$checkPermission(['button_JobBooking_PreSubmit']),
          button_JobBooking_ManagerSubmit: this.$checkPermission(['button_JobBooking_ManagerSubmit']),
          button_JobBooking_ManagerAuditSubmit: this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']),
          button_JobBooking_PrintProfit: this.$checkPermission(['button_JobBooking_PrintProfit']),
          button_SEBooking_cancelProfit: this.$checkPermission(['button_SEBooking_cancelProfit']),
          button_JobBooking_Retract: this.$checkPermission(['button_JobBooking_Retract'])
        }
      },
      tabInfo: {
        visible: {
          oujianCustomsInfo: false,
          dataTrackingDisplay: false
        }
      },
      commonInfo: {
        operateNameCode: -1, // 操作code
        jobState: '',
        jobTitle: '',
        chargeJobTitle: '',
        invoiceMode: '',
        jobLock: '',
        provisionPublished: false, // 计提已发布状态
        provisionLock: { etdLocked: false, feeLocked: false },
        isPreCommit: false, // 预提交
        isPrintCommit: false, // 打印利润分析表是否提交业务
        allSubmitFcl: false, // 主票提交时是否提交全部拼票业务
        reqInputCharge: false, // 是否必录费用
        isBookingFeeMandatoryAppliedGlobally: false, // 订舱费用必填是否全模块应用
        checkEstimate: false, // 预估是否验证过
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        overwriteJobRefNoBySEconvertSI: false, // 出口转进口客户参考号生成规则
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        printEvent: null,
        showMessage: true,
        poItemsTabViewModel: false, // 货物明细显示模式
        showCombinedManifest: false, // 显示合并预配舱单功能
        chargeSyncNeedConfirm: false, // 出口进口费用同步，是否需要确认。
        copyFromJob: false // 是否显示导入订单按钮
      },
      sopTooltipOffset: 0,
      enablePrint: false, // 打印按钮是否可用
      action: '',
      isLoadingData: false, // 是否正在加载数据
      addEventFlag: false, // 新增事件标识
      addMasterEventFlag: false, // 新增主票事件标识
      editEventFlag: false, // 编辑事件标识
      saveEventFlag: false,
      changeDataSFT: {}, // 收发通变更值
      gridOptions: {
        rowSelection: 'single',
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        defaultColDef: {
          tooltipValueGetter: (params) => {
            if (params.value) {
              return params.value
            }
          }
        },
        autoGroupColumnDef: {
          headerName: leftGridColumnType === 'jobNo' ? this.$t('SeaExport.BusinessNo') : leftGridColumnType,
          colId: leftGridColumnType,
          field: leftGridColumnType,
          width: 220,
          tooltip: (params) => {
            return params.data ? params.data[leftGridColumnType] : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob && currentJob.dataType && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:2px;" />${params.value}</span>`
              }
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        suppressContextMenu: false,
        context: {
          componentParent: this
        },
        getContextMenuItems: () => {
          const self = this
          const menu = [
            'copy',
            {
              name: self.$t('SeaExport.BusinessNo'),
              action: function() {
                const currentUserInfo = getUserInfo()
                self.leftGridColumnType = 'jobNo'
                window.localStorage.setItem(`SE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'jobNo')
              }
            }, {
              name: 'MBL',
              action: function() {
                self.leftGridColumnType = 'mbl'
                const currentUserInfo = getUserInfo()
                window.localStorage.setItem(`SE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'mbl')
              }
            }, {
              name: 'HBL',
              action: function() {
                self.leftGridColumnType = 'hblNo'
                const currentUserInfo = getUserInfo()
                window.localStorage.setItem(`SE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'hblNo')
              }
            }
          ]
          return menu
        },
        tabToNextCell: this.tabToNextCell,
        onCellClicked: async event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          // 双击检测
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            const mark = this.markManage.regenerateMark('onCellClicked')
            await sleep(500)
            if (this.markManage.readMark('onCellClicked') !== mark) {
              return
            }
          }
          this.onCellClicked(event)
        },
        onCellDoubleClicked: event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            // 中断单击处理
            this.markManage.regenerateMark('onCellClicked')
            this.onCellDoubleClicked(event)
          }
        }
      },
      rowData: [],
      gridApi: null,
      showMscSupplement: false,
      currentRow: {},
      basicInfo: {
        gridOptions: {
          rowSelection: 'single',
          columnDefs: [
            {
              headerName: this.$t('SeaExport.BasicInfo'),
              field: 'basic',
              width: 220,
              suppressMenu: true,
              tooltipValueGetter: params => params.value
            }
          ],
          suppressContextMenu: false,
          getRowStyle: function(params) {
            if (params.data.isTitle) {
              return {}
            } else {
              return { 'color': '#666666' }
            }
          },
          context: {
            componentParent: this
          }
        },
        rowData: []
      },
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      partner: {}, // 发送分公司-合作伙伴
      relatedJobUUID: '', // 跨tenant委托，接收方的jobUuid
      template: {}, // 跨tenant委托后调用模板，上传到云存储
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SE',
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      unlockApplyDialog: {
        visible: false
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      submitDialog: {
        visible: false
      },
      logCommand: this.$t('SeaExport.PortDataPushLog'),
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      businessStatusDialog: {
        visible: false
      },
      ediStatusLogDialog: {
        visible: false
      },
      bookingSpaceLogDialog: {
        visible: false
      },
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      sendBranchSelectObject: 0,
      sendBranchWindow: {
        opNotNull: false, // 控制操作显示且必填
        visible: false,
        office: {},
        title: this.$t('SeaExport.SelectAction'),
        items: [{
          selectObject: 0,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        }],
        consigneeTarget: '',
        consigneeDetailTarget: '',
        checkConsigneeDefault: false, // 将本次内容设置为默认转出口信息
        checkSalesMapping: false, // 委托业务的销售映射到操作业务的揽货销售
        customJobType: null // 自定义业务类型
      },
      trustFromWindow: {
        visible: false,
        job: null, // 当前业务
        trustJob: null // 关联业务job
      },
      saveJobNos: [], // 保存后的jobNo
      removedJobNos: [], // 被移除的jobNo
      isGetNewJobInfoFromDb: false, // 是否从数据库里获取最新job相关信息【暂时用于保存之后取job】
      isOtherEdit: false, // 拆分主票，复制业务，都属于新增的数据，uuid为空，但是大部分字段已经有值，不需要走初始化数据操作
      enableEntrustmentSI: false, // 是否海出委托转海进
      canSave: true,
      doSaving: false, // 是否正在保存
      optName: '', // 操作名称
      btnGroupLook: null,
      btnGroupEdit: null,
      markManage: new MarkManage(),
      pushResultLogDialog: {
        visible: false
      },
      crossTenantDialog: {
        visible: false,
        readState: false,
        data: []
      },
      toExoSystemOC: false, // 是否显示橙联推送结果
      pushLogDialog: {
        visible: false
      },
      toExoSystemEAS: false, // 是否显示金蝶EAS推送结果
      checkingSaveJobWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      relatedSiFromWindow: { // 关联进口业务信息
        visible: false,
        relatedJob: null // 关联业务job
      },
      cooperationBranchListDialog: { // 协作分公司
        visible: false,
        jobUuid: '',
        job: null,
        orderCenterBranch: false
      },
      JobUtils,
      documentManage: new DocumentManage(),
      basicInfoVisible: false,
      isShowExportToImport: true, // 出口转进口按钮是否显示
      jobApplyDialog: {
        visible: false
      },
      documentConfigId: Job_CHARGE.code,
      // 预览文件参数
      previewFileData: {
        visible: false,
        pdfUrl: '',
        pdfSrc: '',
        numPages: '',
        photoList: [],
        officeFileUrl: '',
        showViewBtn: false
      },
      dataUpdateLogDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      jingyuWarehouse: false,
      jyWarehouseApiLogDialog: {
        visible: false
      },
      importOrderDialog: {
        visible: false,
        job: {}
      },
      msdApiLogDialog: {
        visible: false
      },
      ydBookingResultDialog: {
        visible: false,
        jobUuid: '',
        job: null,
        bookingResult: null
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      enableCommission: false,
      toExoSystemJYD: false,
      toExoSystemTP: false,
      toExoSystemDLWL: false,
      toExoSystemZY: false,
      sendBranchSelectObjectOrigin: '0', // 发送分公司选项配置原始值
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      disabledChangeJob: false, // 是否禁止切换业务
      jobChangeDisabledTip: '', // 业务切换被禁用的提示信息
      vesselAndVoyage: '', // 是否修改了船名航次
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      chargePageSet: { hideTabCharge: false, arAloneShow: false, apAloneShow: false }, // 费用页签设置
      instructioinBtns: [], // 指令按钮列表
      sopTemplateConfig: {}, // SOP模板配置
      templateName: ''
    }
  },
  computed: {
    isXhqAdd() { // 智能托书识别新增业务
      return this.$route.query.action === 'add'
    },
    isShowExportToImportCommon() {
      return this.job.masterFlag || !(this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code)
    },
    user() {
      return this.context.user
    },
    office() {
      return this.context.office || this.$store.getters.currentOffice
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    isVerify() {
      // 预审
      return false
    },
    job() {
      return this.currentRow
    },
    payableChargeLockedTooltip() {
      const details = []
      const person = ColumnUtils.getPayableChargeLockedPerson(this.job)
      const lockedAt = this.job.payableChargeLockedDate ? DateUtils.formatStandardDateTime(this.job.payableChargeLockedDate) : ''
      if (person) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockPerson')}：${person}`)
      }
      if (lockedAt) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockTime')}：${lockedAt}`)
      }
      return details.join('\n')
    },
    sideBar() {
      return this.$store.getters.sidebar.opened
    },
    isBuyerConsoleFcl() {
      return this.paramsOfTab.containerLoadType === 'BCF'
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    saveJobNosLength() {
      return this.saveJobNos.length
    },
    showTabWarehouseIn() { // 货物信息
      return !(this.isLclMaster && this.isNew) && !this.isNew && this.paramsOfTab.warehousing && this.privilege.seBooking.warehouseTab
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.config ? Number(this.config.get('useOrderCenterMode')) === 1 : false
    },
    useOrderCenterBranch() { // 是否开启接单分公司
      return this.config ? Number(this.config.get('orderCenterBranch')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus || -1
      if (this.paramsOfTab.cooperate && this.paramsOfTab.cooperate.cooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperate.cooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperate && this.paramsOfTab.cooperate.businessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperate.businessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperate && this.paramsOfTab.cooperate.uuid) {
        return true
      }
      return false
    },
    location() {
      if (!this.isFba) {
        return LOG_SE_SEA_BOOKING.code
      }
      return ''
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllDetail
    },
    canOperateJob() {
      if (this.hqViewAllDetail) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (this.currentRow &&
          this.currentRow.opOffice !== this.$store.getters.currentOfficeId &&
          this.currentRow.salesOffice !== this.$store.getters.currentOfficeId &&
          !this.mactchCooperateBranch(this.currentRow.cooperatebranch, this.$store.getters.currentOffice) &&
          !this.enableCommission
        ) {
          return false
        }
      }
      if (this.hierarchyViewDetail && this.currentRow) {
        return this.matchOwnerBranch(this.currentRow)
      }
      return true
    },
    showdCheckSalesMapping() {
      return this.toExoSystemJYD && !this.enableEntrustmentSI && Number(this.sendBranchSelectObjectOrigin) === 3 && !this.job.fba
    },
    seMultiSoMode() { // 海运出口开启拼箱小票多SO操作模式
      return this.config ? Number(this.config.get('SEMultiSoMode')) === 1 : false
    },
    slaveCustomsDeclarationEnable() { // 【小票】关单信息 是否可用
      return this.job.lob === SE.code && !this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BB_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.paramsOfTab.containerLoadType) >= 0
    },
    masterCustomsDeclarationEnable() { // 【主票】关单信息 是否可用
      return this.job.lob === SE.code && this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.paramsOfTab.containerLoadType) >= 0
    },
    showImportOrder() {
      return this.commonInfo.copyFromJob && this.job.jobState === SystemConstants.OPERATING &&
        this.job.opOffice === this.$store.getters.currentOfficeId && !this.job.masterFlag && !this.job.lclMasterUuid
    },
    controlledLocked() {
      return this.toExoSystemDLWL && this.job.exportControlledLocked
    },
    showReturnReview() { // 是否显示退回按钮
      return this.job.jobState === SystemConstants.OPERATING && !this.job.masterFlag && !this.job.lclMasterUuid &&
        (this.job.preverifyState === SystemConstants.VERIFYING_AUDITED.code || this.job.preverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code)
    },
    trackingTemplateUuid() {
      return this.currentRow.trackingTemplateUuid
    }
  },
  watch: {
    leftGridColumnType(newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      console.log(newVal, oldVal)
      this.gridOptions.api.setAutoGroupColumnDef({
        headerName: newVal === 'jobNo' ? this.$t('SeaExport.BusinessNo') : newVal,
        colId: newVal,
        field: newVal,
        width: 220,
        tooltip: (params) => {
          return newVal === 'jobNo' ? params.data.jobNo : newVal === 'MBL' ? params.data.mbl : params.data.hblNo
        },
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          innerRenderer: params => {
            const currentJob = params.data
            if (currentJob && currentJob.dataType && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
              const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
              return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:2px;" />${params.value}</span>`
            }
            return `<span>${params.value}</span>`
          }
        },
        suppressMenu: true
      })
    },
    action(newVal) {
      this.$nextTick(() => {
        this.$refs.cargoButtonGroupSlider.resizeHandler()
      })
    },
    addEventFlag(newVal) {
      if (newVal) {
        this.addEventFlag = false
        this.toAdd()
      }
    },
    addMasterEventFlag(newVal) {
      if (newVal) {
        this.addMasterEventFlag = false
        this.toAdd({ masterFlag: true })
      }
    },
    editEventFlag(newVal) {
      if (newVal) {
        this.editEventFlag = false
        return catchErrorTip(() => {
          return this.editHandler('edit')
        })
      }
    },
    saveEventFlag(newVal) {
      if (newVal) {
        this.saveEventFlag = false
        return catchErrorTip(() => {
          return this.save()
        })
      }
    },
    saveJobNosLength(newVal, oldVal) {
      if (newVal > oldVal) {
        const changedRows = this.saveJobNos.slice(oldVal)
        for (const item of changedRows) {
          this.syncViewData(item)
        }
      }
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (this.$store.state.uiCustom.enable) {
          this.loadPageSet()
        }
        if (this.$route.name !== 'SeaBooking' || this.view !== 'detail') {
          return
        }
        await cache.load(cacheName.CONFIG)
        this.enableCommission = cache.config.get('enableCommission') === '1'
        if (this.hqViewAllList && !this.hqViewAllDetail) {
          if (this.$store.getters.currentOfficeId === 1) {
            this.$confirm(this.$t('queryJob.SwitchHQNotView'), this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
              confirmButtonText: this.$t('queryJob.JumpListPage'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.goBack()
            }).catch(() => {
            })
          }
        }
      }
    },
    trackingTemplateUuid: {
      immediate: true,
      async handler(newVal) {
        this.templateName = await SopUtil.getTemplateName(newVal)
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'SE' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBasicInfo', function() {
      context.showBasicInfo()
    })
    if (this.$store.state.uiCustom.enable) {
      this.loadPageSet()
    }
  },
  mounted() {
    this.btnGroupLook = this.$el.getElementsByClassName('btn-group-look')[0]
    this.btnGroupEdit = this.$el.getElementsByClassName('btn-group-edit')[0]
    this.btnGroupNew = this.$el.getElementsByClassName('btn-group-new')[0]
    this.sendBranchWindow.checkConsigneeDefault = LocalStorageUtilsNew.getConfiguration('SE_checkConsigneeDefault') || false
    if (this.sendBranchWindow.checkConsigneeDefault) {
      this.sendBranchWindow.consigneeTarget = LocalStorageUtilsNew.getConfiguration('SE_consigneeTargett', 'string') || 'consignee'
      this.sendBranchWindow.consigneeDetailTarget = LocalStorageUtilsNew.getConfiguration('SE_consigneeDetailTarget', 'string') || 'consigneeDetail'
    }
  },
  activated() {
    if (!this.action) {
      return
    }
    if (this.openMultiple) {
      const leftSize = LocalStorageUtilsNew.getConfiguration('SE_LEFT_SIZE')
      if (leftSize) {
        this.$refs.cargoLeftRightResize.$refs.left.style.width = leftSize
      }
      let action = ''
      if (this.$route.params.action === 'edit') {
        delete this.$route.params.action
        if (this.action === 'look') {
          action = 'edit'
        }
      }
      if (this.$route.params.isDirty) {
        delete this.$route.params.isDirty
        if (this.action === 'look') {
          this.reset([this.currentRow])
          this.againShow(action || 'look')
        } else {
          this.$message.warning(this.$t('queryJob.DataChangedToReopen'))
        }
        action = ''
      }
      if (action) {
        this.againShow(action)
      }
    } else {
      let action = ''
      if (this.viewJobNoSet.has(this.currentRow.jobNo)) {
        const rows = this.rowData.filter(p => !this.viewJobNoSet.has(p.jobNo))
        if (rows.length > 0) {
          this.currentRow = rows[0]
          action = 'look'
        } else {
          this.goBack()
          return
        }
      }
      const changedJobNos = this.$route.params.changedJobNos
      if (changedJobNos) {
        delete this.$route.params.changedJobNos
        // 重置关联数据
        for (const item of this.rowData) {
          if (changedJobNos.includes(item.jobNo)) {
            if (item.jobNo === this.currentRow.jobNo) {
              if (this.action === 'look') {
                this.reset([item])
                this.againShow(action || 'look')
              } else {
                this.$message.warning(this.$t('queryJob.DataChangedToReopen'))
              }
              action = ''
            } else {
              this.reset([item])
            }
          }
        }
      }
      if (action) {
        this.againShow(action)
      }
    }
  },
  deactivated() {
    if (this.openMultiple) {
      LocalStorageUtilsNew.setConfiguration('SE_LEFT_SIZE', this.$refs.cargoLeftRightResize.$refs.left.style.width)
    }
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    onGridReady(params) {
      console.log('左侧列表')
      this.gridApi = params.api
    },
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    // 港前、尾程审核
    priceAuditHandle() {
      JobUtils.priceAuditHandle(this, this.job, 'detail')
    },
    toPacking() {
      if (!(this.isLclMaster && this.isNew) && !this.masterFlag && this.privilege.seBooking.containersLayer) {
        this.activeTabName = 'tabContainer'
      }
      if (!(this.isLclMaster && this.isNew) && this.masterFlag && !this.isNew && this.privilege.seBooking.lclManagerLayer) {
        this.activeTabName = 'tabLclContainer'
      }
      this.handleTabClick()
    },
    loadPageSet() {
      this.chargePageSet = UICustomUtil.getChargePageSet(UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE)
    },
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      if (action === 'edit' && this.isHc) {
        selectedRow.containerUsages = '' // 需要刷新，因为在查看状态可以【门点-添加装箱】
      }
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      // 新增操作，预处理
      if (action === 'add' || action === 'split' || action === 'copy') {
        const currentTab = this.$refs[this.activeTabName]
        if (currentTab) {
          this.$refs.cargoLeftRightResize.hideLeft()
          this.btnGroupLook.style.display = 'none'
          this.btnGroupNew.style.display = ''
          this.$refs.cargoButtonGroupSlider.resizeHandler()
          const jobModel = new SeaExportJob()
          jobModel.fillDefaultValue()
          jobModel.seaEQ = jobModel.seaEQ || []
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
          jobModel.containerUsages = jobModel.containerUsages || []
          jobModel.containers = jobModel.containers || []
          jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
          jobModel.surchargeTerms = jobModel.surchargeTerms || []
          jobModel.backUpWarehouseInfo = jobModel.backUpWarehouseInfo || []
          currentTab.onShow(jobModel.getData(), true)
          // 延迟执行，避免阻塞页面渲染
          await sleep(5)
        }
      } else if (action === 'edit') { // CARGO-9583 编辑时，重新加载费用
        if (selectedRow.differenceJobFields) {
          selectedRow.isCompleteRow = true
          if (selectedRow.seaEQ && selectedRow.seaEQ.length > 0) {
            ContainerUtil.autoJustContainerUsages(selectedRow)
          }
        } else {
          selectedRow.version = 0
          selectedRow.charges = ''
          selectedRow.cargoDoc = ''
          selectedRow.seaCargoDoc = ''
          // CARGO-39416 HBL 提单种类 不可选择问题
          selectedRow.jointSlavesHBL = ''
          selectedRow.isCompleteRow = false
          // CARGO-31170 查原因 件毛体数据自动清空
          if (selectedRow.masterFlag) {
            selectedRow.lclSlaves = ''
          }
          await new SeaExportJob(this.job).getSeaCargoDoc()
          const data = this.job.seaCargoDoc.find((item) => {
            return item.docType === 'HBL'
          })
          if (data) {
            this.customerSelfRelease = data.customerSelfRelease
          }
          if (this.activeTabName === 'tabPrePlanBooking' || this.activeTabName === 'tabPrePlanBookingLcl') {
            selectedRow.manifestInfos = ''
          }
        }
      }
      this.enablePrint = false
      this.visible = true
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      if (!this.isXhqAdd) {
        if (Number(this.config.get('MultipleJobViewMode')) !== 0 && this.$route && this.$route.query) {
          JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SE, action === 'look', this.$route.query.key || '')
        } else {
          JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SE, action === 'look', '')
        }
      }
      this.action = action
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      this.isOtherEdit = action === 'split' || action === 'copy'
      if (selectedRow.uuid) {
        this.rowData = [...rowData]
      } else {
        if (!selectedRow.lclNumber && !this.isOtherEdit) {
          this.context.opDepartment = null
          await Promise.all([this.context.getDefaultSeaExportJob(), this.context.getOpDepartment(this.office)])
          await this.buildNewRow(selectedRow)
        } else if (selectedRow.lclNumber > 0 && !this.isOtherEdit) {
          // CARGO-33616 主票下新增小票需要查询整拼类型对应的分单条款
          await this.getShippingTerm(selectedRow)
        }
        // [copydiag] 复制时 autoJust 前后 seaEQ/containers/containerUsages 现场追踪
        if (action === 'copy') {
          // eslint-disable-next-line no-console
          console.log('[copydiag] onShow.autoJust BEFORE', {
            seaEQ: (selectedRow.seaEQ || []).length,
            containers: Array.isArray(selectedRow.containers) ? selectedRow.containers.length : selectedRow.containers,
            containerUsages: Array.isArray(selectedRow.containerUsages) ? selectedRow.containerUsages.length : selectedRow.containerUsages,
            masterFlag: selectedRow.masterFlag
          })
        }
        if (action === 'copy' && selectedRow.seaEQ && selectedRow.seaEQ.length > 0) {
          if (selectedRow.masterFlag) {
            ContainerUtil.autoAdjustMasterContainer(selectedRow)
          } else {
            // 复制统一按 seaEQ 重建箱子：先清掉带入的 containers/containerUsages
            // （后端未返回、或源单内存里残留的旧 containers），否则 containers 数已 == eqQuantity，
            // autoJustContainerUsages 会判定"已满"而不补 containerUsages，导致集装箱 tab 箱货信息空白。
            selectedRow.containers = []
            selectedRow.containerUsages = []
            ContainerUtil.autoJustContainerUsages(selectedRow, 'copy')
          }
        }
        if (action === 'copy') {
          // eslint-disable-next-line no-console
          console.log('[copydiag] onShow.autoJust AFTER', {
            containers: Array.isArray(selectedRow.containers) ? selectedRow.containers.length : selectedRow.containers,
            containerUsages: Array.isArray(selectedRow.containerUsages) ? selectedRow.containerUsages.length : selectedRow.containerUsages
          })
        }
        // CARGO-53866 东丽 新增复制业务 销售默认带入当前登录人
        await JobUtils.loadingDlwlSales(selectedRow, this)
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...rowData, selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        await this.onRowClicked({ data: selectedRow })
      })
      if (action === 'look') {
        this.getImGroupFunc({ data: selectedRow })
        const cfg = LocalStorageUtils.getConfiguration('SESopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
        const logDialogVisible = LocalStorageUtilsNew.getConfiguration('SEDataUpdateLogDialogVisible')
        this.dataUpdateLogDialog.visible = !!logDialogVisible
      }
    },
    // sop 双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    // sop 关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', false)
    },
    // log 关闭处理
    dataUpdateLogDialogClose() {
      this.dataUpdateLogDialog.defaultIsExpand = true
      LocalStorageUtilsNew.setConfiguration('SEDataUpdateLogDialogVisible', false)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载配置项
    loadConfigData() {
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.btnInfo.visible.sendBackBookingButton = Number(this.config.get('sendBackBookingButton')) === 1
      this.commonInfo.reqInputCharge = Number(this.config.get('saveCharge')) === 1
      this.commonInfo.isBookingFeeMandatoryAppliedGlobally = Number(this.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
      this.commonInfo.allSubmitFcl = Number(this.config.get('AllSubmitFcl')) === 1
      this.commonInfo.isPrintCommit = Number(this.config.get('isPrintCommit')) === 1
      this.commonInfo.isCopySellingCharge = Number(this.config.get('isCopySellingCharge')) === 1
      this.commonInfo.needConfirmDuplicateWarehouseNo = Number(this.config.get('needConfirmeDuplicateWarehouseNo')) === 1
      this.commonInfo.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      this.commonInfo.overwriteJobRefNoBySEconvertSI = Number(this.config.get('OverwriteJobRefNoBySEconvertSI')) === 1
      this.sendBranchSelectObjectOrigin = this.config.get('SendBranchSelectObject')
      this.readSendBranchSelectObject()
      this.tabInfo.visible.oujianCustomsInfo = Number(this.config.get('openOujianCustoms')) === 1
      this.commonInfo.showCombinedManifest = Number(this.config.get('CombinedManifest')) === 1
      this.commonInfo.poItemsTabViewModel = Number(this.config.get('PoItemsTabViewModel')) === 1
      this.toExoSystemOC = Number(this.config.get('ToExoSystem')) === 2
      this.toExoSystemEAS = String(this.config.get('ToExoSystem')) === 'EAS'
      this.toExoSystemJYD = this.config.get('ToExoSystem') === 'JYD'
      this.toExoSystemTP = this.config.get('ToExoSystem') === 'TP'
      this.toExoSystemDLWL = this.config.get('ToExoSystem') === 'DLWL'
      this.toExoSystemZY = this.config.get('ToExoSystem') === 'zy'
      this.commonInfo.chargeSyncNeedConfirm = Number(this.config.get('ChargeSyncNeedConfirm')) === 1
      this.jingyuWarehouse = Number(this.config.get('JingyuWarehouse')) === 1
      this.enableCommission = Number(this.config.get('enableCommission')) === 1
      this.commonInfo.copyFromJob = Number(this.config.get('CopyFromJob')) === 1
      this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
      this.loadDataTrackingConfig()
    },
    readSendBranchSelectObject() {
      this.sendBranchWindow.items = []
      const temArr = stringToNumArray(this.config.get('SendBranchSelectObject'))
      let arr = []
      for (let temp of temArr) {
        if (temp === 3) { // 3控制操作显示并必填
          this.sendBranchWindow.opNotNull = true
          temp = 1
        }
        arr.push(temp)
      }
      if (arr.includes(2)) {
        this.sendBranchSelectObject = 2
        arr = [0, 1]
      } else if (arr.includes(4)) {
        // 4控制仅显示航线负责人
        this.sendBranchSelectObject = 4
        arr = [4]
      } else {
        // 1 控制操作显示， 3控制操作显示并必填
        this.sendBranchSelectObject = arr[0] || 0
      }
      for (const selectObject of arr) {
        this.sendBranchWindow.items.push({
          selectObject,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        })
      }
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      const rowBackup = lodash.cloneDeep(row)
      const isNew = !Object.keys(row).length
      // 填充默认值
      new SeaExportJob(row).fillDefaultValue()
      row.path = ''
      row.lob = this.lob
      row.cargoType = 'GC'
      row.cargoSource = 'NC'
      row.typeHBL = 1
      row.typeMBL = 1
      row.portCode = this.$t('SeaExport.PlsSeeEIR')
      row.paymentTermHBL = 'PP'
      row.paymentTermMBL = 'PP'
      row.opOffice = this.office.officeId
      row.loadingPortCode = this.office.seaport
      row.fba = this.isFba // 是否fba业务
      if (this.context.opDepartment && Number(this.context.opDepartment.departmentId) > 0) {
        row.op = this.user.userId
        if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === this.office.officeId) {
          row.opDepartment = this.user.defaultDepId
        } else {
          row.opDepartment = this.context.opDepartment.departmentId
        }
      }
      if (row.masterFlag) {
        row.cargoSource = ''
        row.paymentTermHBL = ''
        row.containerLoadType = 'LCL'
      } else {
        row.freightTermHBL = 'CY-CY'
        row.containerLoadType = 'FCL'
      }
      row.tradeTerm = '110'
      row.taxNature = 0
      Object.assign(row, this.context.defaultSeaExportJob)
      if (row.masterFlag) {
        row.dispatchingPlace = ''
        row.paymentTermHBL = ''
        row.freightTermHBL = ''
      }
      if (!isNew && !row.masterFlag) {
        Object.keys(row).forEach(key => {
          if (rowBackup[key]) {
            row[key] = rowBackup[key]
          }
        })
      }
      await this.getShippingTerm(row)
      await JobUtils.loadPlaceOfDeliveryRegion(row)
      // OCR识别，补录信息的时候，需要根据业务港口带出HBL,MBL的港口信息
      if (row.salesChannel === SystemConstants.SALES_CHANNEL_OCR_RECOGNITION.code && row.seaCargoDoc && row.seaCargoDoc.length > 0) {
        if (row.dischargingPortCode && Number(this.config.get('SyncPOD')) === 1) {
          row.destinationPortCode = row.dischargingPortCode || ''
        }
        for (const cargoDoc of row.seaCargoDoc) {
          new SeaCargoDoc(cargoDoc).fillDefaultValue()
          await SeaCargoDoc.copyInfoFromSeaExportJob(row, cargoDoc)
        }
      }
    },

    /**
     * 获取整拼类型对应的运输条款
     * @param row
     * @returns {Promise<void>}
     */
    async getShippingTerm(row) {
      // 判断客户是否有维护默认的主单和分单运输条款
      // CARGO-30761 主单/分单运输条款优先取用户保存默认值
      const shippingTermList = await getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm)
      if (shippingTermList && shippingTermList.length > 0) {
        if (!row.freightTerm) {
          for (const shippingTerm of shippingTermList) {
            const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
            let isFind = false
            if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
              for (const item of shippingTermOperationTypes) {
                if (item.containerLoadType === row.containerLoadType && item.mbl && item.lob === 'SE') {
                  isFind = true
                  break
                }
              }
            }
            if (isFind) {
              row.freightTerm = shippingTerm.code
              break
            }
          }
        }
        if (!row.freightTermHBL && !row.masterFlag) {
          for (const shippingTerm of shippingTermList) {
            const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
            let isFind = false
            if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
              for (const item of shippingTermOperationTypes) {
                if (item.containerLoadType === row.containerLoadType && !item.mbl && item.lob === 'SE') {
                  isFind = true
                  break
                }
              }
            }
            if (isFind) {
              row.freightTermHBL = shippingTerm.code
              break
            }
          }
        }
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getModel().rowsToDisplay
      this.gridApi.clearFocusedCell()
      // this.$logger.log('nodes', nodes)
      // this.$logger.log('this.rowData', this.rowData)
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid || item.data.jobUuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    tabToNextCell(e) {
      if (!e.nextCellPosition) {
        return e.previousCellPosition
      }
      const { column, rowIndex } = e.nextCellPosition
      if (this.action !== 'look' || !column) return
      const { rowsToDisplay } = this.gridOptions.api.getModel()
      const curNode = rowsToDisplay[rowIndex]
      curNode.setSelected(true)
      this.changeJob(curNode)
      return e.nextCellPosition
    },
    onCellClicked(event) {
      this.changeJob(event)
      this.getImGroupFunc(event)
    },
    async onCellDoubleClicked(event) {
      let data = event.data
      // 若选中提单拆并单,则需要找到其父级job
      if (data.dataType && Number(data.dataType) !== 1 && Number(data.dataType) !== 2 && data.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === data.jobUuid) {
            data = item
            break
          }
        }
      }
      if (this.openMultiple && data.jobNo === this.$route.query.key) {
        return
      }
      this.gridApi.setRowData(this.rowData)
      this.setGridSelect(this.currentRow)
      if (this.viewJobNoSet.has(data.jobNo)) {
        if (this.isFba) {
          this.$router.push({ name: 'FBABookingNew', query: { openNew: true, key: data.jobNo }})
        } else {
          this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: data.jobNo }})
        }
      } else {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        const rowData = deepCopy(this.rowData)
        this.reset(rowData)
        if (this.isFba) {
          this.$router.push({ name: 'FBABookingNew', query: { openNew: true, key: data.jobNo }, params: { rowData, activeTabName: this.activeTabName }})
        } else {
          const action = Number(cache.config.get('JobDirectEditingStatus')) === 1 && data.jobState === 0 && !JobUtils.isBlockJob(data) && (await SecurityUtil.canEdit(data, false)) ? 'edit' : 'look'
          this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: data.jobNo }, params: { rowData, action, activeTabName: this.activeTabName }})
        }
      }
    },
    // 左侧列表切换job
    async changeJob(event) {
      if (this.disabledChangeJob) {
        this.setGridSelect(this.currentRow)
        this.$message.warning(this.jobChangeDisabledTip)
        return
      }
      console.log('oncrowclicked')
      let result = event.data
      // 若选中提单拆并单,则需要找到其父级job
      if (result.dataType && Number(result.dataType) !== 1 && Number(result.dataType) !== 2 && result.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === result.jobUuid) {
            result = item
            break
          }
        }
      }
      if (result) {
        const action = Number(cache.config.get('JobDirectEditingStatus')) === 1 && result.jobState === 0 && !JobUtils.isBlockJob(result) && (await SecurityUtil.canEdit(result, false)) ? 'edit' : 'look'
        if (this.openMultiple) {
          if (result.jobNo === this.$route.query.key) {
            return
          }
          this.gridApi.setRowData(this.rowData)
          this.setGridSelect(this.currentRow)
          if (this.viewJobNoSet.has(result.jobNo)) {
            this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: result.jobNo }})
          } else {
            if (Number(this.config.get('MultipleJobViewMode')) === 2) {
              const rowData = deepCopy(this.rowData)
              this.reset(rowData)
              this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: result.jobNo }, params: { rowData, action, activeTabName: this.activeTabName, replace: true }})
            }
          }
        } else {
          if (this.viewJobNoSet.has(result.jobNo)) {
            this.gridApi.setRowData(this.rowData)
            this.setGridSelect(this.currentRow)
            this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: result.jobNo }})
          } else {
            // 重新数据库中加载job
            this.isGetNewJobInfoFromDb = true
            result.version = 0
            for (const key in result) {
              if (typeof result[key] === 'object') {
                result[key] = ''
              }
            }
            this.action = action
            this.onRowClicked({ data: result })
            // console.log('changeJob====', event.data, event.data.seaEQ, event.data.lclSlaves)
          }
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      if (!event.data) {
        return
      }
      let job = event.data
      const jobVersion = job.version
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            job = item
            break
          }
        }
      }

      this.setGridSelect(job)
      let loadCooperate = false
      // 加载job详细信息
      if (!job.isCompleteRow || this.isGetNewJobInfoFromDb) {
        const jobModel = new SeaExportJob(job)
        if (job.uuid) {
          if (!jobVersion || jobVersion === 0) job.version = 0 // version为0时可以重新加载job
          this.isLoadingData = true
          try {
            await jobModel.loadJobRelated({
              job: true, // 脏数据，需要重新载入
              seaEQ: true,
              lclSlaves: job.masterFlag,
              charges: true,
              warehouseIn: true,
              warehouseInfo: true,
              trucking: true,
              dischargingTrucking: true,
              destPortCustomsDataList: true,
              lclMaster: !job.masterFlag,
              seaCargoDoc: true,
              containerUsages: true,
              containers: true,
              cargoBulkDetail: !job.masterFlag,
              surchargeTerms: !job.masterFlag || (ContainerLoadType.BC_CARGO_TYPE_FCL.code === job.containerLoadType && job.masterFlag),
              backUpWarehouseInfo: true,
              manifestInfos: true,
              fbaJob: job.fba, // fba业务就加载
              orderCenterMode: this.useOrderCenterMode,
              cooperateBranchId: this.cooperateBranchId,
              jobWarehouseNos: this.jingyuWarehouse // 开了参数的有需要加载多进仓编号列表
            })
            loadCooperate = true
            if (jobModel.dischargingPortDoor || jobModel.usCustomsClearance) {
              jobModel.destinationPortService = true
            }
            if (jobModel.dischargingTrucking.length > 0) {
              // 需要排序
              sortByMultiField(jobModel.dischargingTrucking, ['truckOrderNo'], false)
            }
          } finally {
            this.isLoadingData = false
          }
          // 过滤脏数据（seaEQ、containers、containerUsages）
          if (jobModel.lclMasterUuid && [ContainerLoadType.LCL_CARGO_TYPE.code, ContainerLoadType.BC_CARGO_TYPE.code].includes(jobModel.containerLoadType)) {
            if (jobModel.seaEQ) {
              jobModel.seaEQ = []
            }
            if (jobModel.containers) {
              jobModel.containers = []
            }
            if (jobModel.containerUsages) {
              jobModel.containerUsages = jobModel.containerUsages.filter(p => !p.container || p.container.jobUuid === jobModel.lclMasterUuid)
            }
          }
          // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
          if (!jobModel.masterFlag) {
            ContainerUtil.buildContainerUsages(job)
          }

          if (!job.path) {
            this.setBasicData(job)
            this.gridApi.refreshCells({ force: true })
          }

          // 检查主票下的小票，如果主票有修改，同步将小票放在修改列表中
          if (job.lclSlaves && job.lclSlaves.length > 0) {
            const index = this.saveJobNos.findIndex(p => p.uuid === job.uuid)
            if (index >= 0) {
              for (const slave of job.lclSlaves) {
                const row = this.rowData.find(p => p.uuid === slave.uuid)
                if (row) {
                  for (const key in slave) {
                    if (typeof row[key] === 'object' || key === 'version') {
                      continue
                    }
                    row[key] = slave[key]
                  }
                  this.saveJobNos.push(row)
                }
              }
            }
          }
        } else {
          jobModel.seaEQ = jobModel.seaEQ || []
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.jobWarehouseNos = jobModel.jobWarehouseNos || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.dischargingTrucking = jobModel.dischargingTrucking || []
          jobModel.destPortCustomsDataList = jobModel.destPortCustomsDataList || []
          jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
          jobModel.containerUsages = jobModel.containerUsages || []
          jobModel.containers = jobModel.containers || []
          jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
          jobModel.surchargeTerms = jobModel.surchargeTerms || []
          jobModel.backUpWarehouseInfo = jobModel.backUpWarehouseInfo || []
        }
        // 其他页签冗余字段
        this.otherParams(job)
        job.isCompleteRow = true
        this.isGetNewJobInfoFromDb = false
        // console.log('onRowClicked====', this.currentRow, this.currentRow.seaEQ, this.currentRow.lclSlaves)
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && job.cooperate && job.cooperate.uuid) {
          console.log('job.cooperate===', job.cooperate)
          // 记录原值
          job.opOffice_original = job.opOffice // 分公司
          job.op_original = job.op // 操作
          job.csr_original = job.csr // 客服
          job.overseaOp_original = job.overseaOp // 海外操作
          job.dc_original = job.dc // 单证
          job.planner_original = job.planner // 航线负责人
          job.opDepartment_original = job.opDepartment // 操作部门
          //
          job.opOffice = job.cooperate.branchId // 分公司
          job.op = job.cooperate.opId // 操作
          job.csr = job.cooperate.csrId // 客服
          job.overseaOp = job.cooperate.overseaOp // 海外操作
          job.dc = job.cooperate.dcId // 单证
          job.planner = job.cooperate.planner // 航线负责人
          job.opDepartment = job.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(job, job.cooperate)
        }
      }
      if (this.toExoSystemZY) {
        // 中文品名
        job.cargoChineseName_original = job.cargoChineseName
        // 英文品名
        job.cargoEnglishName_original = job.cargoEnglishName
      }
      job.warehouseNo_original = job.warehouseNo
      this.currentRow = job
      this.initInfo()
      this.resetParamsOfTab()
      // 记录仓库初始值
      this.paramsOfTab.warehouseRecord = this.paramsOfTab.warehouseCmp || 0
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.processingPromiseList = []
      this.basicInfoVisible = false
      if (!event.skipTabHandle) {
        this.$nextTick(() => {
          this.resetActiveTabName()
          this.handleTabClick()
        })
      }
      this.closePreviewDialog()
      this.loadInstructionBtns()
    },
    // 加载指令按钮
    async loadInstructionBtns() {
      const useHqSet = UICustomUtil.getUseHqSet(UICustomConstants.SEA_BOOKING_BASIC, this.$store.getters.currentOfficeId)
      const res = await getJobInstructions({
        pageType: UICustomConstants.SEA_BOOKING_BASIC,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet,
        jobKey: this.currentRow.uuid,
        lob: this.currentRow.lob
      })
      this.instructioinBtns = res.data
    },
    otherParams(job) {
      job.truckingPage = false
      const actAtdDate = DateUtils.customFormat(job.actualUnBerthPlanDate, 'YYYY-MM-DD')
      const atd = DateUtils.customFormat(job.atd, 'YYYY-MM-DD')
      // 基本页签atd为空 或者 atd与实际离泊时间初始值相等
      if (!atd || actAtdDate === atd) {
        job.needSynchronizationAtd = true
      } else {
        job.needSynchronizationAtd = false
      }
      const actAtaDate = DateUtils.customFormat(job.actualArrivalTime, 'YYYY-MM-DD')
      const ata = DateUtils.customFormat(job.ata, 'YYYY-MM-DD')
      // 基本页签atd为空 或者 atd与实际离泊时间初始值相等
      if (!ata || actAtaDate === ata) {
        job.needSynchronizationAta = true
      } else {
        job.needSynchronizationAta = false
      }
      job.manifestInfoPage = false
      if (job.warehouseInfo && job.warehouseInfo.length > 0) {
        job.warehouseName = job.warehouseInfo[0].warehouseName
      }
      this.vesselAndVoyage = job.vessel + '_' + job.voyageFlight
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理（在编辑状态下）
    async endTabHandler(tabName) {
      if (!this.action || this.action === 'look') {
        return
      }
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    async handleTabClick() {
      // CARGO-9583 详情打印控件应置灰处理
      const tabs = ['tabTradeDetail', 'tabTradeCommission', 'tabAdvanceCharge', 'tabSopState', 'tabFileHistory', 'tabFile']
      this.enablePrint = tabs.includes(this.activeTabName)
      const oldSize = this.pendTabSet.size
      this.pendTabSet.add(this.activeTabName)
      const isRefresh = this.pendTabSet.size > oldSize
      // this.$logger.log('handleTabClick-isRefresh', isRefresh)
      this.$nextTick(() => {
        if (this.activeTabName === 'tabCharges') {
          this.showBasicInfoWindow()
        }
        let loading = null
        if (isRefresh) {
          loading = getLoading4Cxt(this.activeTabName === 'tabVesselEq' ? this : this.$refs[this.activeTabName])
        }
        console.log('切换了==============')
        if (!this.showMscSupplement && this.activeTabName === 'tabMscBooking') {
          if (this.$refs['tabBookingFCL']) {
            this.activeTabName = 'tabBookingFCL'
          }
        }
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh, this.pendTabSet.size).finally(() => {
          if (loading) {
            ensureExecuteSuccess(() => !this.isLoadingData).then(() => {
              setTimeout(() => {
                loading.close()
              }, 500)
            })
          }
        })
        if (this.slaveCustomsDeclarationEnable && this.activeTabName === 'tabContainer') {
          if (this.$refs['tabBookingFCL']) {
            const oldSize = this.pendTabSet.size
            this.pendTabSet.add('tabBookingFCL')
            const isRefresh = this.pendTabSet.size > oldSize
            this.$refs['tabBookingFCL'].onShow(this.paramsOfTab, isRefresh)
          }
        }
      })
    },
    // 附加小票
    appendSlaves(rows) {
      const result = [...rows]
      const masterUuids = Array.from(rows.filter(p => p.masterFlag), p => p.uuid)
      if (masterUuids.length > 0) {
        const uuids = Array.from(rows, p => p.uuid)
        for (const item of this.rowData) {
          if (item.lclMasterUuid && masterUuids.includes(item.lclMasterUuid) && !uuids.includes(item.uuid)) {
            result.push(item)
          }
        }
      }
      return result
    },
    triggerEditEvent() {
      this.editEventFlag = true
    },
    // 编辑
    async editHandler(action) {
      if (this.currentRow.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(this.currentRow, false)) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.$refs.cargoLeftRightResize.hideLeft()
      this.btnGroupLook.style.display = 'none'
      this.btnGroupEdit.style.display = ''
      this.$refs.cargoButtonGroupSlider.resizeHandler()
      // 延迟执行，避免阻塞页面渲染
      setTimeout(() => {
        this.againShow(action)
      }, 5)
    },
    triggerAddEvent(masterFlag = false) {
      if (masterFlag) {
        this.addMasterEventFlag = true
      } else {
        this.addEventFlag = true
      }
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      const selectedRow = this.isNew ? row || {} : this.currentRow
      if (this.action !== 'edit' && selectedRow.differenceJobFields) {
        selectedRow.differenceJobFields = null
        selectedRow.differenceBookingFields = null
        selectedRow.differencePrePlanFields = null
        selectedRow.differenceMblFields = null
        selectedRow.differenceHblFields = null
        selectedRow.version = 0
        selectedRow.seaEQ = ''
        selectedRow.charges = ''
        selectedRow.cargoDoc = ''
        selectedRow.seaCargoDoc = ''
        selectedRow.manifestInfos = ''
        selectedRow.isCompleteRow = false
      }
      this.onShow(action, this.rowData, selectedRow)
    },
    sinceSingle(val) {
      this.customerSelfRelease = val
      console.log('val', val)
    },
    // async updateDocCfmState() {
    //   this.$refs[this.activeTabName].updateCfm()
    // },
    async triggerSaveEvent() {
      this.lockHBLReleaseStateBeforeReleaseVerify = Number(this.config.get('LockHBLReleaseStateBeforeReleaseVerify'))
      // customerSelfRelease===1为客户自出单
      if (this.action !== 'add' && this.action !== 'copy' && this.lockHBLReleaseStateBeforeReleaseVerify === 2) {
        await new SeaExportJob(this.job).getSeaCargoDoc()
        if (this.job.signHBL) {
          const data = this.job.seaCargoDoc.find((item) => {
            return item.docType === 'HBL'
          })
          if (this.customerSelfRelease === 1) {
            const params = {
              uuid: data.uuid,
              state: 0,
              setting: 0
            }
            const res = await manualTriggerAndUpate(params)
            if (res.ok) {
              if (res.data.result === 2) {
                const messages = []
                const createElement = this.$createElement
                messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.businessNumber') + res.data.jobNo))
                if (res.data.mbl) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.mblNo') + res.data.mbl))
                }
                if (res.data.hbl) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.hblNo') + res.data.hbl))
                }
                if (res.data.tip.accountCompanyName) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.accountCompanyName))
                }
                if (res.data.tip.accountOverCreditLimitDate) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
                }
                if (res.data.tip.accountOverCreditLimitAmount) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.accountOverCreditLimitAmount)))
                }
                if (res.data.tip.agentCompanyName) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.agentCompanyName))
                }
                if (res.data.tip.agentOverCreditLimitDate) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
                }
                if (res.data.tip.agentOverCreditLimitAmount) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.agentOverCreditLimitAmount)))
                }
                if (res.data.tip.customerCompanyName) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.customerCompanyName))
                }
                if (res.data.tip.customerOverCreditLimitDate) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
                }
                if (res.data.tip.customerOverCreditLimitAmount) {
                  messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.customerOverCreditLimitAmount)))
                }
                messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.unableSave')))
                messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.cantUse')))
                messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.triggerRemind')))
                await this.$confirm('', {
                  title: this.$t('ReleaseNotes.lineCreditDialog.title'),
                  message: createElement('div', null, messages),
                  confirmButtonText: this.$t('ReleaseNotes.lineCreditDialog.cancel'),
                  showCancelButton: false,
                  showClose: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  type: 'warning'
                }).then(() => {
                  const tabHBL = this.$refs.tabHBL
                  tabHBL.modifyCustomerSelfRelease()
                  this.canSave = false
                  setTimeout(() => {
                    this.saveEventFlag = true
                  }, 5)
                })
                return
              }
            }
            if (res.data.result === 1) {
              // 获取放单接口返回的版本号，更新保存时传入的版本号
              const tabHBL = this.$refs.tabHBL
              tabHBL.updateVersion(res.data.currentSeaCargoDocVersion)
              this.$message.success(this.$t('ReleaseNotes.lineCreditDialog.through'))
            }
          }
        }
      }
      this.canSave = false
      setTimeout(() => {
        this.saveEventFlag = true
      }, 5)
    },
    // 保存海运业务【保存业务相关数据】
    async save() {
      // this.canSave = false
      this.doSaving = true
      const loading = getLoading4Cxt(this)
      try {
        if (this.processingPromiseList.length > 0) {
          const processingPromiseList = [...this.processingPromiseList]
          for (const processingPromise of processingPromiseList) {
            try {
              await processingPromise
            } catch (err) {
              console.log(err)
            }
          }
        }
        // 当前页签结束后的处理
        if (this.activeTabName) {
          await this.endTabHandler(this.activeTabName)
        }
        const body = {}
        try {
          const pendTabSet = [...this.pendTabSet, 'other']
          for (const item of pendTabSet) {
            let tabData = null
            if (item !== 'other') {
              // 各页签的保存数据
              const getSubmitData = this.$refs[item].getSubmitData
              if (getSubmitData && typeof getSubmitData === 'function') {
                /* 获取各页签需要保存的数据 */
                const result = this.$refs[item].getSubmitData()
                if (result instanceof Promise) {
                  tabData = await result
                } else {
                  tabData = result
                }
              }
            } else {
              // 被联动修改了的数据
              tabData = this.context.modifiedData
            }
            console.log('tabData========', tabData)
            if (!tabData) continue

            // this.$logger.log('tabData' + item, tabData)
            // 将不同页签相同key的集合进行数据合并
            for (const key in tabData) {
              const tabValue = tabData[key]
              // this.$logger.log('tabValue：' + item, tabValue)
              if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
              const bodyValue = body[key]
              // this.$logger.log('bodyValue：' + item, bodyValue)
              if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
              // 将数组进行合并
              if (Array.isArray(tabValue)) {
                //
                if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                  const bodyMap = new Map()
                  if (bodyValue && bodyValue.length > 0) {
                    for (const bodyKey of bodyValue) {
                      if (!bodyKey) continue
                      if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                    }
                  }
                  if (tabValue && tabValue.length > 0) {
                    for (const tabKey of tabValue) {
                      if (!tabKey || bodyValue.includes(tabKey)) continue
                      if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                      bodyValue.push(tabKey)
                    }
                  }
                } else {
                  tabValue.push(bodyValue)
                  body[key] = tabValue
                }
                delete tabData[key]
              }
            }
            // 去除提单（MBL、HBL）中的重复值
            if (body.seaCargoDoc) {
              const list = body.seaCargoDoc
              const mblList = []
              const hblList = []
              for (let i = list.length - 1; i >= 0; --i) {
                if (list[i].docType === CargoDocConsts.MBL) {
                  mblList.push(list[i])
                  list.splice(i, 1)
                } else if (list[i].docType === CargoDocConsts.HBL) {
                  hblList.push(list[i])
                  list.splice(i, 1)
                }
              }
              if (mblList.length > 0) {
                list.push(mblList.find(p => p.uuid) || mblList[mblList.length - 1])
              }
              if (hblList.length > 0) {
                list.push(hblList.find(p => p.uuid) || hblList[hblList.length - 1])
              }
            }
            // 待删除的提单
            if (this.paramsOfTab.deletedCargoDocs) {
              body.seaCargoDoc = body.seaCargoDoc || []
              for (const deletedCargoDoc of this.paramsOfTab.deletedCargoDocs) {
                deletedCargoDoc.deleted = true
                body.seaCargoDoc.push(deletedCargoDoc)
              }
            }
            Object.assign(body, tabData)
            // this.$logger.log('页签名称：' + item, tabData)
          }
          // 还原接单分公司
          if (this.useOrderCenterMode) {
            if (body.job && body.job.cooperate && body.job.cooperate.uuid) {
              body.job = { ...body.job }
              body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
              body.job.op = body.job.op_original || body.job.op // 操作
              body.job.csr = body.job.csr_original || body.job.csr // 客服
              body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
              body.job.dc = body.job.dc_original || body.job.dc // 单证
              body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
              body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
              JobUtils.restoreJobFromCooperateInfo(body.job)
            }
          }
          // this.$logger.log('charges============1', body.charges)

          // 判断箱子数量是否超过默认值，超过就给提示
          const containerNum = Number(this.config.get('ContainerMaxNum'))
          if (body.seaEQ) {
            let containerCount = 0
            for (const eq of body.seaEQ) {
              containerCount += (eq.eqQuantity ? Number(eq.eqQuantity) : 0)
            }
            if (containerCount > containerNum) {
              this.$message.warning(this.$t('SystemMaintenance.ContainerMaxNumTip', [containerNum]))
              return
            }
          }
          if ((body.containers && body.containers.length > containerNum) || (body.containerNums && Number(body.containerNums) > containerNum)) {
            this.$message.warning(this.$t('SystemMaintenance.ContainerMaxNumTip', [containerNum]))
            return
          }

          // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
          this.doNotClickTabData(body)
          // 校验目的港清关申报货值
          if (this.pendTabSet.has('tabDestinationCustomsData') && this.$refs.tabDestinationCustomsData) {
            if (!this.$refs.tabDestinationCustomsData.validateDeclaredValue()) {
              return
            }
          }
          // 确保 body 中包含 job 数据（修复：定位在非委托页签保存时 job 数据丢失）
          if (!body.job && this.paramsOfTab) {
            body.job = { ...this.paramsOfTab }
          }
          // this.$logger.log('charges============2', body.charges)
          // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
          if (Reflect.has(body, 'job') && body.job) {
            if (body.job === this.paramsOfTab) {
              body.job = { ...body.job }
            }
            for (const key in body.job) {
              // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
              if (typeof body.job[key] === 'object') delete body.job[key]

              // 保存时需要将sop显示列排除
              if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
            }
          }
          // this.$logger.log('charges============3', body.charges)
          // 主票 新增/加入小票 使用
          if (this.currentRow.lclNumber) {
            const job = this.currentRow
            if (job.warehouseInfo) {
              Object.assign(body, { warehouseInfo: job.warehouseInfo })
            }
            if (job.trucking) {
              Object.assign(body, { truckingInfo: job.trucking })
            }
            if (job.seaCargoDoc) {
              Object.assign(body, { seaCargoDoc: job.seaCargoDoc })
            }
          }
          // 针对复制 且未切换过msc页签场景
          if (this.action === 'copy' && this.currentRow.mscSupplement) {
            if (!this.showMscSupplement) {
              this.currentRow.mscSupplement = null
            }
            Object.assign(body, { mscSupplement: this.currentRow.mscSupplement })
          }
          if (this.isNew) {
            // 初始化舱单数据格式化信息
            if (!body.manifestInfos) {
              const manifestInfo = new ManifestInfo().fillDefaultValue().getData()
              await PrePlanBookingUtil.newCreateSyncWithJob(manifestInfo, this.currentRow, body.seaCargoDoc)
              body.manifestInfos = [manifestInfo]
            }
          }
          cleanCircleObject(body)
          if (body.containerUsages) {
            for (const item of body.containerUsages) {
              if (item.container && item.container.containerUsage === '') { // 避免后台fastjson解析报错
                item.container.containerUsage = null
              }
            }
          }
          if (body.charges) {
            for (let i = body.charges.length - 1; i >= 0; --i) {
              const item = body.charges[i]
              // CARGO-21740 海出-复制新增业务中的费用，保存时删除的费用又会随机出现一条
              // 这里先移除数据，避免下面去重时再次移除
              if (item.deleted) {
                body.charges.splice(i, 1)
                continue
              }
            }
            JobUtils.handleChargeForSave(body)
          }
          this.$logger.log('body', body)
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message && err.message !== this.$t('CargoMsg.Cargo_QuantityWeightCubageChange')) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            return
          }
          throw err
        }
        try {
          // 在保存前进行校验
          const bodyJob = body.job || null
          if (!(await this.pm.checkBeforeSave(bodyJob))) {
            return
          }
        } catch (err) {
          throw err
        }

        // 获取复制份数
        if (Reflect.has(body, 'job') && Reflect.has(body.job, 'copyNum') && Number(body.job.copyNum) > 1) {
          this.copyJobNum = Number(body.job.copyNum)
        }

        // 校验vgmInfo中参考号是否重复
        if (body.vgmInfoList && body.vgmInfoList.length > 0) {
          const seen = new Set()
          let referenceNoRepeat = false
          body.vgmInfoList.some(item => {
            if (seen.has(item.referenceNo)) {
              referenceNoRepeat = true
            } else {
              seen.add(item.referenceNo)
            }
          })
          console.log('referenceNoRepeat', referenceNoRepeat)
          if (referenceNoRepeat) {
            this.$message.error(this.$t('CargoMsg.Cargo_ReferenceNoRepeat'))
            return
          }
        }

        // 复制时校验费用名称是否被禁用
        if (this.action === 'copy') {
          const flag = await JobUtils.checkChargeItemDisabled(this, body.charges)
          if (!flag) {
            return
          }
        }

        // 保存 校验航交所是否申报或费用是否超限
        if (!await JobUtils.matchOpenPriceConfig(body, this.office.officeId, this)) {
          return
        }

        // CARGO-54098 个性需求评估 增加SOP特殊限制
        if (this.toExoSystemDLWL && !await JobUtils.checkExportControlledProduct(body.job, this)) {
          return
        }

        // CARGO-53261 14615中邮，敏感词管理校验需要双重提醒
        if (this.toExoSystemZY && !await JobUtils.checkZySensitiveWord(body.job, this)) {
          return
        }

        // 后端触发SOP使用
        if (!this.isNew) body.jobUuid = this.job.uuid

        // 保存业务时判断缓存M单和H单的提单方式是否变更
        if (body.seaCargoDoc && Number(this.config.get('ReleaseTypeDefaultValue')) === 4) {
          for (const doc of body.seaCargoDoc) {
            if (doc.docType === 'MBL') {
              const type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
              if (doc.releaseType && doc.releaseType !== type) {
                LocalStorageUtilsNew.setConfiguration('SE_MBL_BL_MODEL', doc.releaseType)
              }
            } else if (doc.docType === 'HBL') {
              const type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
              if (doc.releaseType && doc.releaseType !== type) {
                LocalStorageUtilsNew.setConfiguration('SE_HBL_BL_MODEL', doc.releaseType)
              }
            }
          }
        }

        // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
        await SopUtil.checkSopTemplate(body.job, this, body.seaEQ || null, body.containerUsages || null, this.sopTemplateConfig)
        // 处理vgm通道
        if (body.job && body.job.vgm) {
          // 当客户新增业务，然后浏览器缓存储的是海管家，但是实际上配置的是未斯，此时要更新为未斯
          if (body.job.vgmChannel === '') {
            let vgmChannel = LocalStorageUtils.getConfiguration('vgmChannel') || 0
            const { data: vasConfig } = await getConfigForCurrentTenant()
            if (vgmChannel > 0 && vasConfig > 0 && vasConfig !== vgmChannel) {
              vgmChannel = vasConfig
            }
            body.job.vgmChannel = vgmChannel
          } else if (!body.job.uuid && body.job.vgmChannel > 0) { // 新增的时候，比对通道是否正确
            const { data: vasConfig } = await getConfigForCurrentTenant()
            if (vasConfig > 0 && vasConfig !== body.job.vgmChannel) {
              body.job.vgmChannel = vasConfig
            }
          }
        }
        if (this.toExoSystemTP && body.job && !body.job.scNoType) {
          body.job.scNoType = SeaExportConstants.TYPE_RFA.code
        }
        // 若为自揽货 清空指定货代理取值
        if (body.job && body.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          body.job.designationAgent = 0
        }
        // CARGO-16870 验证规则节点增加“业务保存”
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        if (useCheckRule && body && body.hasOwnProperty('job') && body.job) {
          const hasCheckRuleForSaveJob = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_BUSINESS.code, this.$store.getters.currentOfficeId)
          if (hasCheckRuleForSaveJob) {
            const result = await JobUtils.checkBySaveJobNode({ ...body, charges: this.paramsOfTab.charges }, this.job.lob, CheckRuleConstants.NODE_SAVE_BUSINESS.code)
            if (result.needShowDialog) {
              loading.close()
              const callBack = async() => { await this.continueSaving(body, loading, true) }
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BUSINESS.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.continueSaving(body, loading, false)
            }
          } else {
            await this.continueSaving(body, loading, false)
          }
        } else {
          await this.continueSaving(body, loading, false)
        }
      } catch (err) {
        throw err
      } finally {
        loading.close()
        this.canSave = true
        this.doSaving = false
      }
    },
    // 更新MBL、HBL拆单编号
    updateCargoDocNo(seaCargoDoc) {
      if (!seaCargoDoc) {
        return
      }
      for (const item of seaCargoDoc) {
        if (!item.uuid) {
          continue
        }
        if (item.docType === CargoDocConsts.MBL2) {
          const row = this.rowData.find(p => p.uuid === item.uuid)
          if (row) {
            row.jobNo = item.mblNbr2
          }
        } else if (item.docType === CargoDocConsts.HBL2) {
          const row = this.rowData.find(p => p.uuid === item.uuid)
          if (row) {
            row.jobNo = item.hblNbr2
          }
        }
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const isSplit = this.action === 'split'
      const job = this.currentRow
      if (!body || !job || (!isCopy && !isSplit)) return
      const hasCopySeaEQ = isCopy && Array.isArray(job.seaEQ) && job.seaEQ.length > 0
      const hasCopyContainers = isCopy && Array.isArray(job.containers) && job.containers.length > 0
      const hasCopyContainerUsages = isCopy && Array.isArray(job.containerUsages) && job.containerUsages.length > 0
      // 复制独有
      if (isCopy) {
        if (!Object.prototype.hasOwnProperty.call(body, 'seaCargoDoc') && job.seaCargoDoc && job.seaCargoDoc.length > 0) {
          Object.assign(body, { seaCargoDoc: job.seaCargoDoc })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
          Object.assign(body, { warehouseInfo: job.warehouseInfo })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
          Object.assign(body, { truckingInfo: job.trucking })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'manifestInfos') && job.manifestInfos && job.manifestInfos.length > 0) {
          Object.assign(body, { manifestInfos: job.manifestInfos })
        }
        if (job.charges && job.charges.length > 0) {
          if (Object.prototype.hasOwnProperty.call(body, 'charges')) {
            for (const item of job.charges) {
              const index = body.charges.findIndex(p => p === item || (p.receivable === item.receivable && p.serialNumber && p.serialNumber === item.serialNumber))
              if (index < 0) {
                body.charges.push(item)
              }
            }
          } else {
            Object.assign(body, { charges: job.charges })
          }
        }
      }

      mergeCopyUntouchedTabData(body, job, this.action)

      // copy 时清空 container/containerUsage 的 uuid，避免后端 FK 外键约束失败
      if (isCopy) {
        cleanupCopiedContainerUuids(body)
        // copy 时 containers 的 uuid 全部为空（尚未 INSERT），后端会先保存顶层 containerUsages 再保存 containers，
        // 导致 OMS_CONTAINER_USAGE.CONTAINER_UUID 外键约束失败。
        // 装箱数据已包含在 containers[].containerUsage 中，会通过安全的嵌套路径保存：
        //   ContainerServiceImpl.saveContainer 先 INSERT container 生成 uuid，
        //   再用该 uuid 设置 containerUsage.containerUuid 后 INSERT。
        body.containerUsages = []
      }
      // 复制时不再将 containerUsages 赋值回去，装箱数据通过 containers[].containerUsage 嵌套路径由后端安全保存
      // 避免 containerUuid 为空导致 OMS_CONTAINER_USAGE 外键约束失败

      // 拆分主票独有
      if (isSplit) {
        if (!Object.prototype.hasOwnProperty.call(body, 'lclSlaves') && job.lclSlaves && job.lclSlaves.length > 0) {
          Object.assign(body, { lclSlaves: job.lclSlaves })
        }

        // todo 目前处理了从主票装箱拆分入口 被拆分主票的container,seqEq 信息
        if (job.sourceSeqEq) {
          if (job.sourceSeqEq.delseaEQUuids) {
            body.delseaEQUuids = job.sourceSeqEq.delseaEQUuids.join(',')
          }
          if (job.sourceSeqEq.updateSeaEq && job.sourceSeqEq.updateSeaEq.length > 0) {
            if (!body.seaEQ) {
              body.seaEQ = []
            }
            body.seaEQ.push(...job.sourceSeqEq.updateSeaEq)
          }
        }
      }
    },

    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      const job = obj.job || null
      for (const key in obj) {
        // 主票装箱信息循环引用特殊处理
        if (job && job.masterFlag && key === 'containers' && obj.containers && obj.containers.length > 0) {
          for (const container of obj.containers) {
            const containerUsages = container.containerUsages
            if (!containerUsages || containerUsages.length <= 0) break
            for (const containerUsage of containerUsages) {
              if (containerUsage.container) containerUsage.container = undefined
            }
          }
          continue
        }
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, masterFlag, copyNum, danUNNo) {
      //
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      const cacheSuffix = masterFlag ? lob + '_MASTER' : lob
      const copyOptions = normalizeSchemeContent(LocalStorageUtilsNew.getConfiguration(SEA_BOOKING_COPY_OPTIONS_CACHE_PREFIX + cacheSuffix) || {})
      if (masterFlag) {
        item.vesselEq = resolveLegacyVesselEqSelected(LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER'), copyOptions)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob + '_MASTER')
      } else {
        item.vesselEq = resolveLegacyVesselEqSelected(LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob), copyOptions)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
      }
      item.copyNum = copyNum
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      item.masterFlag = masterFlag
      item.location = this.location
      item.danUNNo = danUNNo
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            new SeaExportJob(copyJob).fillDefaultValue() // 数据补充完整
            this.setBasicData(copyJob)
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 保存剩下的新增小票业务【后台复制并保存】
    async saveLclJob(jobUuid, copyNum) {
      const item = {
        jobUuid,
        masterJobNo: this.job.masterJobNo || '',
        branchId: this.$store.getters.currentOfficeId,
        copyNum,
        all: true,
        copyOnly: false, // 是否是复制业务，新增业务日志时使用
        location: this.location
      }
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            new SeaExportJob(copyJob).fillDefaultValue() // 数据补充完整
            this.setBasicData(copyJob)
            copyJob.jobUuid = copyJob.uuid
            copyJob.parentUuid = copyJob.lclMasterUuid
            copyJob.path = copyJob.lclMasterUuid + ',' + copyJob.uuid
            copyJob.dataType = 2 // 小票
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    syncViewData(job) {
      let view = null
      if (this.openMultiple) {
        // 默认页签
        view = this.visitedViews.find(p => p.path === this.$route.path && (!p.query || !p.query.openNew || !p.query.key))
        if (view) {
          view.params.changedJobNos = view.params.changedJobNos || []
          view.params.changedJobNos.push(job.jobNo)
        }
      }
      // 多页签
      view = this.visitedViews.find(p => p.query && p.query.openNew && p.query.key && p.query.key === job.jobNo)
      if (view && (this.openMultiple && this.$route.query.key !== job.jobNo)) {
        view.params.isDirty = true
      }
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SE, true, this.job ? this.job.jobNo || '' : '')
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => {
      })
    },
    saveDefaultVal() {
      const loading = getLoading4Cxt(this)
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'SeaExportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    // 刷新
    refresh() {
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.job)
    },
    // 加载完job走这里
    initInfo() {
      this.updateControlsState()
      this.checkCrossTenantHistoryState()
      this.showJobState()
      this.showJobTitle()
      this.showMscSupplementFunc()
      this.checkProvisionPublishedStatus()
    },
    // 获取委托状态
    checkCrossTenantHistoryState() {
      if (this.job && this.job.uuid) {
        const company = this.context.companyList.find(p => p.cmpIdx === this.job.bookingAgent)
        if (company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0) {
          // 获取最新的委托状态：已发送、已查看、拒绝为“委托"按钮
          queryLatestState(this.job.jobNo).then(res => {
            this.queryLatestStateHandler(res)
          })
        } else {
          this.btnInfo.privilege.consignationCrossEnable = false
        }
      }
    },
    // 根据委托状态处理相关权限
    queryLatestStateHandler(event) {
      const latestState = event.data
      this.btnInfo.privilege.crossMoreSign = latestState < 3
      const company = this.context.companyList.find(p => p.cmpIdx === this.job.bookingAgent)
      this.btnInfo.privilege.consignationCrossEnable = company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0
      if (this.job.relatedJob && this.job.relatedJob && company.relateTenantId > 0 && !(latestState < 3)) {
        this.btnInfo.privilege.consignationCrossEnable = false
      }
    },
    // 刷新控制按钮
    updateControlsState() {
      const job = this.currentRow
      if (!job) return
      this.btnInfo.label.shutOutLabel = job.shutOut ? this.$t('SeaExport.CancelShutOut') : this.$t('SeaExport.ShutOut')

      this.btnInfo.visible.printFclProfit = false
      this.btnInfo.visible.printLclProfit = false
      if (job && job.jobState !== SystemConstants.SHUT_OUT && !job.masterFlag && (job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.SPECIAL_CARGO_TYPE.code)) {
        // CARGO-10506this.btnInfo.privilege.button_JobBooking_Submit ||
        this.btnInfo.visible.printFclProfit = (this.btnInfo.privilege.button_JobBooking_PrintProfit)
      }
      // 拼箱主票
      if (job && job.jobState !== SystemConstants.SHUT_OUT && (job.masterFlag || (job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code))) {
        // CARGO-10506this.btnInfo.privilege.button_JobBooking_Submit ||
        this.btnInfo.visible.printLclProfit = (this.btnInfo.privilege.button_JobBooking_PrintProfit)
      }
      // 撤回权限按钮
      if (this.btnInfo.privilege.button_SEBooking_cancelProfit || this.btnInfo.privilege.button_JobBooking_Retract) {
        this.btnInfo.visible.printReturn = false
        if (!this.isEditing && job && job.jobState === SystemConstants.COMMITED) {
          this.btnInfo.visible.printReturn = true
        }
      }
      if (this.btnInfo.privilege.button_JobBooking_Retract) {
        this.btnInfo.visible.cancelReturn = false
        if (!this.isEditing && job && job.jobState === SystemConstants.COMMITED) {
          this.btnInfo.visible.cancelReturn = true
        }
      }
      this.changeSendBranchBtn()
      this.loadCrossTenantSyncHistory()
    },
    // 内部委托按钮label控制
    changeSendBranchBtn() {
      // 发送分公司控制
      const _job = this.currentRow
      if (!_job) return
      let company = this.context.companyList.find(p => p.cmpIdx === _job.bookingAgent)
      this.btnInfo.privilege.consignationEnable = company && company.linkedBranchId > 0 && company.linkedBranchId !== _job.opOffice && (!_job.relatedJob)
      // CARGO-23488 详情页面切换业务，当前业务没有做委托，按钮显示仍会显示“关联进口业务信息”
      this.btnInfo.label.btnEntrustment = this.$t('SeaExport.Consignation')
      // CARGO-30390上海辰景13900点击出口转进口按钮后，出口转进口按钮依旧会显示
      // relatedJobLob字段只有内部出口转进口时才会有值，如果是跨租户出口转进口，则relatedJobLob等于空
      if (company && !this.btnInfo.privilege.consignationEnable && _job.relatedJob && _job.relatedJob !== '' && company.relateTenantId === 0 && _job.relatedJobLob && _job.relatedJobLob !== 'SI') {
        this.btnInfo.label.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
        this.btnInfo.privilege.consignationEnable = !this.isEditing
      }
      // 出口转进口(分为内部以及跨租户)
      company = this.context.companyList.find(p => p.cmpIdx === _job.destinationAgent)
      this.isCrossTenantSEToSIStatus = company && this.isCrossTenantSEToSI(company, _job)
      this.isLoadRelatedSop = company && this.loadRelatedSop(company, _job)
      this.btnInfo.privilege.consignationEnableSI = company && (((company.linkedBranchId > 0 && company.linkedBranchId !== _job.opOffice) || this.isCrossTenantSEToSIStatus)) && !_job.relatedJob
      this.btnInfo.label.btnEntrustmentSI = this.$t('SeaExport.ConsignationSI')
      this.btnInfo.btnEntrustmentSISynchronized = false
      this.isShowExportToImport = this.isShowExportToImportCommon
      if (company && !this.btnInfo.privilege.consignationEnableSI && _job.relatedJob) { // 内部出口转进口逻辑判断
        if (_job.relatedJobLob && _job.relatedJobLob === 'SI') {
          this.btnInfo.label.btnEntrustmentSI = this.$t('SeaExport.AssociationBusinessInformationSI')
          this.btnInfo.btnEntrustmentSISynchronized = true
          this.btnInfo.privilege.consignationEnableSI = !this.isEditing
        }
        // 跨租户的话就隐藏这个按钮
        this.isShowExportToImport = (company.relateTenantId > 0 && company.overseaAgent) ? false : this.isShowExportToImport
      }
    },
    isCrossTenantSEToSI(company, _job) {
      if (!(company.relateTenantId > 0 && company.overseaAgent && _job.jobState === SystemConstants.STATE_OPERATING.code) || _job.containerLoadType === 'SPA') {
        return false
      }
      if ((_job.containerLoadType === 'BC' || _job.containerLoadType === 'LCL')) {
        if (_job.masterFlag && _job.lclSlaves.length === 0) { // 主票没有小票
          return false
        }
        if (!_job.masterFlag && !_job.lclMasterUuid) { // 小票没有关联主票
          return false
        }
      }
      return true
    },
    loadRelatedSop(company, _job) {
      if (!(company.relateTenantId > 0 && company.overseaAgent) || _job.containerLoadType === 'SPA') {
        return false
      }
      if ((_job.containerLoadType === 'BC' || _job.containerLoadType === 'LCL')) {
        if (_job.masterFlag && _job.lclSlaves.length === 0) { // 主票没有小票
          return false
        }
        if (!_job.masterFlag && !_job.lclMasterUuid) { // 小票没有关联主票
          return false
        }
      }
      return true
    },
    returnReview() {
      if (!this.currentRow) {
        return
      }
      JobUtils.batchReturnReview(this, [this.currentRow])
    },
    // 退关
    async toShutOut() {
      if (!this.currentRow) return
      const item = this.currentRow
      const jobKeys = Array.of(item.uuid)
      this.shutOutDialog.jobKeys = jobKeys
      // 财务审核
      if (item.jobState === 2) {
        this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
        return
      }
      const validateClosingAccount = Number(this.config.get('ValidateClosingAccount')) === 1
      if (validateClosingAccount) {
        const flag = await JobUtils.checkJobOfClosingAccount(item.opOffice, item.etd)
        if (!flag) {
          return
        }
      }
      // 退关
      if (item.shutOut) {
        if (!this.btnInfo.privilege.button_SEBooking_cancelShutout) {
          this.$message.warning(this.$t('Message.NoPermissionToCancelTheShutOut'))
          return
        }
        // 取消退关
        this.$confirm(this.$t('Message.ConfirmToCancelTheShutOut'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const job = this.currentRow
          if (!job) return
          this.commonInfo.operateNameCode = Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)
          shutOut({ anyStr: job.uuid, location: this.location }).then(res => this.shutOutResult(res))
        }).catch(() => {
        })
      } else {
        canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
      }
    },
    // 退关 弹框处理
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      this.shutOutDialog.shutOutButtonShow2 = ''
      if (result === 0) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.CustomsClearanceNoChargeNoChange')
      } else if (result === 1) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.ClearFeeNoChargeCustomsClearance')

        this.shutOutDialog.shutOutButtonShow2 = 'none'
      } else if (result === 2) {
        this.$message.info(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.info(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
      if (result === 0 || result === 1) {
        this.shutOutDialog.visible = true
      }
    },
    // 有费用退关
    hasChargeShutoutHandler() {
      const job = this.currentRow
      if (!job) return
      this.shutOutDialog.hasCharge = true
      this.commonInfo.operateNameCode = Number(SystemConstants.OPERATE_SHUTOUT.code)
      shutOut({ anyStr: job.uuid, anyBool: true, location: this.location }).then(res => this.shutOutResult(res))
    },
    // 无费用退关
    async noHasChargeShutoutHandler() {
      const job = this.currentRow
      if (!job) return
      this.shutOutDialog.hasCharge = false
      this.commonInfo.operateNameCode = Number(SystemConstants.OPERATE_SHUTOUT.code)
      const loading = getLoading4Cxt(this)
      try {
        const body = { job: { ...job }}
        delete body.job.containerUsages
        delete body.job.containers
        const result = await JobUtils.checkBySaveJobNode(body, this.job.lob, CheckRuleConstants.NO_FEE_REFUND.code)
        if (result.needShowDialog) {
          loading.close()
          const callBack = async() => { shutOut({ anyStr: job.uuid, anyBool: false, location: this.location }).then(res => this.shutOutResult(res)) }
          this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NO_FEE_REFUND.code
          this.checkingSaveJobWindow.rowData = result.rowData
          this.checkingSaveJobWindow.callBack = callBack
          this.checkingSaveJobWindow.visible = true
        } else {
          shutOut({ anyStr: job.uuid, anyBool: false, location: this.location }).then(res => this.shutOutResult(res))
        }
      } catch (err) {
        throw err
      } finally {
        loading.close()
      }
    },
    // 退关结果处理
    async shutOutResult(res) {
      const j = res.data
      if (!j) return
      const msg = j.shutOut ? this.$t('Message.ShutOutSuccessfully') : this.$t('Message.CancelShutOutSuccessfully')
      // this.$confirm(msg, this.$t('common.tips.prompt'), {
      //   confirmButtonText: this.$t('common.btn.ok'),
      //   showCancelButton: false,
      //   closeOnClickModal: false,
      //   showClose: false,
      //   center: true,
      //   type: 'success'
      // }).then(() => {})
      this.$message.success(msg)
      if (this.commonInfo.operateNameCode === Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)) {
        this.currentRow.jobState = SystemConstants.OPERATING
        this.currentRow.shutOut = false
      } else {
        const hasCharge = this.shutOutDialog.hasCharge
        this.currentRow.shutOut = true
        if (!hasCharge) {
          this.currentRow.jobState = SystemConstants.SHUT_OUT
        }
      }
      await this.mergeCurrentRow(res)
      this.refresh()
      this.shutOutDialog.visible = false
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.commonInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState2(this.currentRow)
      }
    },
    async showMscSupplementFunc() {
      const job = this.currentRow
      if (job.carrierId) {
        const company = await Company.getCompanyById(job.carrierId)
        if (company && company.mscSupplement && company.mscSupplementType === SystemConstants.MSC_SUPPLEMENT_TYPE_1.code) {
          this.showMscSupplementHandler(true)
        } else {
          this.showMscSupplementHandler(false)
        }
      } else {
        this.showMscSupplementHandler(false)
      }
    },
    /** 标题行中段：插在业务编号与客户信息之间（与订舱 mbl / MBL_NO 同源，空为 -） */
    formatJobTitleMblSegment(job) {
      if (!job) return '-'
      const m = job.mbl != null && String(job.mbl).trim() !== '' ? job.mbl : job.MBL_NO != null ? job.MBL_NO : ''
      const v = String(m).trim()
      return v || '-'
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = Number(this.config.get('DetailTitleShowModel')) === 0 ? job.jobNo : StrUtils.toHalfwordUpperCase(job.mbl)
      let chargeJobTitle = ''
      if (this.isEditing) {
        const methodPath = this.documentManage.getPath('showBasicInfo')
        chargeJobTitle = jobTitle + `<i title="${this.$t('SeaExport.TipCharge')}" class="el-icon-search" style="margin-left:5px;color:#0000FF;cursor:pointer" onclick="${methodPath}()"></i>`
      }
      if (parseInt(job.customerId) > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await new Company(cmp).getCustomerDetail().then(data => {
            if (data) {
              const str1 = ` ${this.$t('Message.BillingType')}[${this.$t('Message.ByTicket')}]`
              const str2 = `${this.$t('Message.BillingType')}[${this.$t('Message.Monthly')}]`
              return data.invoiceMode === 0 ? str1 : str2
            }
            return ''
          })
          const detailModel = Number(this.config.get('DetailTitleShowModel'))
          const mblMid = detailModel === 0 ? this.formatJobTitleMblSegment(job) : null
          if (detailModel === 0) {
            jobTitle =
              '<span style="margin-right:10px">' +
              jobTitle +
              '</span><span style="margin-right:10px">' +
              mblMid +
              '</span><span style="margin-right:10px">' +
              (this.isZh ? cmp.chineseName : cmp.englishName) +
              creditTerm +
              '</span><span>' +
              billingType +
              '</span>'
            if (this.isEditing) {
              chargeJobTitle =
                '<span style="margin-right:10px">' +
                chargeJobTitle +
                '</span><span style="margin-right:10px">' +
                mblMid +
                '</span><span style="margin-right:10px">' +
                (this.isZh ? cmp.chineseName : cmp.englishName) +
                creditTerm +
                '</span><span>' +
                billingType +
                '</span>'
            }
          } else {
            jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + (this.isZh ? cmp.chineseName : cmp.englishName) + creditTerm + '</span><span>' + billingType + '</span>'
            if (this.isEditing) {
              chargeJobTitle = '<span style="margin-right:10px">' + chargeJobTitle + '</span><span style="margin-right:10px">' + (this.isZh ? cmp.chineseName : cmp.englishName) + creditTerm + '</span><span>' + billingType + '</span>'
            }
          }
        }
      }
      this.commonInfo.jobTitle = jobTitle
      this.commonInfo.chargeJobTitle = chargeJobTitle
    },
    // 检查计提发布状态
    async checkProvisionPublishedStatus() {
      if (!this.job || !this.job.uuid) {
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
        return
      }

      try {
        const res = await checkJobProvisionFlag(this.job.uuid)
        this.commonInfo.provisionLock = res.ok ? normalizeProvisionLock(res.data) : { etdLocked: false, feeLocked: false }
      } catch (error) {
        console.error('检查计提发布状态失败:', error)
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
      }
    },
    showBasicInfo() {
      this.basicInfoVisible = !this.basicInfoVisible
      this.showBasicInfoWindow()
    },
    showBasicInfoWindow() {
      if (this.basicInfoVisible) {
        const job = this.paramsOfTab
        this.basicInfo.rowData = [
          { basic: this.$t('SeaExport.PortOfLoading') + ':', isTitle: true },
          { basic: ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', job.loadingPortCode, 'englishName'), isTitle: false },
          { basic: this.$t('SeaExport.PortOfDischarge') + ':', isTitle: true },
          { basic: ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', job.dischargingPortCode, 'englishName'), isTitle: false },
          { basic: this.$t('SeaExport.PlaceOfDelivery') + ':', isTitle: true },
          { basic: ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', job.destinationPortCode, 'englishName'), isTitle: false },
          { basic: this.$t('SeaExport.ContainerInfo2') + ':', isTitle: true },
          { basic: job.seaEQ ? Array.from(job.seaEQ, p => p.eqSize + p.eqType + '×' + p.eqQuantity).join(' ') : '', isTitle: false },
          { basic: this.$t('Payment.vesselAndVoyage') + ':', isTitle: true },
          { basic: (job.vessel || '') + ' ' + (job.voyageFlight || ''), isTitle: false },
          { basic: 'MBL NO.' + ':', isTitle: true },
          { basic: job.mbl || '', isTitle: false },
          { basic: 'ETD' + ':', isTitle: true },
          { basic: job.etd ? ColumnUtils.dateLabelFunc(job.etd) : '', isTitle: false },
          { basic: this.$t('SeaExport.ShippingCompany') + ':', isTitle: true },
          { basic: job.carrierId ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', job.carrierId, 'auto_5') : '', isTitle: false }
        ]
      }
    },
    // 复制
    toCopy() {
      if (this.job.masterFlag) {
        this.$emit('copy', this.job)
      } else {
        if (this.job.customerId) {
          const loading = getLoading4Cxt(this)
          isContractExpiredForbidCreateJob(this.job.customerId).then(res => {
            loading.close()
            if (res.data) {
              this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
            } else {
              this.$emit('copy', this.job)
            }
          }).catch(() => { loading.close() })
        }
      }
    },
    importOrder() {
      if (!this.job) return
      if (JobUtils.checkHQ()) return
      this.importOrderDialog.job = this.job
      this.importOrderDialog.visible = true
    },
    importOrderConfirmCallBack(data) {
      if (!data) return
      const selectedJob = data.job
      const selectedTabs = data.selectedTabs
      const item = {}
      item.sourceJobUuid = selectedJob.uuid
      item.targetJobUuid = this.currentRow.uuid
      item.branchId = this.$store.getters.currentOfficeId
      if (selectedTabs) {
        item.vesselEq = selectedTabs.booking
        item.prePlanBooking = selectedTabs.prePlanBooking
        item.mbl = selectedTabs.mbl
        item.hbl = selectedTabs.hbl
        item.charge = selectedTabs.charge
        item.overwritesDifference = selectedTabs.isOverwritesDifference
      }
      const loading = getLoading4Cxt(this)
      importOrderJob(item).then(async res => {
        if (res.data) {
          const result = res.data
          result.job.opOffice = this.$store.getters.currentOfficeId || result.job.opOffice
          const continueExec = await JobUtils.validateJobFieldActive(result.job, this, 'SeaBooking')
          if (!continueExec) {
            return
          }
          this.writebackJob(result.job)
          this.currentRow.differenceJobFields = result.seaJobDifferenceTab
          this.currentRow.differenceBookingFields = result.bookingDifferenceTab
          this.currentRow.differencePrePlanFields = result.perPlanDifferenceTab
          this.currentRow.differenceMblFields = result.mblDifferenceTab
          this.currentRow.differenceHblFields = result.hblDifferenceTab
          this.againShow('edit', this.currentRow)
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 预提交
    doSubmitPrint_PreSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_PRE_COMMIT.code)
    },
    // 提交
    doSubmitPrint_Submit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_COMMIT.code)
    },
    // 主管提交
    doSubmitPrint_ManagerSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
    },
    // 主管审核
    async doSubmitAudit_ManagerSubmit() {
      this.optName = ''
      const job = this.job
      const checkApChargeVerify = parseInt(this.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (checkApChargeVerify === 1 && !await JobUtils.checkChargeStateVerify(this.job)) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = parseInt(this.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      const callBack = this.getDoSubmitAudit_ManagerSubmit || null
      const callBack2 = this.getDoSubmitAudit_ManagerSubmit2 || null
      const checkNode = 10
      this.checkingManager(checkNode, callBack, callBack2)
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit() {
      commit(this.job.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.office.officeId, this.location).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
      })
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit2() {
      this.commonInfo.showMessage = false
      this.loadChargesPrintReturnHandler()
    },
    // 主管审核【验证规则回调函数】
    async loadChargesPrintReturnHandler() {
      const charges = await new SeaExportJob(this.job).getCharges()
      this.refChargeChargeState(charges)
      this.job.jobState = SystemConstants.OPERATING
      this.job.submissionDate = null
      this.job.manageAuditStatus = 0
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      this.job.sopStateUpdate = 1
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        if (this.commonInfo.showMessage) {
          this.$message.info(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
      })
    },
    // 保存之前将不需要保存的数据置空,后续需要使用时再加载 this.refresh() 会再走加载那一段
    // 避免循环引用
    resetNoNeedSaveData() {
      if (Object.prototype.hasOwnProperty.call(this.job, 'containerUsages')) {
        for (const usage of this.job.containerUsages) {
          delete usage.container
        }
      }
      if (Object.prototype.hasOwnProperty.call(this.job, 'containers')) {
        for (const container of this.job.containers) {
          delete container.containerUsages
        }
      }
    },
    // node 提交 检测的节点【预提交/提交/主管提交】
    async doSubmitPrintPROFIT(node) {
      this.optName = ''
      // this.isGetNewJobInfoFromDb = true
      // this.currentRow.version = 0
      // await this.onRowClicked({ data: this.currentRow }) // 避免连续操作导致版本号不对
      if (this.currentRow.masterFlag) {
        this.currentRow.lclSlaves = ''
        await new SeaExportJob(this.currentRow).getLclSlaves()
      }
      const job = this.job
      if (node === CheckRuleConstants.NODE_COMMIT.code || node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        // 预付款余额校验
        const checkFailUuids = []
        const jobKeys = []
        jobKeys.push(job.uuid)
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.indexOf(job.uuid) !== -1) {
          return
        }
      }
      this.commonInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
      if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
      }

      this.commonInfo.isPrintOpr = false
      const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = Number(this.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      // 判断是否开启验证规则
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const hasCheckRule = await JobUtils.hasConfigCheckRule(node, job.uuid, job.lob)
        if (hasCheckRule) {
          const callBack = this.getDoSubmitPrintPROFIT || null
          const callBack2 = this.commitRefuseHandler || null
          const checkNode = node
          this.checkingManager(checkNode, callBack, callBack2)
        } else {
          await this.getDoSubmitPrintPROFIT()
        }
      } else {
        if (this.commonInfo.allSubmitFcl) {
          this.doSubmitAllFcl()
        } else {
          this.doSubmitPrint()
        }
      }
    },
    // 提交【验证规则回调函数】
    async getDoSubmitPrintPROFIT() {
      const job = this.job
      const checkChargeInvoice = Number(this.config.get('CheckReceivableChargePrintInvoice'))
      if (this.commonInfo.isPreCommit || checkChargeInvoice < 1) {
        // CARGO-32805 BPM流程引擎二期，增加bpm弹窗
        if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
          return
        }
        commit(job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPreCommit, this.office.officeId, this.location).then(res => {
          if (Number(this.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
            (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code ||
              this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code)) {
            this.commitCBMSResultHandler(res, '0')
          } else if (Number(this.config.get('openHecConfig')) === 1) {
            this.commitSapResultHandler(res)
          } else {
            this.commitResultHandler(res)
          }
        })
      } else {
        getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res))
      }
    },
    /**
     * 开启sap推送 发送sap消息
     * @private
     */
    async commitSapResultHandler(res) {
      const jobs = []
      jobs.push(this.job.uuid)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = ChargeUtils.CHARGE_US.code
      params.sapStatus = ChargeUtils.CHARGE_SH.code
      params.needUpdateCharge = true
      params.isSend = false
      await sendHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResultHandler(res)
      })
    },
    async backReturnSapResultHandler(res) {
      const jobs = []
      jobs.push(this.job.uuid)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = 'all'
      params.sapStatus = ChargeUtils.CHARGE_US.code
      params.needUpdateCharge = true
      params.isSend = false
      await backHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResult2Handler(res)
      })
    },
    /**
     * 开启CBMS推送 发送CBMS消息
     * @private
     */
    async commitCBMSResultHandler(res, type = '0') {
      const params = {}
      params.uuid = this.job.uuid
      params.isDisable = type
      params.officeId = this.$store.getters.currentOfficeId
      await sendJobCBMS(params).then(rsp => {
        if (!rsp.data || rsp.data === 'fail') {
          this.$message.error(this.$t('CargoMsg.Cargo_PushFailByCBMS'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_PushSuccessByCBMS'))
        }
        this.commitResult2Handler(res)
      })
    },
    async commitResult2Handler(res) {
      await this.mergeCurrentRow(res)
      this.refresh()
    },
    // 提交【验证规则回调函数】
    async commitResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.CommitSuccessfully'))
      this.refresh()
    },
    // 提交主票，小票一起提交
    async doSubmitAllFcl() {
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('Message.LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL'))
        return
      } else if (this.job.masterFlag) {
        await this.getLclSlavesAndCharges()
        this.loadSubmitAllFclHandler()
      } else {
        this.doSubmitPrint()
      }
    },
    // 根据主票加载小票以及小票费用
    async getLclSlavesAndCharges() {
      await new SeaExportJob(this.job).getCharges()
      const lclSlaves = await new SeaExportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const lclJob of lclSlaves) {
          if (lclJob.uuid && !lclJob.charges) {
            await new SeaExportJob(lclJob).getCharges()
          }
        }
      }
    },
    // 提交主票
    async loadSubmitAllFclHandler() {
      await RateUtil.refreshChargeRatesByJob(this.job)
      this.job.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
      this.job.submissionDate = this.commonInfo.isPreCommit ? null : new Date()
      for (const c of this.job.charges) {
        c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
      }
      for (const lclJob of this.job.lclSlaves) {
        lclJob.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
        lclJob.submissionDate = this.commonInfo.isPreCommit ? null : new Date()
        if (!this.commonInfo.isPreCommit) {
          for (const c of lclJob.charges) {
            c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
          }
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        // 保存job相关信息【saveJobInfo = save2】
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.refresh()
        })
      } else {
        // CARGO-32805 BPM流程引擎二期，提交
        if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
          return
        }
        // 保存刷新过的的汇率 by Marco 2014-8-8 (Bad Design)
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.commonInfo.isPrint = false
          if (this.btnInfo.visible.printFclProfit) {
            this.checkPrintEnable(this.doPrintFCLPROFIT)
          } else {
            this.checkPrintEnable(this.doPrintLCLPROFIT)
          }
        })
      }
    },
    // 整箱利润打印提交  isProfitPrint:是否由整箱/拼箱利润打印按钮触发
    async doPrintFCLPROFIT(isProfitPrint = false) {
      // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1或2时，先打印再提交
      if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.previewFCLProfit({ data: this.job }, isProfitPrint)
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewFCLProfit(res, isProfitPrint))
      }
    },
    // 拼箱利润打印提交  isProfitPrint:是否由整箱/拼箱利润打印按钮触发
    async doPrintLCLPROFIT(isProfitPrint = false) {
      // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1或2时，先打印再提交
      if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.previewLCLProfit({ data: this.job }, isProfitPrint)
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewLCLProfit(res, isProfitPrint))
      }
    },
    // 拼箱利润打印预处理
    previewLCLProfit(res, isProfitPrint) {
      this.previewProfit(res, 'LCL', isProfitPrint)
    },
    // 整箱利润打印预处理
    previewFCLProfit(res, isProfitPrint) {
      this.previewProfit(res, 'FCL', isProfitPrint)
    },
    // 预览打印【区分整箱拼箱】
    async previewProfit(res, type, isProfitPrint = false) {
      // 整箱拼箱利润打印按钮事件触发打印弹窗，预提交/提交/主管提交不触发
      if (isProfitPrint) {
        await this.mergeCurrentRow(res)
        this.$nextTick(() => {
          const params = {}
          params.jobuuid = this.job.uuid
          params.showPreview = this.commonInfo.isPrint
          params.JOB_UUID = this.job.uuid
          // 提交之前需要预打印，预打印是不需要弹出提示框的，这里主要是控制PrintTemplateManager.profitSubmitHandler的提示控制
          let category = 'LCLPROFIT'
          if (type === 'FCL') {
            params.isCommitJob = this.commonInfo.isPrint
            category = 'FCLPROFIT'
          }
          params.isPreCommit = this.commonInfo.isPreCommit
          console.log(type + '-previewProfit--params--', params)
          this.templateSelectorDialog.ctx = new SeaExportJob(this.job)
          this.templateSelectorDialog.category = category
          this.templateSelectorDialog.data = params
          // 组装打印回调函数
          this.prePrintCallback = null
          this.printedCallback = this.doPrintPROFIT
          this.v2CheckCallback = this.doPrintPROFIT_V2
          this.templateSelectorDialog.visible = true
        })
      } else {
        // CARGO-32805 BPM流程引擎二期，增加bpm弹窗
        if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, isProfitPrint, this.config, this.job)) {
          return
        }
        // 预提交/提交直接显示已提交，不显示利润打印弹窗
        if (Number(this.config.get('useCheckRule')) === 1) {
          printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler(res))
        } else {
          calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler(res))
        }
      }
      this.updateControlsState()
      this.refresh()
    },
    async calculateResultHandler(res) {
      this.optName = ''
      const oldJobState = this.job.jobState
      await this.mergeCurrentRow(res)
      this.refreshChargeHandler(oldJobState)
      this.refresh()
    },
    // 打印回调函数
    doPrintPROFIT(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPreCommit = event.isPreCommit
      if (PrintUtils.isExecutor(event.action)) {
        if (this.job && this.job.uuid) {
          // 检查是否有收费用未开发票
          if (this.job.jobState === SystemConstants.OPERATING) {
            getChargeIsInvoice(this.job.uuid).then(res => this.getChargeIsInvoiceResult(res, true))
          } else {
            this.printAlert(true)
          }
        }
      }
    },
    // 打印回调函数
    doPrintPROFIT_V2(isSure, template, entity, arms) {
      if (isSure && arms) {
        this.commonInfo.isPreCommit = arms.event.isPreCommit
        if (PrintUtils.isExecutor(arms.event.action)) {
          this.printAlert(true)
        }
      }
    },
    // 确认是否可打印  isProfitPrint 是否由整箱/拼箱利润打印按钮触发
    checkPrintEnable(callback, isProfitPrint = false) {
      if (this.job && !this.job.masterFlag && this.job.sales <= 0 && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        this.commonInfo.isPrint ? this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndPrints')) : this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndSubmit'))
        return
      }
      const jobNos = this.checkSales()
      if (jobNos && jobNos.length > 0) {
        const msg1 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndPrint')
        const msg2 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndSubmit')
        this.$message.warning(this.commonInfo.isPrint ? msg1 : msg2)
        return
      }
      callback(isProfitPrint)
    },
    // 验证销售及揽货类型
    checkSales() {
      const jobNos = []
      if (this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          if (j.sales <= 0 && j.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
            jobNos.push(j.jobNo)
          }
        }
      }
      return jobNos
    },
    // 正常提交
    async doSubmitPrint() {
      // CARGO-32805 BPM流程引擎二期，增加bpm弹窗
      if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
        return
      }
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        // 这段逻辑移动到后端
        const item = {}
        item.jobUuid = this.job.uuid
        item.operateNameCode = this.commonInfo.operateNameCode
        item.location = this.location
        await normalCommitJob(item).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.refresh()
        })
        return
      }
      this.commonInfo.isPrint = false
      if (this.btnInfo.visible.printFclProfit) {
        this.checkPrintEnable(this.doPrintFCLPROFIT)
      } else {
        this.checkPrintEnable(this.doPrintLCLPROFIT)
      }
    },
    // 打印回调函数
    commitRefuseHandler() {
      this.refresh()
    },
    // 检查是否有收费用未开发票
    async getChargeIsInvoiceResult(res, isProfitPrint = false) {
      const flag = res.data
      if (flag) {
        const msg = this.commonInfo.isPrint ? this.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
        await this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          await this.printAlert(isProfitPrint)
        }).catch(() => {
          this.commonInfo.isPrint = true
        })
      } else {
        await this.printAlert(isProfitPrint)
      }
    },
    // 打印提示
    async printAlert(isProfitPrint = false) {
      const printProfitToPreCommit = Number(this.config.get('PrintProfitToPreCommit'))
      if (printProfitToPreCommit === 0 ||
        this.job.jobState === SystemConstants.SHUT_OUT || this.job.jobState === SystemConstants.VERIFIED || this.job.jobState === SystemConstants.COMMITED ||
        (this.job.jobState === SystemConstants.PRE_COMMIT && printProfitToPreCommit === 1)) {
        await this.onConfirmedPrintProfit(isProfitPrint)
      } else {
        let msg = this.$t('Message.VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        if (this.commonInfo.isPreCommit) {
          msg = this.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        }
        this.$confirm(msg, this.$t('common.tips.warning'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          await this.onConfirmedPrintProfit(isProfitPrint, true)
        }).catch({})
      }
    },
    // 提交/预提交
    async onConfirmedPrintProfit(isProfitPrint = false, isPrint = false) {
      // CARGO-32805 BPM流程引擎二期，增加bpm弹窗
      if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, isProfitPrint, this.config, this.job)) {
        return
      }
      // 利润打印 按钮逻辑
      // if (isProfitPrint) {
      //   calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      //   return
      // }
      // 预提交/提交/主管提交 按钮逻辑
      if (Number(this.config.get('useCheckRule')) === 1) {
        printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      } else {
        calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      }
    },
    // 提交成功
    async calculateProfit2ResultHandler(res, isProfitPrint = false, isPrint = false) {
      this.optName = ''
      const oldJobState = this.job.jobState
      await this.mergeCurrentRow(res)
      if ((!isProfitPrint || isPrint) && this.commonInfo.printEvent && !PrintUtils.isPrint(this.commonInfo.printEvent.action)) {
        const template = this.commonInfo.printEvent.template
        const parameter = this.commonInfo.printEvent.parameter
        let documentType = null
        if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
          await getDocumentType(template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        if (StimulSoftUtil.isOpenStiReport(template)) {
          parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
          parameter.documentType = documentType
          await StimulSoftUtil.stiReportPreview(template, this.job, parameter)
        } else {
          const action = this.commonInfo.printEvent.action || ''
          const format = this.commonInfo.printEvent.format || ''
          const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
          if (url) {
            await this.loadMailURL(url, parameter)
          }
        }
      }
      // 提交成功推送费用
      if (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code || this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code) {
        if (Number(this.config.get('openHecConfig')) === 1) {
          const jobs = []
          jobs.push(this.job.uuid)
          if (this.job.masterFlag && this.job.lclSlaves) {
            for (var j of this.job.lclSlaves) {
              jobs.push(j.uuid)
            }
          }
          const params = {}
          params.jobKey = jobs
          params.oldSapStatus = ChargeUtils.CHARGE_US.code
          params.sapStatus = ChargeUtils.CHARGE_SH.code
          params.needUpdateCharge = true
          params.isSend = false
          await sendHecMessageByJob(params).then(rsp => {
            this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
          })
        }
      }
      this.refreshChargeHandler(oldJobState, isProfitPrint)
      this.refresh()
    },
    // 加载MailURLRequest
    async loadMailURL(url, parameter) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.onerror = function(e) {
        this.loadError()
      }
      request.send()
      if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
        this.httpResultEmail(status)
      }
    },
    // Mail异常结果处理
    httpResultEmail(status) {
      // 附件过大
      if (status === 0) {
        this.$message.error('附件内容过大')
      } else if (status === 1) {
        this.$message.error(this.$t('SeaExport.SmtpServerError'))
      } else if (status === 2) {
        this.$message.error(this.$t('SeaExport.NotConnectSmtpServer'))
      } else if (status === 3) {
        this.$message.error(this.$t('SeaExport.NotFindFile'))
      } else if (status === 4) {
        this.$message.error(this.$t('SeaExport.SendFileError'))
      } else if (status === 5) {
        this.$message.error(this.$t('SeaExport.AttachTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('SeaExport.MailSentSuccess'))
      }
    },
    // 刷新Tab
    refreshChargeHandler(oldJobState = -2, isProfitPrint = false) {
      if (!this.commonInfo.isPreCommit) {
        this.refresh()
      }
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = false
      if (isProfitPrint && oldJobState === SystemConstants.COMMITED) return // 如果是已提交状态再整箱利润打印，就不需要再弹出提交成功提示
      if (isProfitPrint && Number(this.config.get('PrintProfitToPreCommit')) === 0) return // 如果是打印按钮事件 且printProfitToPreCommit=0，不再弹出提交成功提示
      if (isProfitPrint && oldJobState === SystemConstants.PRE_COMMIT) return
      this.$message.success(this.$t('Message.CommitSuccessfully'))
    },
    // CARGO-46883 验证触发：业务单据点击【委托】时，进行数据必录项的规则验证
    async entrustmentClickHandlerPre() {
      if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.Consignation')) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_CROSS_DELEGATION.code
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        if (useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
          if (hasCheckRule) {
            this.checkingWindow.checkNode = checkNode
            this.checkingWindow.callBack = this.entrustmentClickHandler
            this.checkingWindow.callBack2 = null
            this.checkingWindow.visible = true
          } else {
            await this.entrustmentClickHandler()
          }
        } else {
          await this.entrustmentClickHandler()
        }
      } else {
        await this.entrustmentClickHandler()
      }
    },
    // 委托
    async entrustmentClickHandler() {
      this.$logger.log('this.job- this.job', this.job)
      // this.$logger.log('this.job.relatedJob', this.job.relatedJob)
      this.enableEntrustmentSI = false
      const company = await Company.getCompanyById(this.job.bookingAgent)
      this.$logger.log('company- company', company)
      if (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.job.opOffice) { // 内部委托
        // cargo-425 集翊达：委托业务往来关联号为空：只有为委托状态的情况下采取判断
        if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.Consignation')) {
          if (this.job.relatedJob) {
            this.$message.info(this.$t('Message.TicketEntrustedCannotRepetitionDelegate'))
            return
          }
        }
        this.doSendBranchHandler()
      } else if (company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0) { // 跨tenant委托
        this.doCrossTenantHandler()
      }
    },
    // 出口转进口
    async entrustmentSIClickHandler() {
      this.enableEntrustmentSI = true
      if (this.btnInfo.label.btnEntrustmentSI === this.$t('SeaExport.AssociationBusinessInformationSI')) {
        if (this.job.relatedJob && this.job.relatedJobLob && this.job.relatedJobLob === 'SI') { // 内部出口转进口，查看内部进口业务
          this.queryRelatedSiFrom()
        } else { // 目前系统不支持跨租户出口转进口，查询其他租户进口业务信息功能
        }
      } else {
        const company = await Company.getCompanyById(this.job.destinationAgent)
        this.$logger.log('company- company', company)
        if (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.job.opOffice) { // 内部委托
          if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.ConsignationSI')) {
            if (this.job.relatedJob) {
              this.$message.info(this.$t('Message.TicketEntrustedCannotRepetitionDelegate'))
              return
            }
          }
          this.doSendBranchHandler()
        } else if (company.relateTenantId > 0 && company.overseaAgent) { // 跨租户委托
          // CARGO-23687 跨Tenant【出口转进口】增加校验项，字段：“预计到港日期”，需要必填。
          if (!this.job.eta) {
            await this.$confirm(this.$t('SeaExport.DateOfArrival2') + this.$t('CargoMsg.Cargo_CanNotEmpty'), this.$t('common.tips.warning'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_ContinueOperation'),
              cancelButtonText: this.$t('CargoMsg.Cargo_CancelOperation'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.doCrossTenantSeToSi()
            }).catch(() => {})
          } else {
            this.doCrossTenantSeToSi()
          }
        }
      }
    },
    doCrossTenantSeToSi() {
      const loading = getLoading4Cxt(this)
      checkingConsignationJob(this.job.uuid).then(async res => {
        if (res.data === 1) {
          await createCrossTenantImportByExportJob(this.job.uuid, this.location, this.$store.getters.currentOfficeId).then(res => {
            this.$message.success(this.$t('Message.OperationSuccessfully'))
            this.currentRow.version = 0
            this.refresh()
          })
        } else {
          this.$message.info(this.$t('CargoMsg.CheckingExportToImport'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 发送分公司
    doSendBranchHandler() {
      if (this.enableEntrustmentSI) {
        if (this.btnInfo.label.btnEntrustmentSI === this.$t('SeaExport.AssociationBusinessInformationSI')) {
          this.queryRelatedSiFrom()
        } else {
          this.checkingConsignationJob()
        }
      } else {
        if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.AssociationBusinessInformation')) {
          this.queryTrustFrom()
        } else {
          this.checkingConsignationJob()
        }
      }
    },
    // 后端检查该业务是否可以委托
    checkingConsignationJob() {
      checkingConsignationJob(this.job.uuid).then(res => this.sendBranchHandler(res))
    },
    // 发送分公司
    async sendBranchHandler(event) {
      if (event.data === 1) {
        const company = await Company.getCompanyById(this.enableEntrustmentSI ? this.job.destinationAgent : this.job.bookingAgent)
        if (company) {
          // 检索属于订舱代理所属分公司的合作伙伴ID
          queryCompany(1, this.job.opOffice).then(res => this.queryCompanyResultHandler(res))
        }
      } else {
        this.$message.info(this.$t('Message.CheckingConsignation'))
      }
    },
    // 检索属于订舱代理所属分公司的合作伙伴ID
    queryCompanyResultHandler(event) {
      const companyArr = event.data
      if (companyArr && companyArr.length > 0) {
        this.partner = companyArr[0]
        // 加载联系人
        new Company(this.partner).getContacts()
        this.loadContractsResultHandler()
      } else {
        if (this.enableEntrustmentSI) {
          this.$message.info(this.$t('Message.TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI'))
        } else {
          this.$message.info(this.$t('Message.TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership'))
        }
      }
    },
    // 加载联系人
    loadContractsResultHandler() {
      this.doSendBranch()
    },
    // 发送分公司
    async doSendBranch() {
      const company = await Company.getCompanyById(this.enableEntrustmentSI ? this.job.destinationAgent : this.job.bookingAgent)
      if (company) {
        const office = await Office.getOfficeById(company.linkedBranchId)
        if (office) {
          this.readSendBranchSelectObject()
          this.sendBranchWindow.office = office
          this.sendBranchWindow.title = office.chineseName
          if (!this.sendBranchWindow.checkConsigneeDefault) {
            this.sendBranchWindow.consigneeTarget = 'consignee'
            this.sendBranchWindow.consigneeDetailTarget = 'consigneeDetail'
          }
          this.sendBranchWindow.checkSalesMapping = this.showdCheckSalesMapping
          this.sendBranchWindow.visible = true
        }
      }
    },
    // 销售change事件
    async userId_changeHandler(item) {
      const userId = item.userId
      if (userId > 0) {
        if (item.selectObject === 0) {
          await getUserDefaultDepartment({
            category: 'role',
            shape: 'csr',
            userId: userId
          }).then(res => this.getDefaultCsrResult(res, item))
        } else {
          const office = this.sendBranchWindow.office
          if (office) {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId,
              officeId: office.officeId
            }).then(res => this.getDefaultDeptResult(res, item))
          } else {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId
            }).then(res => this.getDefaultDeptResult(res, item))
          }
        }
      } else {
        item.departmentId = 0
        item.userId = 0
      }
    },
    // 操作部门
    getDefaultDeptResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
      } else {
        item.departmentId = 0
      }
    },
    // 客服部门
    async getDefaultCsrResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
        if (dep.officeUuid) {
          await getOfficeByUuid(dep.officeUuid).then(res => this.officeLoadHandler(res, item))
        } else {
          this.officeLoadHandler({ data: dep.office }, item)
        }
      } else {
        item.departmentId = 0
        item.departmentOfficeId = 0
      }
    },
    // 加载csr加载dep后加载office后更新业务的客服分公司
    officeLoadHandler(event, item) {
      const office = event.data
      if (office) {
        item.departmentOfficeId = office.officeId
      } else {
        item.departmentOfficeId = 0
      }
    },
    // 发送分公司保存业务
    async enterSendHandler() {
      // if (this.sendBranchWindow.userId === 0) {
      //   this.$message.warning(this.sendBranchWindow.selectObject === 0 ? '请选择客服.' : this.$t('SeaExport.PleaseSelectAction'))
      //   return
      // }
      if (this.sendBranchWindow.opNotNull && this.sendBranchWindow.items && this.sendBranchWindow.items.length > 0) {
        for (const itemElement of this.sendBranchWindow.items) {
          if (itemElement.userId === 0 && itemElement.selectObject === 1) {
            this.$message.warning(this.$t('SeaExport.PleaseSelectAction'))
            return
          }
        }
      }
      // 复制一票新的业务以及更新当前业务的relatedJob放在后端[返回修改后的job]
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      // 配置值4：航线负责人模式（使用seaLine权限）
      if (this.sendBranchSelectObject === 4) {
        item.anyStr = 'seaLine' // shape标识为航线负责人
        item.anyInteger2 = this.sendBranchWindow.items[0].userId // planner userId
      } else {
        item.anyStr = this.sendBranchWindow.items[0].selectObject === 0 ? 'csr' : 'op' // shape
        item.anyInteger = this.sendBranchWindow.items[0].departmentId // departmentId
        item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId // departmentOfficeId
        item.anyInteger2 = this.sendBranchWindow.items[0].userId // userId
      }
      item.anyBool = this.commonInfo.isCopySellingCharge // isCopySellingCharge
      item.anyInteger3 = this.partner.cmpIdx // cmpIdx
      item.anyInteger4 = this.sendBranchWindow.office.officeId // officeId
      item.anyStr1 = this.job.uuid
      item.anyBool1 = this.commonInfo.overwriteJobRefNoBySEconvertSI
      item.anyBool2 = this.commonInfo.chargeSyncNeedConfirm
      item.location = this.location
      if (this.sendBranchWindow.items.length > 1) {
        const item2 = this.sendBranchWindow.items[1]
        item.anyStr2 = item2.selectObject === 0 ? 'csr' : 'op' // shape
        item.anyInteger5 = item2.departmentId // departmentId
        item.anyInteger6 = item2.departmentOfficeId // departmentOfficeId
        item.anyInteger7 = item2.userId // userId
      }
      if (this.sendBranchSelectObject === 2) {
        if (this.sendBranchWindow.consigneeTarget === 'customer') {
          if (this.job.masterFlag) {
            if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
              for (const lclSlave of this.job.lclSlaves) {
                const company = lclSlave.consigneeId > 0 ? await Company.getCompanyById(lclSlave.consigneeId) : null
                if (company) {
                  if (!company.customer) {
                    this.$message.warning(`【${lclSlave.jobNo}】` + this.$t('queryJob.ConsigneeCustomerNotExist'))
                    return
                  }
                } else {
                  this.$message.warning(`【${lclSlave.jobNo}】` + this.$t('queryJob.RecipientNotExist'))
                  return
                }
              }
            }
          } else {
            const company = this.job.consigneeId > 0 ? await Company.getCompanyById(this.job.consigneeId) : null
            if (company) {
              if (!company.customer) {
                this.$message.warning(this.$t('queryJob.ConsigneeCustomerNotExist'))
                return
              }
            } else {
              this.$message.warning(this.$t('queryJob.RecipientNotExist'))
              return
            }
          }
        }
        item.consigneeTarget = this.sendBranchWindow.consigneeTarget
        item.consigneeDetailTarget = this.sendBranchWindow.consigneeDetailTarget
      }
      const excludeFileds = []
      for (const item of this.sendBranchWindow.items) {
        if (item.userId) {
          excludeFileds.push(item.selectObject)
        }
      }
      // 出口转进口
      if (this.enableEntrustmentSI) {
        if (!this.job.eta) {
          this.$message.warning(this.$t('SeaExport.DateOfArrival2') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return
        }
        // 自定义业务类型
        item.customJobType = this.sendBranchWindow.customJobType
        const loading = getLoading4Cxt(this)
        createImportByExportJob(item).then(res => {
          if (res.data && res.data.relatedJob) {
            getRelatedSiJob(res.data.relatedJob).then(res2 => {
              JobUtils.matchPresetConfigAndSave(res2.data, excludeFileds)
            })
          }
          this.saveCloneResultHandler(res)
        }).finally(() => {
          loading.close()
        })
      } else {
        if (this.job.fba) {
          const loading = getLoading4Cxt(this)
          fbaSaveCloneJob(item).then(res => this.saveCloneResultHandler(res)).catch((err) => {
            loading.close()
            console.log(err)
          }).finally(() => {
            loading.close()
          })
        } else {
          item.checkSalesMapping = this.sendBranchWindow.checkSalesMapping
          if (item.checkSalesMapping) {
            const cloneJob = {
              ...this.job,
              customerId: this.job.bookingAgent,
              designationAgent: 0,
              opOffice: item.anyInteger4,
              sales: 0,
              salesOffice: 0,
              salesDepartment: 0
            }
            await JobUtils.loadSalesByJob(cloneJob, true)
            item.sales = cloneJob.sales
            item.salesOffice = cloneJob.salesOffice
            item.salesDepartment = cloneJob.salesDepartment
          }
          const loading = getLoading4Cxt(this)
          saveCloneJob(item).then(res => {
            if (res.data && res.data.relatedJob) {
              getRelatedJob(res.data.relatedJob).then(res2 => {
                JobUtils.matchPresetConfigAndSave(res2.data, excludeFileds)
              })
            }
            this.saveCloneResultHandler(res)
          }).catch((err) => {
            loading.close()
            console.log(err)
          }).finally(() => {
            loading.close()
          })
        }
      }
      this.sendBranchWindow.visible = false
    },
    async saveCloneResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.SuccessfullySent'))
      if (this.enableEntrustmentSI) {
        this.btnInfo.label.btnEntrustmentSI = this.$t('SeaExport.AssociationBusinessInformationSI')
        this.btnInfo.btnEntrustmentSISynchronized = true
      } else {
        this.btnInfo.label.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
      }
      this.sendBranchWindow.items[0].userId = 0
      this.sendBranchWindow.office = {}
      this.sendBranchWindow.items[0].departmentId = 0
      this.sendBranchWindow.items[0].departmentOfficeId = 0
      this.sendBranchWindow.items[0].selectObject = 0
      this.sendBranchWindow.customJobType = null
      this.refresh()
    },
    // 查看关联业务信息
    queryTrustFrom() {
      if (this.job.relatedJob.trim().length > 0) {
        if (this.job.fba) {
          // job相关的初始化也放在这里面了，统一返回，避免多次访问后端
          fbaGetRelatedJob(this.job.relatedJob).then(res => this.queryTrustResultHandler(res))
        } else {
          // job相关的初始化也放在这里面了，统一返回，避免多次访问后端
          getRelatedJob(this.job.relatedJob, 0).then(res => this.queryTrustResultHandler(res))
        }
      } else {
        this.$message.info(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    async queryTrustResultHandler(event) {
      const trustJob = event.data
      if (trustJob) {
        // 显示关联业务
        this.trustFromWindow.trustJob = trustJob
        this.trustFromWindow.job = this.job
        // await this.$refs['trustFromWindow'].onShow(trustJob, true)
        this.trustFromWindow.visible = true
      } else {
        this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
      }
    },
    // 发送跨tenant
    doCrossTenantHandler() {
      this.$confirm(this.$t('Message.MakeSureToDelegateTheBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        // this.btnInfo.privilege.btnEntrustment = false
        this.sendCrossTenantHandler()
      }).catch(() => {
      })
    },
    // 发送跨tenant委托
    async sendCrossTenantHandler() {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        // 检索订舱代理所属分公司在合作伙伴中维护的tenant，是否也维护了当前tenant
        mainTainCurrentTenantCompanies(company.relateTenantId, this.job.opOffice).then(res => this.maitainTenantResult(res))
      }
    },
    async maitainTenantResult(event) {
      const cmps = event.data
      if (cmps && cmps.length > 0) {
        this.partner = cmps[0]
        // 加载联系人
        await new Company(this.partner).getContacts()
        this.loadCrossTenantContractsHandler()
      } else {
        this.$message.info(this.$t('Message.TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners'))
        // this.$refs.btnEntrustment.disabled = false
      }
    },
    loadCrossTenantContractsHandler() {
      queryLatestState(this.job.jobNo).then(res => this.stateResultHandler(res))
    },
    async stateResultHandler(event) {
      const latestState = event.data
      if (latestState === 3) {
        this.$message.info(this.$t('Message.TheOppositeSideHasScceptedNoNeedToReCommission'))
      } else {
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const carrier = await Company.getCompanyById(this.job.carrierId)
        if (carrier) {
          if (!carrier.scac) {
            // this.btnInfo.privilege.btnEntrustment = true
            this.$message.info(this.$t('Message.CheckCarrier', [carrier.chineseName]))
            return
          } else {
            getCompanyByTenantIdAndBranchIdAndScac(company.relateTenantId, company.relateTenantOfficeId, carrier.scac).then(res => this.hasCompanyResult(res))
          }
        } else {
          // 检验接收方是否维护对应的港口
          const codes = []
          if (this.job.loadingPortCode && !codes.includes(this.job.loadingPortCode)) {
            codes.push(this.job.loadingPortCode)
          }
          if (this.job.destinationPortCode && !codes.includes(this.job.destinationPortCode)) {
            codes.push(this.job.destinationPortCode)
          }
          if (this.job.dischargingPortCode && !codes.includes(this.job.dischargingPortCode)) {
            codes.push(this.job.dischargingPortCode)
          }
          isHavePorts(company.relateTenantId, codes).then(res => this.hasPortsResult(res))
        }
      }
    },
    async hasCompanyResult(event) {
      const hasCarrier = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!hasCarrier) { // bool 判断是否维护对应的船公司
        // this.btnInfo.privilege.btnEntrustment = true
        const sourceCarrier = await Company.getCompanyById(this.job.carrierId)
        let msg = this.$t('SeaExport.CheckBeforeEntrust')
        msg = msg.replace('{0}', company.chineseName)
        msg = msg.replace('{1}', sourceCarrier.chineseName)
        this.$message.info(msg)
        return
      } else {
        // 检验接收方是否维护对应的港口
        const codes = []
        if (this.job.loadingPortCode && !codes.includes(this.job.loadingPortCode)) {
          codes.push(this.job.loadingPortCode)
        }
        if (this.job.destinationPortCode && !codes.includes(this.job.destinationPortCode)) {
          codes.push(this.job.destinationPortCode)
        }
        if (this.job.dischargingPortCode && !codes.includes(this.job.dischargingPortCode)) {
          codes.push(this.job.dischargingPortCode)
        }
        isHavePorts(company.relateTenantId, codes).then(res => this.hasPortsResult(res))
      }
    },
    async hasPortsResult(event) {
      const result = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!result) {
        // 检验接收方是否维护对应的包装
        if (this.job.packing) {
          isHavePacking(company.relateTenantId, this.job.packing).then(res => this.hasPackingResult(res))
        } else {
          this.doSendCrossTenant()
        }
      } else {
        let message = ''
        for (const code of result) {
          const seaport = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', code)
          if (seaport) {
            message = message + seaport.englishName + ','
          }
        }
        if (message) {
          message = message.substring(0, message.length - 1)
        }
        // this.btnInfo.privilege.btnEntrustment = true
        let msg = this.$t('SeaExport.CheckPortBeforeEntrust')
        msg = msg.replace('{0}', company.chineseName)
        msg = msg.replace('{1}', message)
        this.$message.info(msg)
        return
      }
    },
    // 查询是否被拒绝过
    async doSendCrossTenant() {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        isRejectedBySendJobNo(this.job.jobNo, company.relateTenantId).then(res => this.isRejectResult(res))
      }
    },
    isRejectResult(event) {
      const isReject = event.data
      if (isReject) { // bool 判断是否被拒绝过
        this.$confirm(this.$t('Message.ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          // 查询pdf模板
          queryTemplateByNameAndType('BOOKING', this.$t('SeaExport.SeaExportLetter'), this.$store.getters.tenantId, this.office.officeId).then(res => this.templateSenderResultHandler(res))
        }).catch(() => {
        })
      } else {
        // 查询pdf模板
        queryTemplateByNameAndType('BOOKING', this.$t('SeaExport.SeaExportLetter'), this.$store.getters.tenantId, this.office.officeId).then(res => this.templateSenderResultHandler(res))
      }
    },
    async templateSenderResultHandler(event) {
      this.template = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!this.template) {
        this.$confirm(this.$t('Message.DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          isCrossed(this.job.jobNo, company.relateTenantId).then(res => this.isCrossedHandler(res))
        }).catch(() => {
          // this.btnInfo.privilege.btnEntrustment = true
        })
      } else {
        isCrossed(this.job.jobNo, company.relateTenantId).then(res => this.isCrossedHandler(res))
      }
    },
    isCrossedHandler(event) {
      const isCrossed = event.data
      this.enterSendCrossTenantHandler(isCrossed)
    },
    // isCrossed为false就说明没有委托过当前的订舱代理
    enterSendCrossTenantHandler(isCrossed) {
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      item.anyStr = this.job.uuid
      item.anyBool = isCrossed
      item.anyBool1 = this.commonInfo.isCopySellingCharge // isCopySellingCharge
      item.anyInteger = this.partner.cmpIdx // cmpIdx
      item.location = this.location
      crossTenantJob(item).then(res => this.saveCrossTenantCloneResultHandler(res))
      if (this.sendBranchWindow.visible) {
        this.sendBranchWindow.visible = false
      }
    },
    async saveCrossTenantCloneResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.SuccessfullySent'))
      // this.btnInfo.privilege.btnEntrustment = true
      this.uploadCloudBasedTemplate()
    },
    async uploadCloudBasedTemplate() {
      if (this.template) {
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const params = {}
        params.JOB_UUID = this.job.uuid
        params.jobuuid = this.job.uuid

        params.relatedJobUUID = this.job.relatedJobUuid
        params.relatedTenantId = company ? company.relateTenantId : ''
        params.relatedJobNo = this.job.relatedJob
        params.showPreview = true
        params.classNameType = SystemConstants.BOOKING
        params.className = 'SeaExportJob' // 后端ReportService会用到此属性
        //
        let documentType = null
        if (this.template && this.template.documentTypeUuid) {
          await getDocumentType(this.template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        const url = await PrintTemplateManager.print(this.template, documentType, PrintTemplateManager.FORMAT_PDF, params, true)
        if (url) {
          await this.loadMailURL(url, params)
        }
      }
    },
    async hasPackingResult(event) {
      const hasPacking = event.data
      if (!hasPacking) { // bool 判断是否有包装
        // this.btnInfo.privilege.btnEntrustment = true
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', this.job.packing)
        if (company && packing) {
          let msg = this.$t('SeaExport.CheckPackBeforeEntrust')
          msg = msg.replace('{0}', company.chineseName)
          msg = msg.replace('{1}', packing.name)
          this.$message.info(msg)
        }
        return
      } else {
        this.doSendCrossTenant()
      }
    },
    // 日志记录
    logHandle() {
      if (!this.job || !this.job.uuid) {
        return
      }
      switch (this.logCommand) {
        case this.$t('SeaExport.DataPushChangeLog'):
          this.toQueryDataPushLog()
          break
        case this.$t('CargoMsg.Cargo_BusinessStatusChangeLog'):
          this.businessStatusDialog.visible = true
          break
        case this.$t('SeaExport.EdiStatusChangeLog'):
          this.ediStatusLogDialog.visible = true
          break
        case this.$t('SeaExport.BookingReceiptLog'):
          this.bookingSpaceLogDialog.visible = true
          break
        case this.$t('CargoMsg.Cargo_PushResultLog'):
          if (this.toExoSystemEAS) {
            this.pushLogDialog.visible = true
            return
          }
          this.pushResultLogDialog.visible = true
          break
        case this.$t('SeaExport.ChangeHistory'):
          this.crossTenantDialog.visible = true
          this.crossTenantDialog.readState = false
          break
        case this.$t('SeaExport.OperationLog'):
          this.dataUpdateLogDialog.visible = true
          this.dataUpdateLogDialog.isNeedExpand = true
          this.dataUpdateLogDialog.defaultIsExpand = true
          LocalStorageUtilsNew.setConfiguration('SEDataUpdateLogDialogVisible', true)
          break
        case this.$t('SeaExport.JyWarehouseApiLog'):
          this.jyWarehouseApiLogDialog.visible = true
          break
        case this.$t('SystemMaintenance.MsdApiLog'):
          this.msdApiLogDialog.visible = true
          break
      }
    },
    // 数据推送日志
    async toQueryDataPushLog() {
      const loading = getLoading4Cxt(this)
      let easApiLogData = []
      try {
        if (this.toExoSystemEAS) {
          easApiLogData = await queryApiRespLog(this.job.uuid).then(res => res.data)
        }
        await new SeaExportJob(this.job).loadPushHistoryLogs()
      } finally {
        loading.close()
      }
      const dataArr = []
      const item = this.job.pushHistoryLogs
      this.dataPushDialog.titles = []
      this.dataPushDialog.dataMap = new Map()
      if (item) {
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k], 'isEas': false })
        }
      }
      if (easApiLogData && easApiLogData.length > 0) {
        for (const apiLog of easApiLogData) {
          dataArr.push({ 'time': apiLog.time, 'logs': apiLog.logs, 'isEas': true })
        }
      }
      if (dataArr && dataArr.length > 0) {
        // 排序 按时间降序
        sortByMultiField(dataArr, ['time'], true)
        for (const data of dataArr) {
          if (data.isEas) {
            this.easApiLog(data)
            continue
          }
          const logs = data.logs
          const firstLog = logs[0]
          let t = '：' + this.$t('SeaExport.DataPush')
          if (Number(firstLog.sourceType) === 1) {
            t = '：' + this.$t('SeaExport.MasterTicketSync')
          } else if (Number(firstLog.sourceType) === 2) {
            t = '：G7' + this.$t('SeaExport.DataPush')
          }
          const labTime = new Date(Number(data.time))
          const title = DateUtils.formatStandardDateTimeS(labTime) + t
          this.dataPushDialog.titles.push(title)
          const cMap = {}
          let labLog = ''
          const titleVals = []
          // 对每个推送记录进行排序，后续对箱号进行排列
          logs.sort((a, b) => {
            return b.containerNo.localeCompare(a.containerNo)
          })
          for (const h of logs) {
            if (!cMap.hasOwnProperty(h.fieldName + h.targetValue)) {
              if (!h.sourceValue || h.targetValue === h.sourceValue) {
                labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_NewValue') + '->' + h.targetValue
              } else {
                //
                const newValArr = h.targetValue ? h.targetValue.split(' ') : []
                labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_OriginalValue') + '->' + h.sourceValue + this.$t('CargoMsg.Cargo_NewValue') + '->' + (newValArr && newValArr.length > 0 ? newValArr[0] : '')
                if (newValArr && newValArr.length > 0) {
                  for (const str of newValArr) {
                    const index = newValArr.indexOf(str)
                    if (index > 0) labLog += ' ' + str
                  }
                }
              }
              // 每一行便是一个div[ labLog -> div]
              // 排列箱号，经过排序后有箱号的必定在最上面，向数组最前段添加箱号，重复的不添加
              // 格式为：['箱号1','记录1','记录1','箱号2','记录2','记录2','无箱号记录','无箱号记录']
              if (h.containerNo) {
                if (!titleVals.includes(`箱号：${h.containerNo}`)) {
                  titleVals.push(`箱号：${h.containerNo}`)
                }
              } else {
                // 当前推送有存在箱号的记录才添加空箱号标记，用于船期和箱子记录之间的margin-top css设置
                if (!titleVals.includes('箱号：containerNoNull') && h.fieldName !== '箱号') {
                  titleVals.push('箱号：containerNoNull')
                }
              }
              titleVals.push(labLog)
            }
            if (h.fieldName === '箱种' || h.fieldName === this.$t('SeaExport.ContainerSize')) {
              cMap[h.fieldName + h.targetValue] = h.fieldName + h.targetValue
            }
          }
          this.dataPushDialog.dataMap.set(title, titleVals)
        }
      }
      this.dataPushDialog.visible = true
    },
    // 加入eas传输日志
    easApiLog(data) {
      const t = '：' + this.$t('SeaExport.KingDeeChargePush')
      const labTime = new Date(Number(data.time))
      const title = DateUtils.formatStandardDateTime(labTime) + t
      this.dataPushDialog.titles.push(title)
      const titleVals = []
      const logs = data.logs
      for (const log of logs) {
        // 结算对象、费用名称、收付
        const accountId = log.ACCOUNT_ID ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(log.ACCOUNT_ID), 'chineseName') : ''
        const chargeItemId = log.CHARGEITEMID ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(log.CHARGEITEMID), 'zhName') : ''
        const accountReceivable = ColumnUtils.chargeReceivableLabelFun(log.ACCOUNT_RECEIVABLE)
        const rowOne = this.$t('SeaExport.AccountObject') + ': ' + accountId + '    ||    ' + this.$t('CargoMsg.Cargo_ChargeName') + ': ' + chargeItemId + '    ||    ' + this.$t('CargoMsg.Cargo_PayReceive') + ': ' + accountReceivable
        titleVals.push(rowOne)

        // 审核状态
        const oldState = log.EXTERNAL_CHARGE_STATE ? ColumnUtils.easChargeStateLabFun(Number(log.EXTERNAL_CHARGE_STATE)) : ''
        const newState = log.newState ? ColumnUtils.easChargeStateLabFun(Number(log.newState)) : ''
        const rowTwo = this.$t('SeaExport.AuditStatus') + ': ' + this.$t('CargoMsg.Cargo_OriginalValue') + ' -> ' + oldState + ' ' + this.$t('CargoMsg.Cargo_NewValue') + ' -> ' + newState
        titleVals.push(rowTwo)

        // 收付金额
        const oldArPaymentAmount = log.AR_PAYMENT_AMOUNT || ''
        const newArPaymentAmount = log.paymentAmount || ''
        const rowThree = this.$t('CargoMsg.Cargo_ReceiptAmount') + ': ' + this.$t('CargoMsg.Cargo_OriginalValue') + ' -> ' + oldArPaymentAmount + '        ' + this.$t('CargoMsg.Cargo_NewValue') + ' -> ' + newArPaymentAmount
        titleVals.push(rowThree)

        // 收付日期
        const oldPayReceiveDate = log.PAY_RECEIVE_DATE || ''
        const newPayReceiveDate = log.payReceiveDate || ''
        const rowFour = this.$t('CargoMsg.Cargo_ReceivedDate') + ': ' + this.$t('CargoMsg.Cargo_OriginalValue') + ' -> ' + oldPayReceiveDate + '        ' + this.$t('CargoMsg.Cargo_NewValue') + ' -> ' + newPayReceiveDate
        titleVals.push(rowFour)
      }

      this.dataPushDialog.dataMap.set(title, titleVals)
    },
    againLookAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
    },
    goBackAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
      this.goBack()
    },
    goBack() {
      /* saveJobNos去重 */
      const map = new Map()
      for (const item of this.saveJobNos) {
        const newJob = {}
        for (const key in item) {
          if (typeof item[key] === 'object') {
            continue
          }
          newJob[key] = item[key]
        }
        delete newJob.isCompleteRow
        delete newJob.version
        map.set(item.uuid, newJob)
      }
      const saveJobNos = [...map.values()]
      if (this.openMultiple) {
        const uuidSet = new Set(map.keys())
        for (const item of saveJobNos) {
          if (item.lclMasterUuid && !uuidSet.has(item.lclMasterUuid)) {
            const row = this.rowData.find(p => p.uuid === item.lclMasterUuid)
            if (row) {
              const newJob = {}
              for (const key in row) {
                if (typeof row[key] === 'object') {
                  continue
                }
                newJob[key] = row[key]
              }
              saveJobNos.push(newJob)
              uuidSet.add(newJob.uuid)
            }
          }
        }
        if (!this.isFba) {
          const removedJobNos = this.removedJobNos
          const view = { name: 'SeaBooking', path: '/SeaExport/BookingNew', query: this.$route.query, key: this.$route.query.key }
          this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
            const targetView = { name: 'SeaBooking', path: '/SeaExport/BookingNew', params: { saveJobNos, removedJobNos }}
            let isActive = false
            for (const visitedView of visitedViews) {
              if (visitedView.name === targetView.name && visitedView.fullPath === targetView.path) {
                isActive = true
                break
              }
            }
            // 判断当前海运订舱的模块是否打开，如果打开关闭其它模块就跳转到海出，若未打开，那关闭就跳转到上次打开的模块
            if (isActive) {
              this.$router.push(targetView)
            } else if (this.isActive(view)) {
              this.toLastView(visitedViews)
            }
          })
        }
      } else {
        this.visible = false
        setTimeout(() => {
          this.activeTabName = ''
          this.action = ''
          this.revertBtnGroupStyle()
          this.$store.dispatch('app/setCanCloseModule', true)
        }, 500)
      }
      this.$emit('back', saveJobNos, this.removedJobNos)
      this.closePreviewDialog()
    },
    isActive(route) {
      return matchView(route, this.$route)
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        this.$router.push('/')
      }
    },
    revertBtnGroupStyle() {
      this.btnGroupLook.style.display = this.action === 'look' ? '' : 'none'
      this.btnGroupNew.style.display = this.isNew ? '' : 'none'
      this.btnGroupEdit.style.display = this.action === 'edit' ? '' : 'none'
    },
    // 打印
    onPrint(command) {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.info(this.job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData(command) || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 整箱利润打印
    async printFCLPROFIT() {
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = true
      this.optName = '整箱利润打印'
      // 打印利润分析表后是否变更业务状态 0:不变更，1:变为已提交，2:变为预提交
      this.commonInfo.isPreCommit = Number(this.config.get('PrintProfitToPreCommit')) === 1
      // 判断是否开启验证规则
      const checkNode = CheckRuleConstants.NODE_PRINT_PROFIT.code
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
        if (hasCheckRule) {
          const callBack = async() => { this.checkPrintEnable(this.doPrintFCLPROFIT, true) }
          this.checkingManager(checkNode, callBack, null)
        } else {
          this.checkPrintEnable(this.doPrintFCLPROFIT, true)
        }
      } else {
        this.checkPrintEnable(this.doPrintFCLPROFIT, true)
      }
    },
    // 拼箱利润打印
    async printLCLPROFIT() {
      this.optName = '拼箱利润打印'
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = true
      this.commonInfo.isPreCommit = Number(this.config.get('PrintProfitToPreCommit')) === 1
      // 判断是否开启验证规则
      const checkNode = CheckRuleConstants.NODE_PRINT_PROFIT.code
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
        if (hasCheckRule) {
          const callBack = async() => { this.checkPrintEnable(this.doPrintLCLPROFIT, true) }
          this.checkingManager(checkNode, callBack, null)
        } else {
          this.checkPrintEnable(this.doPrintLCLPROFIT, true)
        }
      } else {
        const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
        if (this.commonInfo.isPreCommit && checkApChargeVerify === 1 && !await JobUtils.checkChargeStateVerify(this.job)) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
        this.checkPrintEnable(this.doPrintLCLPROFIT, true)
      }
    },
    getPrePrintFCLProfit() {
      prePrintProfit(this.job.uuid, this.office.officeId).then(res => this.prePintProfitFCLResultHandler(res))
    },
    getPrePrintLCLProfit() {
      prePrintProfit(this.job.uuid, this.office.officeId).then(res => this.prePintProfitLCLResultHandler(res))
    },
    prePintProfitLCLResultHandler(res) {
      this.prePintProfit(res, 'LCL')
    },
    prePintProfitFCLResultHandler(res) {
      this.prePintProfit(res, 'FCL')
    },
    // 利润打印【区分整箱拼箱】
    async prePintProfit(res, type) {
      await this.mergeCurrentRow(res)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, 'LCLPROFIT', params, this, null, this.preprintProfitCallBack, this.doPrintPROFIT_V2)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, 'FCLPROFIT', params, this, null, this.preprintProfitCallBack, this.doPrintPROFIT_V2)
      this.$nextTick(() => {
        const params = {}
        params.jobuuid = this.job.uuid
        params.showPreview = this.commonInfo.isPrint
        params.JOB_UUID = this.job.uuid
        console.log(type + '-prePintProfit--params--', params)
        this.templateSelectorDialog.ctx = new SeaExportJob(this.job)
        this.templateSelectorDialog.category = type === 'FCL' ? 'FCLPROFIT' : 'LCLPROFIT'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = this.prePrintProfitCallBack
        this.v2CheckCallback = this.doPrintPROFIT_V2
        this.templateSelectorDialog.visible = true
      })
      this.updateControlsState()
      this.refresh()
    },
    prePrintProfitCallBack(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPrintCommit = event.isPreCommit
      if (PrintUtils.isExecutor(event.action) && this.job && this.job.uuid) {
        this.printAlert()
      }
    },
    refChargeChargeState(charges) {
      const submitChargeState = parseInt(this.config.get('CommitJobChangedChargeState'))
      if (submitChargeState === 1 && charges && charges.length > 0) {
        for (const c of charges) {
          if (c.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
            c.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
          }
        }
      }
    },
    // 合并当前job【刷新当前job】
    async mergeCurrentRow(res) {
      if (res && res.data) {
        console.log('---------------------------', this.currentRow, res.data)
        for (const key in res.data) {
          if (typeof this.currentRow[key] === 'object') {
            continue
          }
          this.currentRow[key] = res.data[key]
        }
        const ajaxResults = []
        if (this.currentRow.masterFlag) {
          this.currentRow.lclSlaves = ''
          ajaxResults.push(new SeaExportJob(this.currentRow).getLclSlaves())
        }
        this.currentRow.charges = ''
        ajaxResults.push(new SeaExportJob(this.currentRow).getCharges())
        await Promise.all(ajaxResults)
        this.saveJobNos.push(this.currentRow)
        this.isRefresh = true
        this.currentRow.uuid = res.data.uuid
        this.isGetNewJobInfoFromDb = true
      }
    },
    // 退回操作,撤回
    async backReturn() {
      if (this.job.jobState === SystemConstants.COMMITED || this.job.jobState === SystemConstants.PRE_COMMIT) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
        let lb = this.$t('Message.Withdraw')
        if (this.job.jobState === SystemConstants.PRE_COMMIT) {
          this.commonInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
          lb = this.$t('Message.ReturnAction')
        }
        const operate = this.job.jobState === SystemConstants.PRE_COMMIT ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code
        if (!await JobUtils.backCheckJobState([this.job.uuid], operate, this.job)) {
          this.refresh()
          return
        }
        this.$confirm(this.$t('Message.IsConfirm') + lb + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          const loading = getLoading4Cxt()
          backReturn({ jobUuids: [this.job.uuid], lob: 'SE', location: this.location }).then(async res => {
            loading.close()
            if (Number(this.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
              this.commonInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
              await this.commitCBMSResultHandler(res, '1')
            } else if (Number(this.config.get('openHecConfig')) === 1) {
              this.backReturnSapResultHandler(res)
            } else {
              await this.mergeCurrentRow(res)
              this.refresh()
            }
            if (this.currentRow.masterFlag) {
              this.currentRow.lclSlaves = ''
              await new SeaExportJob(this.currentRow).getLclSlaves()
            }
            this.$message.success(this.$t('Message.AlreadyWithdraw'))
          }).finally(() => {
            loading.close()
          })

          // this.isGetNewJobInfoFromDb = true
          // this.currentRow.version = 0
          // await this.onRowClicked({ data: this.currentRow }) // 避免连续操作导致版本号不对
          // this.onConfirmedPrintReturn()
        }).catch(() => {
        })
      }
    },
    onConfirmedPrintReturn() {
      if (this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code) {
        this.loadLclSlavesHandler()
      } else {
        this.loadChargesPrintReturnHandler()
      }
    },
    async loadLclSlavesHandler() {
      await new SeaExportJob(this.job).getCharges()
      const lclSlaves = await new SeaExportJob(this.job).getLclSlaves()
      console.log('===this.job.lclSlaves==', this.job.lclSlaves)
      if (lclSlaves) {
        for (const sej of lclSlaves) {
          if (sej.jobState === SystemConstants.COMMITED || sej.jobState === SystemConstants.PRE_COMMIT) {
            await new SeaExportJob(sej).getCharges()
          }
        }
      }
      await this.loadJobsChargesPrintReturnHandler()
    },
    async loadJobsChargesPrintReturnHandler() {
      this.job.jobState = SystemConstants.OPERATING
      // 撤回置空提交时间
      this.job.submissionDate = null
      this.refChargeChargeState(this.job.charges)
      if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
        for (const sej of this.job.lclSlaves) {
          if (sej.jobState === SystemConstants.COMMITED || sej.jobState === SystemConstants.PRE_COMMIT) {
            this.refChargeChargeState(sej.charges)
          }
          sej.jobState = SystemConstants.OPERATING
          // 撤回置空提交时间
          sej.submissionDate = null
          sej.operateNameCode = this.commonInfo.operateNameCode
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      this.job.sopStateUpdate = 0
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        this.$message.success(this.$t('Message.AlreadyWithdraw'))
      })
    },
    // 提交改单费用
    changeCommit_clickHandler() {
      this.$confirm(this.$t('SeaExport.ConfirmChangeCommit'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        updateChangeState([this.job.uuid], { changeState: SystemConstants.CHANGE_COMMIT.code, location: this.location }).then(res => this.updateChangeStateHandler(res))
      }).catch(() => {
      })
    },
    updateChangeStateHandler(res) {
      this.commitResultHandler({ data: res.data[0] })
    },
    // 发送订舱数据
    sendBookingData() {
      feedbackBookingData(this.job).then(res => this.feedbackBookingDataHandler(res))
    },
    feedbackBookingDataHandler(res) {
      const result = res.data
      //  受理成功
      if (result.code === '1') {
        this.$message.success(this.$t('SeaExport.BookingDataSentSuccess'))
      } else if (result.code === '101') {
        this.$message.info(result.msg)
      } else {
        this.$message.error(this.$t('SeaExport.BookingDataSentSuccess'))
      }
    },
    // 根据对象的属性排序[descending 是否降序]
    createComparisonFunction(propertyName, descending = false) {
      return function(object1, object2) {
        const value1 = object1[propertyName]
        const value2 = object2[propertyName]

        if (!descending) {
          return value1 - value2
        } else {
          return value2 - value1
        }
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag && checkNode !== CheckRuleConstants.NODE_SAVE_BUSINESS.code) {
        const lclSlaves = await new SeaExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.job, ...lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    async addBatchLcl(lclJob, clearCustomerRefNo = false) {
      lclJob.path = ''
      console.log('addBatchLcl')
      console.log(lclJob)
      this.context.getDefaultLclSeaExportJob()
      Object.assign(lclJob, this.context.defaultLclSeaExportJob)
      await this.onShow('add', this.rowData, lclJob)
      if (clearCustomerRefNo) {
        lclJob.customerRefNo = ''
      }
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        if (this.viewJobNoSet.has(selectedRow.jobNo)) {
          this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: selectedRow.jobNo }, params: { action }})
        } else {
          this.onShow(action, this.rowData, selectedRow)
        }
      }
    },
    // 加入小票
    addSlavedJob(jobs) {
      for (const job of jobs) {
        new SeaExportJob(job).fillDefaultValue() // 数据补充完整
        job.jobUuid = job.uuid
        job.parentUuid = job.lclMasterUuid
        job.path = job.lclMasterUuid + ',' + job.uuid
        job.dataType = 2 // 小票
        job.isCompleteRow = false
        const oldIndex = this.rowData.findIndex(p => p.uuid === job.uuid)
        if (oldIndex >= 0) {
          this.rowData.splice(oldIndex, 1)
        }
      }
      this.rowData = [...this.rowData, ...jobs]
      this.saveJobNos.push(this.currentRow)
      this.saveJobNos.push(...jobs)
      for (let i = this.removedJobNos.length - 1; i >= 0; --i) {
        if (jobs.findIndex(p => p.uuid === this.removedJobNos[i].uuid) >= 0) {
          this.removedJobNos.splice(i, 1)
        }
      }
      if (this.isEditing) {
        this.currentRow.lclSlaves.push(...jobs)
      }
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    // 移除小票
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      const removedRows = this.rowData.filter(p => jobKeys.includes(p.uuid))
      /* for (const row of rows) {
        row.lclMasterUuid = ''
        row.mbl = ''
        row.parentUuid = ''
        row.path = row.uuid
        row.isCompleteRow = false
      }*/
      this.rowData = [...rows]
      this.saveJobNos.push(this.currentRow)
      this.removedJobNos.push(...removedRows)
      if (this.isEditing) {
        const lclSlaves = this.currentRow.lclSlaves
        for (let i = lclSlaves.length - 1; i >= 0; --i) {
          if (jobKeys.includes(lclSlaves[i].uuid)) {
            lclSlaves.splice(i, 1)
          }
        }
      }
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    removeJob(jobUuid) {
      const rows = this.rowData.filter(p => p.uuid !== jobUuid)
      const removedRows = this.rowData.filter(p => p.uuid === jobUuid)
      this.rowData = [...rows]
      this.saveJobNos.push(this.currentRow)
      this.removedJobNos.push(...removedRows)
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.currentRow.version = 0
      this.refresh()
    },
    splitHandle(row) {
      this.view = 'detail'
      this.onShow('split', this.rowData, row)
    },
    resetSopTooltip(event) {
      this.sopTooltipOffset = event.offsetX
    },
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    reload() {
      this.currentRow.version = 0
      this.isRefresh = true
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.currentRow)
    },
    containerLoadTypeChange() {
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.$nextTick(() => {
        this.resetActiveTabName()
        this.handleTabClick()
      })
    },
    // 发起费用解锁申请（仅校验订单状态已审核；未审核视为未锁定）
    toUnlockApply() {
      if (!this.job || !this.job.uuid) {
        return
      }
      if (this.job.jobState !== SystemConstants.VERIFIED) {
        this.$message.warning(this.$t('SeaExport.UnlockApplyJobNotLocked'))
        return
      }
      this.unlockApplyDialog.visible = true
    },
    // 解锁申请提交成功（审批期间订单保持锁定，无需刷新锁定状态；成功提示与关弹窗由弹窗组件内部完成）
    onUnlockApplySuccess() {},
    chargeLockStatusChange(lastJob) {
      this.$emit('chargeLockStatusChange', lastJob)
      if (lastJob) {
        for (const item of this.rowData) {
          if (item.uuid && item.uuid === lastJob.uuid) {
            item.receivableChargeLockedStatus = lastJob.receivableChargeLockedStatus
            item.payableChargeLockedStatus = lastJob.payableChargeLockedStatus
            item.receivableChargeLockedDate = lastJob.receivableChargeLockedDate
            item.payableChargeLockedDate = lastJob.payableChargeLockedDate
            break
          }
        }
      }
    },
    async updateJob() {
      const data = {}
      for (const key in this.paramsOfTab) {
        if (typeof this.paramsOfTab[key] === 'object') {
          continue
        }
        data[key] = this.paramsOfTab[key]
      }
      const loading = getLoading4Cxt(this)
      try {
        const res = await saveJobInfo(data)
        await this.mergeCurrentRow(res)
      } finally {
        loading.close()
      }
      this.refresh()
    },
    loadDataTrackingConfig() {
      getSubscribePortPush().then(resp => {
        const item = resp.data
        this.tabInfo.visible.dataTrackingDisplay = (item['push'] != null)
      })
    },
    loadCrossTenantSyncHistory() {
      const jobUuid = this.currentRow.uuid
      if (!jobUuid) {
        return
      }
      queryCrossTenantSyncHistory({ jobKey: jobUuid }).then(res => {
        this.crossTenantDialog.readState = false
        // 判断已读状态
        if (res.data && res.data.length > 0) {
          for (const data of res.data) {
            if (data.receiveJobUuid === jobUuid && !data.readState) {
              this.crossTenantDialog.readState = true
              break
            }
          }
        }
        this.crossTenantDialog.data = res.data
      })
    },
    async continueSaving(body, loading, closingLoading = false) {
      try {
        if (closingLoading) {
          loading = getLoading4Cxt(this)
        }
        // 保存 访问数据库
        // 拆分主票 保存处理逻辑【也走这里】
        body.action = this.action
        if (body && body.job && body.job.masterFlag && body.job.containerLoadType !== 'BCF') {
          body.job.paymentTermHBL = ''
          body.job.freightTermHBL = ''
        }
        if (!this.isFba) {
          body.location = this.location
        }
        body.receiptCharges = this.context.receiptCharges
        // 需要针对一些特殊字段解码
        body.needDeCodeSpecialFiled = true
        let blockCreditData = null
        let savedJobUuid = ''
        const encodedBody = lodash.cloneDeep(body) // 加这个的目的是防止前端UI闪烁 在那么1秒钟内会展示密文
        JobUtils.encodeSpecialField(encodedBody)
        await this.saveSeaBookingSpaceFunc(encodedBody).then(res => {
          const result = res.data.job
          if (result) {
            savedJobUuid = result.uuid
            Object.assign(this.currentRow, result)
            // this.currentRow.version = 0
            this.currentRow.blocked = result.blocked
            this.currentRow.jobUuid = result.uuid
            this.currentRow.dataType = result.masterFlag ? 1 : 2 // 1、主票 1、小票
            if (this.currentRow.lclMasterUuid) {
              if (this.openMultiple && !this.rowData.some(p => p.uuid === this.currentRow.lclMasterUuid)) {
                this.currentRow.path = result.uuid
              } else {
                this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
              }
            } else {
              this.currentRow.path = result.uuid
            }
            this.isRefresh = true
            this.saveJobNos.push(this.currentRow)
          }
          this.updateCargoDocNo(body.seaCargoDoc)
          // 重置子表数据【将job相关信息置空，然后从库里重新加载】
          for (const key in this.currentRow) {
            if (typeof this.currentRow[key] === 'object') {
              this.currentRow[key] = ''
            }
          }
          this.currentRow.isCompleteRow = false
          const lclSlaves = body.lclSlaves // 先将拆分主票对应的小票记录，保存后使用
          if (this.action === 'split' && lclSlaves && lclSlaves.length > 0) {
            if (!this.currentRow.beSplitedLclUuids) {
              this.currentRow.beSplitedLclUuids = Array.from(lclSlaves, p => p.uuid)
            }
            // 原被拆分的主票uuid集合
            const oldMasterUuidSet = new Set()
            // 更新小票
            const rows = this.rowData.filter(p => this.currentRow.beSplitedLclUuids.includes(p.uuid))
            for (const lcl of rows) {
              oldMasterUuidSet.add(lcl.lclMasterUuid)
              lcl.isCompleteRow = false
              lcl.parentUuid = this.currentRow.uuid
              lcl.lclMasterUuid = this.currentRow.uuid
              lcl.path = this.currentRow.uuid + ',' + lcl.uuid
              lcl.version = 0 // 标识为脏数据，需要重新载入
            }
            this.gridApi.setRowData(this.rowData)
            // 原被拆分的主票，需重新加载
            const oldMasterJobs = this.rowData.filter(p => oldMasterUuidSet.has(p.uuid))
            for (const item of oldMasterJobs) {
              item.isCompleteRow = false
              item.version = 0 // 标识为脏数据，需要重新载入
              // 重置子表数据
              for (const key in item) {
                if (typeof item[key] === 'object') {
                  item[key] = ''
                }
              }
            }
          }
          blockCreditData = res.data.blockCreditData
        })
        void triggerReleaseRuleEngineAfterSave(executeRuleEngine, savedJobUuid)
        // console.log('this.rowData===', this.rowData)
        // 复制多份业务 保存的处理逻辑
        if (this.copyJobNum > 1 && this.currentRow.uuid) {
          await this.saveCopyJobHandle(this.currentRow.uuid, this.currentRow.masterFlag, this.copyJobNum - 1, this.currentRow.danUNNo)
        }

        // 主票页签新增多个小票，保存的处理逻辑
        if (this.currentRow.lclNumber && this.currentRow.uuid) {
          const job = this.currentRow
          // 更新新增的第一条小票数据
          // await new SeaExportJob(job).loadJobRelated({ job: true })
          job.jobUuid = job.uuid
          job.parentUuid = job.lclMasterUuid
          job.path = job.lclMasterUuid + ',' + job.uuid
          job.dataType = 2 // 小票
          if (job.lclNumber > 1) {
            await this.saveLclJob(job.uuid, job.lclNumber - 1)
          } else {
            this.rowData = [...this.rowData.filter(jb => jb.uuid !== job.uuid), { ...job, lclNumber: null }]
          }
          delete job.lclNumber
          // 切换回主票
          this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
          this.currentRow.version = 0
          // 重置子表数据【将job相关信息置空，然后从库里重新加载】
          for (const key in this.currentRow) {
            if (typeof this.currentRow[key] === 'object') {
              this.currentRow[key] = ''
            }
          }
        }
        // 保存成功后各业签执行的回调方法
        for (const item of this.pendTabSet) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            /* 保存成功后的回调 */
            const result = this.$refs[item].executeTask()
            if (result instanceof Promise) {
              await result
            }
          }
        }
        const vesselVoyage = this.vesselAndVoyage.split('_')
        const changeVessel = vesselVoyage[0] !== this.job.vessel || vesselVoyage[1] !== this.job.voyageFlight
        await this.updateBillInfo(changeVessel)
        if (this.config.get('OpenXHQDocumentCenter') !== '0' && changeVessel && this.job.masterFlag) {
          this.toXhqUpdateLclBillInfo()
        }
        if (this.job.warehouseNo && this.job.warehouseNo_original !== this.job.warehouseNo) {
          autoAllocateCargo(this.job.uuid).then(async res => {
            if (this.$refs.tabWarehouse && res.data && res.data.length > 0) {
              await this.$refs.tabWarehouse.loadWarehouseIn()
            }
          })
        }
        this.isGetNewJobInfoFromDb = true
        if (this.openMultiple) {
          if (this.currentRow.jobNo !== this.$route.query.key) {
            const rowData = deepCopy(this.rowData)
            this.reset(rowData)
            this.$message.success(this.$t('Message.SaveSuccessfully'))
            this.$router.push({ name: this.isFba ? 'FBABookingNew' : 'SeaBooking', query: { openNew: true, key: this.currentRow.jobNo }, params: { rowData, replace: true }})
            return
          }
          await this.againShow('look', this.currentRow)
        } else {
          await this.againShow('look', this.currentRow)
          if (JobUtils.isBlockJob(this.currentRow)) {
            // 保存成功之后如果是信控锁住则会弹此提示【Job.as 中的 save方法】
            setTimeout(() => {
              this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
            }, 2000)
          }
        }
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        /*        if (this.currentRow.jobState === 0 && businessDate !== oldBusinessDate && ChargeUtils.ChargeUtils.exchangeRateNeedUpdate(charges, businessDate)) {
          setTimeout(() => {
            this.$message.success(this.$t('queryJob.BusinessDateChangedUpdateExchangeRate'))
          }, 100)
        }*/
        this.copyJobNum = 0

        // 保存业务触发SOP后需要刷新 SOP操作状态弹框
        if (this.sopStateDialog.visible) {
          setTimeout(() => {
            this.sopStateDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存业务后需要刷新 变更日志记录弹框
        if (this.dataUpdateLogDialog.visible) {
          setTimeout(() => {
            this.dataUpdateLogDialog.isNeedRefresh = true
          }, 3000)
        }
        JobUtils.handleCreditRemind(this.currentRow, blockCreditData)
      } catch (err) {
        throw err
      } finally {
        if (closingLoading) {
          loading.close()
        }
      }
    },
    async saveSeaBookingSpaceFunc(body) {
      // 数据已被其他人修改
      let dataModified = false
      let userName = ''
      let modifyDate = ''
      let err = null
      try {
        return await saveSeaBookingSpace(body, true, true)
      } catch (res) {
        let error17 = null
        if (res.errors) {
          error17 = res.errors.find(p => p.code === '0017')
        }
        if (error17) {
          dataModified = true
          const start = error17.message.indexOf('[')
          if (start > -1) {
            const end = error17.message.indexOf(']', start)
            if (end > -1) {
              userName = error17.message.substring(start + 1, end)
            }
          }
          const match = error17.message.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}/)
          modifyDate = match[0] || ''
          err = res
        } else {
          this.$message({
            showClose: true,
            message: res.errorMsg,
            dangerouslyUseHTMLString: res.errorMsg && res.errorMsg.indexOf('<br/>') > -1,
            type: 'error',
            duration: 5 * 1000
          })
          throw res
        }
      }
      if (dataModified) {
        // 是否一票多报关
        const sEMultiSoMode = this.config ? Number(this.config.get('SEMultiSoMode')) || 0 : 0
        // 是否主票
        const masterFlag = this.currentRow ? this.currentRow.masterFlag || false : false
        // 开启”一票多报关“参数，且编辑主票的时候，如果有数据冲突，则提示：”数据已被XXX修改，请刷新“
        if (sEMultiSoMode === 1 && masterFlag) {
          this.$message.error(this.$t('CargoMsg.DataHasModified', [userName, modifyDate]))
          return
        }
        const oldData = lodash.cloneDeep(this.currentRow) // 旧版本的数据
        const editOldData = lodash.cloneDeep(this.paramsOfTab) // 正在编辑的旧版本的数据
        const pendTabs = [...this.pendTabSet]
        const modifiedData = { ...this.context.modifiedData }
        this.currentRow.version = 0
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        await this.onRowClicked({ data: this.currentRow, skipTabHandle: true })
        if (pendTabs.includes('tabTradeDetail')) {
          await new SeaExportJob(this.currentRow).getPoItems()
        }
        if (pendTabs.includes('tabTradeCommission')) {
          await new SeaExportJob(this.currentRow).getPoList()
        }
        if (pendTabs.includes('tabUsCustomsClearance')) {
          await this.$refs['tabUsCustomsClearance'].onShow(this.paramsOfTab, true)
        }
        if (pendTabs.includes('tabUsCustomsClearanceMaster')) {
          await this.$refs['tabUsCustomsClearanceMaster'].onShow(this.paramsOfTab, true)
        }
        if (pendTabs.includes('tabVGM')) {
          await this.$refs['tabVGM'].onShow(this.paramsOfTab, true)
        }
        const newData = this.currentRow // 最新版本的数据
        this.paramsOfTab = JobUtils.compareAndMergeJobData(oldData, editOldData, newData)
        this.pendTabSet.clear()
        for (const pendTab of pendTabs) {
          this.pendTabSet.add(pendTab)
          if (pendTab === 'tabCharges') {
            this.showBasicInfoWindow()
          }
          const loading = getLoading4Cxt(pendTab === 'tabVesselEq' ? this : this.$refs[pendTab])
          this.$refs[pendTab].onShow(this.paramsOfTab, true, this.pendTabSet.size).finally(() => {
            setTimeout(() => {
              loading.close()
            }, 500)
          })
        }
        const filedMap = new Map([['dischargingTruckingInfo', 'dischargingTrucking'], ['truckingInfo', 'trucking']])
        for (const key in modifiedData) {
          const sourceKey = filedMap.get(key) || key
          if (modifiedData[key] instanceof Array && this.paramsOfTab[sourceKey] instanceof Array) {
            const targetArray = modifiedData[key]
            const souceArray = this.paramsOfTab[sourceKey]
            for (let i = 0; i < targetArray.length; ++i) {
              const sourceItem = souceArray.find(p => p === targetArray[i] || (p.uuid && p.uuid === targetArray[i].uuid))
              if (sourceItem) {
                targetArray[i] = sourceItem
              }
            }
            this.context.modifiedData[key] = modifiedData[key]
          }
        }
        const flag = await this.$confirm(this.$t('queryJob.DataModifiedHasMergeContinueSave', [userName, modifyDate]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (flag) {
          const newBody = {}
          if (body.job) {
            newBody.job = { ...this.paramsOfTab }
            // 还原接单分公司
            if (this.useOrderCenterMode) {
              if (newBody.job.cooperate && newBody.job.cooperate.uuid) {
                newBody.job.opOffice = newBody.job.opOffice_original || newBody.job.opOffice // 分公司
                newBody.job.op = newBody.job.op_original || newBody.job.op // 操作
                newBody.job.csr = newBody.job.csr_original || newBody.job.csr // 客服
                newBody.job.overseaOp = newBody.job.overseaOp_original || newBody.job.overseaOp // 海外操作
                newBody.job.dc = newBody.job.dc_original || newBody.job.dc // 单证
                newBody.job.planner = newBody.job.planner_original || newBody.job.planner // 航线负责人
                newBody.job.opDepartment = newBody.job.opDepartment_original || newBody.job.opDepartment // 操作部门
                JobUtils.restoreJobFromCooperateInfo(newBody.job)
              }
            }
            for (const key in newBody.job) {
              if (newBody.job[key] instanceof Object) {
                newBody.job[key] = ''
              }
            }
          }
          for (const key in body) {
            if (key === 'job') {
              continue
            }
            const sourceKey = filedMap.get(key) || key
            if (body[key] instanceof Array) {
              if (this.paramsOfTab[sourceKey] instanceof Array) {
                const uuids = []
                newBody[key] = []
                for (const bodyItem of body[key]) {
                  if (bodyItem.uuid) {
                    uuids.push(bodyItem.uuid)
                  } else {
                    newBody[key].push(bodyItem)
                  }
                }
                for (const mergeItem of this.paramsOfTab[sourceKey]) {
                  if (uuids.includes(mergeItem.uuid)) {
                    newBody[key].push(mergeItem)
                  }
                }
              } else {
                newBody[key] = body[key]
              }
            } else if (body[key] instanceof Object) {
              newBody[key] = this.paramsOfTab[sourceKey] || body[key]
            } else {
              newBody[key] = body[key]
            }
          }
          cleanCircleObject(newBody)
          newBody.needDeCodeSpecialFiled = true
          if (!this.isFba) {
            newBody.location = this.location
          }
          const encodedBody = lodash.cloneDeep(newBody) // 加这个的目的是防止前端UI闪烁 在那么1秒钟内会展示密文
          JobUtils.encodeSpecialField(encodedBody)
          return await saveSeaBookingSpace(encodedBody, true)
        } else {
          throw err
        }
      }
    },
    // 查看关联进口业务信息
    queryRelatedSiFrom() {
      if (this.job.relatedJob.trim().length > 0) {
        getRelatedSiJob(this.job.relatedJob, 0).then(res => {
          if (res.data) {
            this.relatedSiFromWindow.relatedJob = res.data
            this.relatedSiFromWindow.visible = true
          } else {
            this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
          }
        })
      } else {
        this.$message.info(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    // 同步信息-出口同步到进口【租户内】
    async syncRelatedJob() {
      if (this.job.relatedJob && this.job.relatedJob.trim().length > 0) {
        this.loading = getLoading4Cxt()
        const company = await Company.getCompanyById(this.job.destinationAgent)
        const anyBool = (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.job.opOffice) // 内部委托
        const anyBool1 = (company && company.relateTenantId > 0 && company.overseaAgent) // 跨租户委托
        syncRelatedJob({ anyStr: this.job.uuid, anyStr1: this.job.relatedJob, anyBool: anyBool, anyBool1: anyBool1, location: this.location, branchId: this.$store.getters.currentOfficeId }).then(res => {
          this.$message.success(this.$t('Message.SynchronizationSucceeded'))
          this.btnInfo.btnEntrustmentSISynchronized = true
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.$message.info(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    // 协作
    cooperationHandler() {
      this.cooperationBranchListDialog.jobUuid = this.job.uuid
      this.cooperationBranchListDialog.job = this.job
      this.cooperationBranchListDialog.orderCenterBranch = this.orderCenterBranch
      this.cooperationBranchListDialog.visible = true
    },
    // 退回
    cooperationReturnHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureReturn'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toCooperationReturn()
      }).catch(() => {
        //
      })
    },
    toCooperationReturn() {
      const loading = getLoading4Cxt(this)
      updateState({ jobUuid: this.job.uuid, branchId: this.$store.getters.currentOffice.officeId, statusType: SystemConstants.STATUSTYPE_COOPERATE.code, status: SystemConstants.COOPERATE_STATUS_RETURNED.code }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReturnedSuccess'))
      }).finally(() => {
        loading.close()
      })
    },
    prePlanBookingToVgm(manifestInfo) {
      // 判断是否已经勾选vgm, 是则弹窗询问是否跳转。
      if (this.job.vgm) {
        this.$confirm(this.$t('CargoMsg.Cargo_WhetherToContinueSendingVGM'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        }).then(() => {
          // 进行数据同步
          syncManifestInfoToVgm(manifestInfo).then(res => {
            this.job.vgmChannel = manifestInfo && manifestInfo.sendChannel ? manifestInfo.sendChannel : 1
            this.activeTabName = 'tabVGM'
            // 同步海管家发送状态
            this.job.manifestInfos = ''
            this.handleTabClick()
          })
        }).catch(() => {
        })
      }
    },
    onVerticalScroll(offset) {
      const tabsContent = this.$refs.tabsContainer.querySelector('.el-tabs__content')
      tabsContent.scrollTop = tabsContent.scrollTop + offset
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', result.dischargingPortCode, 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    // 审批发起回调
    applyCloseAndRefresh() {
      this.jobApplyDialog.visible = false
      this.currentRow.version = 0
      this.refresh()
    },
    closePreviewDialog() {
      this.previewFileData.pdfUrl = ''
      this.previewFileData.pdfSrc = ''
      this.previewFileData.numPages = ''
      this.previewFileData.photoList = []
      this.previewFileData.officeFileUrl = ''
      this.previewFileData.showViewBtn = false
      this.previewFileData.visible = false
    },
    previewFileMethod({ visible, pdfUrl, pdfSrc, numPages, photoList, officeFileUrl }) {
      if (visible) {
        this.previewFileData.pdfUrl = pdfUrl
        this.previewFileData.pdfSrc = pdfSrc
        this.previewFileData.numPages = numPages
        this.previewFileData.photoList = photoList
        this.previewFileData.officeFileUrl = officeFileUrl
        this.previewFileData.visible = true
      } else {
        this.closePreviewDialog()
      }
    },
    onPreviewFileDailogMin() {
      this.previewFileData.visible = false
      this.previewFileData.showViewBtn = true
    },
    async toViewFile() {
      if (this.previewFileData.pdfUrl) {
        this.previewFileData.pdfSrc = pdf.createLoadingTask(encodeURI(this.previewFileData.pdfUrl))
        await this.previewFileData.pdfSrc.promise.then(pdf => {
          this.previewFileData.numPages = pdf.numPages
        }).catch((err) => {
          console.log(this.$t('Message.FailedToGetTemplate'), err)
        })
      }
      this.previewFileData.visible = true
      this.previewFileData.showViewBtn = false
    },
    async updateBillInfo(changeVessel) {
      if (!(this.config.get('OpenXHQDocumentCenter') !== '0' && this.job.signHBL)) { // 开了参数，且勾了HBL页签的才发送
        return
      }
      let phone = ''
      let userId = 0
      // 推送信号旗单证中心的联系人岗位 0=操作，1=客服，2=单证
      if (Number(this.config.get('PICtoXHQDocumentCenter')) === 1) {
        if (!(this.job.csr > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.CustomerService')]))
          return
        }
        userId = this.job.csr
      } else if (Number(this.config.get('PICtoXHQDocumentCenter')) === 2) {
        if (!(this.job.dc > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.Documents')]))
          return
        }
        userId = this.job.dc
      } else {
        if (!(this.job.op > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.Operation')]))
          return
        }
        userId = this.job.op
      }
      const contact = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', userId)
      if (!contact) {
        return
      }
      if (contact) {
        phone = contact.cell
        if (!phone) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel'))
          return
        }
      }
      if (!(this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code || this.job.typeHBL === BillType.MERGE_BILL_TYPE.code)) { // 普通HBL情况下,不等于拆单或并单的情况下
        const hblDoc = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.HBL, false)
        if (hblDoc && (!hblDoc.confirmationBillState || hblDoc.confirmationBillState === CFM_BILL_STATE_NEW.code || changeVessel)) { // hbl初创时没有confirmationBillState，或者创建过，没发送过的
          this.loading = getLoading()
          try {
            const result = await this.toXhqUpdateBillInfo(hblDoc.hblNbr2)
            if (result) {
              this.$message.warning(result)
            } else {
              this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
              hblDoc.confirmationBillState = CFM_BILL_STATE_UPDATE.code
            }
          } finally {
            this.loading.close()
          }
        }
      } else { // 拆并单的情况下
        const cargoDocs = await new SeaExportJob(this.job).getCargoDoc()
        this.loading = getLoading()
        const resultList = []
        try {
          for (const doc of cargoDocs) {
            if (doc.docType === CargoDocConsts.HBL2 && (!doc.confirmationBillState || doc.confirmationBillState === CFM_BILL_STATE_NEW.code || changeVessel)) { // 已经发过了的，或者不是拆并单的cargoDoc,不发送
              const result = await this.toXhqUpdateBillInfo(doc.uuid)
              resultList.push(result)
            }
          }
          if (resultList && resultList.length > 0) {
            if (resultList[0]) {
              this.$message.warning(resultList[0])
            } else {
              this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
              for (const doc of cargoDocs) {
                doc.confirmationBillState = CFM_BILL_STATE_UPDATE.code
              }
            }
          }
        } finally {
          this.loading.close()
        }
      }
    },
    async toXhqUpdateBillInfo(docUuid) {
      const params = {
        jobUuid: this.job.uuid,
        docUuid: docUuid,
        release: false, // 表示是否放单，电放放单和提单确认是同一个接口，以此区分，true为电放放单，false为提单确认
        ifSystemSend: true // 表示保存时自动触发的发送
      }
      let result = ''
      await xhqUpdateBillInfo(params).then(res => {
        result = res.data
      })
      return result
    },
    // 主票下小票 提单数据更新
    async toXhqUpdateLclBillInfo() {
      const params = {
        masterJobKey: this.job.uuid,
        release: false, // 表示是否放单，电放放单和提单确认是同一个接口，以此区分，true为电放放单，false为提单确认
        ifSystemSend: true // 表示保存时自动触发的发送
      }
      let result = ''
      await toXhqUpdateLclBillInfo(params).then(res => {
        result = res.data
      })
      return result
    },
    writebackJob(data) {
      for (const key in data) {
        this.currentRow[key] = data[key]
      }
    },
    onCheckConsigneeDefaultChange() {
      LocalStorageUtilsNew.setConfiguration('SE_checkConsigneeDefault', this.sendBranchWindow.checkConsigneeDefault)
      if (this.sendBranchWindow.checkConsigneeDefault) {
        this.onConsigneeTargetChange()
        this.onConsigneeDetailTargetChange()
      } else {
        LocalStorageUtilsNew.removeConfiguration('SE_consigneeTargett')
        LocalStorageUtilsNew.removeConfiguration('SE_consigneeDetailTarget')
      }
    },
    onConsigneeTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('SE_consigneeTargett', this.sendBranchWindow.consigneeTarget)
      }
    },
    onConsigneeDetailTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('SE_consigneeDetailTarget', this.sendBranchWindow.consigneeDetailTarget)
      }
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    changeDataSFTFunc(e) {
      this.changeDataSFT = e
    },
    updateJobCooperate(cooperatebranch) {
      this.currentRow.cooperatebranch = cooperatebranch ? cooperatebranch.split(',').join(' | ') : ''
    },
    showMscSupplementHandler(value) {
      this.showMscSupplement = value
    },
    onJobChangeState(data) {
      this.disabledChangeJob = data.disabledChangeJob
      this.jobChangeDisabledTip = data.jobChangeDisabledTip
    },
    // 显示壹沓回执结果
    showYdBookingResultHandler(viewSource) {
      // RPA、订舱确认
      if (this.action !== 'look' || !this.job.uuid || !(this.job.bookingState === SystemConstants.JOB_BOOKING_STATE_BOOKING_RECEIVED.code || this.job.bookingState === SystemConstants.JOB_BOOKING_STATE_BOOKING_CONFIRM.code)) {
        return
      }
      // 判断当前用户是否已忽略
      if (viewSource === 'tabBookingFCL') {
        const ignore = LocalStorageUtils.getConfiguration('ignoreYdBookingResult_' + this.job.uuid) || 0
        if (ignore === 1) {
          return
        }
      }
      this.ydBookingResultDialog.visible = false
      this.ydBookingResultDialog.jobUuid = this.job.uuid
      this.ydBookingResultDialog.job = this.job
      // 订舱页签、基本页签
      if (viewSource === 'tabVesselEq' || (viewSource === 'tabBookingFCL' && !this.job.ydBookingResult)) {
        this.loading = getLoading4Cxt()
        queryYDBookingResultsAndJob({ jobUuid: this.job.uuid }).then(res => {
          this.job.ydBookingResult = res.data
          if (viewSource === 'tabBookingFCL' && (!res.data || res.data.confirmReplaceDate || res.data.notReplaceDate)) {
            return
          }
          this.ydBookingResultDialog.bookingResult = this.job.ydBookingResult
          if (this.ydBookingResultDialog.bookingResult && this.ydBookingResultDialog.bookingResult.diffJobList && this.ydBookingResultDialog.bookingResult.diffJobList.length > 0) {
            this.ydBookingResultDialog.visible = true
          } else {
            if (viewSource === 'tabVesselEq') {
              this.$message.warning(this.$t('CargoMsg.Cargo_NonReplaceDataTip'))
            }
          }
        }).finally(() => {
          this.loading.close()
        })
      } else if (viewSource === 'tabBookingFCL' && this.job.ydBookingResult) {
        // 确认覆盖/都不覆盖
        if (this.job.ydBookingResult.confirmReplaceDate || this.job.ydBookingResult.notReplaceDate) {
          return
        }
        this.ydBookingResultDialog.bookingResult = this.job.ydBookingResult
        if (this.ydBookingResultDialog.bookingResult && this.ydBookingResultDialog.bookingResult.diffJobList && this.ydBookingResultDialog.bookingResult.diffJobList.length > 0) {
          this.ydBookingResultDialog.visible = true
        }
      }
    },
    closeYdBookingDialog() {
      // 记录忽略，不在提醒
      LocalStorageUtils.setConfiguration('ignoreYdBookingResult_' + this.job.uuid, 1)
      this.ydBookingResultDialog.visible = false
    },
    refreshChargeTabCooperatebranch(cooperatebranch) {
      if (this.$refs.tabCharges) {
        this.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)
      }
      if (this.$refs.tabChargesAr) {
        this.$refs.tabChargesAr.refreshCooperatebranch(cooperatebranch)
      }
      if (this.$refs.tabChargesAp) {
        this.$refs.tabChargesAp.refreshCooperatebranch(cooperatebranch)
      }
    },
    onInstructioinCommand(tenantInstructionUuid) {
      const item = this.instructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
      if (item) {
        if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code) {
          this.$refs.customFormWindow.onShowOfUI(item, this.currentRow)
        }
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionBtns()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code) {
        this.reload()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.right-tip{
  width: 100%;
  cursor: pointer;
  display:flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  white-space: nowrap;
  span{
    &:first-of-type{
      margin: 0 10px 0 5px;
    }
  }
}
.details-view{
  .set-style{
    font-weight: 700;
    color:#666666;
  }
  .set-mgTop{
    margin-top:20px;
  }
}

.preview-img{
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
    width: auto;
    max-width: 100%;
    min-width: 120px;
    min-height: 120px;
    height: auto;
  }
}
.pdf-img{
  height: 450px;
  .el-scrollbar{
    height: 450px;
    /deep/ .el-scrollbar__wrap{
      overflow-x: hidden;
    }
    /deep/ .el-scrollbar__bar{
        opacity: 1;
    }
  }
}
.office-preview {
  width: 100%;
  height: 100%;
  min-height: 600px;
  border: none;
}
.details-view ::v-deep {
  .preview-dialog.is-fullscreen {
    height: 100%;
    .el-dialog__body {
      height: 100%;
      .pdf-img{
        height: 100%;
        .el-scrollbar{
          height: 100%;
        }
      }
    }
  }
}
.details-view {
  .btn-group-look.cannot-operate-job::v-deep,
  .tabs-container.cannot-operate-job::v-deep {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
    .el-upload {
      pointer-events: none;
    }
  }
  .btn-group-look.cannot-operate-job::v-deep {
    .el-dropdown.can-operate {
      .el-button {
        &.el-button--primary {
          pointer-events: auto;
          background-color: #1F75D5;
          border-color: #1F75D5;
          &:focus, &:hover {
            background: #4c91dd;
            border-color: #4c91dd;
          }
        }
      }
    }
  }
  .tabs-container.cannot-operate-job::v-deep {
    .el-dropdown {
      pointer-events: none;
    }
  }
}
</style>
